/* ============================================================
   KAMUS — BAHASA MELAYU (kamus INDUK + kamus SANDARAN)
   ============================================================
   Fail ini BUKAN lagi bahasa lalai. Sejak 2026-08-16 lalai
   pelanggan ialah English (lihat BAHASA_LALAI dalam index.js).
   Ia kekal sebagai INDUK kerana setiap ayat produk lahir dalam
   Bahasa Melayu dahulu sebelum diterjemah — jadi inilah kamus
   yang dijamin lengkap, dan itulah sebabnya BAHASA_SANDARAN
   menunjuk ke sini.

   Setiap kunci di sini WAJIB ada pasangannya dalam en.js.
   Kunci yang hilang dalam en.js tidak memecahkan halaman — ia
   jatuh balik ke ayat Melayu di sini — tetapi sejak English
   menjadi lalai, kunci tertinggal bermakna MAJORITI pelanggan
   nampak ayat Melayu terselit di tengah halaman English.
   Anggap ia pepijat.

   Gaya ayat (arahan user, kekal):
     • BM FORMAL untuk pelanggan — "anda", "daripada", bukan
       "korang"/"dari". Formal tetapi mudah difahami, bukan
       gaya buku teks.
     • Terma dalam TERMA_JANGAN_TERJEMAH (index.js) kekal SAMA
       dalam kedua-dua bahasa — termasuk nama produk seperti
       Flow, TikTok, dan nama modul. Ia memang muncul di tengah
       ayat Melayu; itu betul, bukan terlupa diterjemah.
     • Tiada emoji dalam ayat UI v3.9 (peraturan monokrom).
   ============================================================ */

export default {
    'fc.menu': "Buka menu",
    'fc.subtitle': "Urus akses dan langganan Google Flow anda.",
    'fc.loading': "Memuatkan…",
    'fc.active': "Langganan aktif",
    'fc.pilot': "Akses ujian dibenarkan",
    'fc.inactive': "Akses belum tersedia",
    'fc.expiry': "Tarikh tamat",
    'fc.renew': "Langgan / Renew",
    'fc.accessNote': "Open Flow memerlukan extension SESAAT yang telah login serta akses yang dibenarkan.",
    'fc.st.ready': "Sedia untuk digunakan.",
    'fc.st.sourceDown': "Akses Flow terputus sementara. Sambungan sedang dipulihkan oleh admin — sila tunggu sebentar. Tidak perlu tekan Open Flow berulang kali.",
    'fc.st.preparing': "Akses anda sedang disediakan oleh admin.",
    'fc.st.disabled': "Akses ditutup sementara.",
    'fc.st.maintenance': "Penyelenggaraan sebentar. Sila cuba semula tidak lama lagi.",
    'fc.st.busy': "Sistem sibuk sekejap. Sila cuba semula sebentar lagi.",
    'fc.st.expired': "Langganan Flow anda telah tamat.",
    'fc.st.noAccess': "Anda belum mempunyai akses Flow.",
    'fc.st.creditLimit': "Had credit anda telah dicapai. Penjanaan dihentikan. Sila hubungi admin untuk menyambung penggunaan.",
    'fc.preparing': "Preparing Flow…",
    'fc.opened': "Flow telah dibuka dalam tab baharu.",
    'fc.loadError': "Status tidak dapat dimuatkan. Cuba Semak semula dalam Settings & Help.",
    'fc.timeout': "Extension tidak membalas. Reload extension SESAAT dan halaman ini.",
    'fc.login': "Sila login ke extension menggunakan akaun SESAAT yang sama.",
    'fc.noAccess': "Akses Flow terhidup automatik selepas bayaran anda disahkan.",
    'fc.busy': "Proses Flow lain sedang berjalan. Cuba semula selepas selesai.",
    'fc.openError': "Flow tidak dapat dibuka. Semak login extension atau hubungi admin.",
    'fc.sections': "Bahagian Flow",
    'fc.overview': "Projek Saya",
    'fc.billing': "Subscription & Billing",
    'fc.settings': "Settings & Help",
    'fc.readyTitle': "Buka Flow dalam satu klik",
    'fc.instructions': "Pasang extension SESAAT, log masuk akaun yang sama, kemudian tekan Open Flow.",
    'fc.billingNote': "Lihat pakej, harga dan syarat semasa di halaman bayaran Flow Ultra.",
    'fc.viewPlan': "Lihat pakej dan bayaran",
    'fc.history': "Sejarah bayaran",
    'fc.historyNote': "Memaparkan sehingga 50 rekod yang dipautkan kepada akaun SESAAT ini. Bayaran melalui emel lain mungkin tidak dipaparkan.",
    'fc.date': "Tarikh",
    'fc.amount': "Jumlah",
    'fc.status': "Status",
    'fc.paid': "Dibayar",
    'fc.unpaid': "Belum dibayar",
    'fc.paidManual': "Dibayar (direkodkan oleh admin)",
    'fc.granted': "Diberikan oleh admin",
    'fc.noPayments': "Tiada rekod bayaran dipaparkan.",
    'fc.yourPlans': "Langganan anda",
    'fc.type': "Jenis",
    'fc.type1': "Lite (Gmail dikongsi)",
    'fc.type2': "Gmail sendiri + credit",
    'fc.planType1': "Flow Ultra — Lite",
    'fc.planType2': "Flow Ultra — Credit",
    'fc.started': "Tarikh mula",
    'fc.daysLeft': "hari lagi",
    'fc.price': "Harga",
    'fc.credits': "Credit digunakan",
    'fc.subActive': "Aktif",
    'fc.subExpiring': "Akan tamat",
    'fc.subExpired': "Tamat",
    'fc.help': "Gunakan Chrome biasa dengan extension SESAAT. Jika gagal, reload extension dan halaman ini, kemudian cuba semula.",
    'fc.install': "Panduan extension",
    'fc.refresh': "Semak semula",
    'fc.rf.button': "Refresh session",
    'fc.rf.dead': "Session Flow anda telah tamat. Tekan Refresh session untuk mendapatkan session baharu.",
    'fc.rf.refreshing': "Sedang menyediakan session baharu. Biasanya kurang 1 minit. Biarkan halaman ini terbuka.",
    'fc.rf.ready': "Session baharu sudah sedia. Tekan Open Flow sekarang.",
    'fc.rf.browserReject': "Session sudah dihantar, tetapi browser anda belum dapat membukanya. Cuba tutup tab Flow lama dan tekan Refresh session semula.",
    'fc.rf.maintenance': "Flow sedang diselenggara. Pasukan kami telah dimaklumkan. Halaman ini akan dikemas kini sendiri.",
    'fc.rf.timeout': "Session masih belum sedia. Sila tekan Refresh session sekali lagi.",
    'fc.rf.requestError': "Permintaan tidak dapat dihantar. Sila cuba sebentar lagi.",
    /* ── Satu Flow, satu browser (FlowBrowserLain.jsx) ───────── */
    'fc.br.elsewhere': "Flow anda sedang aktif di browser lain. Satu langganan Flow boleh digunakan dalam satu browser pada satu masa.",
    'fc.br.seen': "Kali terakhir aktif di sana:",
    'fc.br.move': "Pindah ke browser ini",
    'fc.br.moving': "Sedang memindahkan Flow ke browser ini…",
    'fc.br.note': "Flow di browser lama akan ditutup secara automatik. Anda boleh terus guna Flow di sini tanpa menunggu.",
    'fc.br.moveError': "Flow tidak dapat dipindahkan. Sila cuba sebentar lagi.",
    /* ── Flow Projects ───────────────────────────────────────── */
    'fc.fp.title': "Projek Saya",
    'fc.fp.search': "Cari mengikut URL atau nama…",
    'fc.fp.sortNewest': "Terbaru",
    'fc.fp.sortOldest': "Terlama",
    'fc.fp.sortLastUsed': "Guna terbaru",
    'fc.fp.pin': "Pin",
    'fc.fp.unpin': "Nyah-pin",
    'fc.fp.open': "Buka",
    'fc.fp.empty': "Tiada projek disimpan lagi. Buka Flow dan cipta projek — ia akan muncul di sini.",
    'fc.fp.note': "Projek disimpan secara automatik semasa anda menciptanya dalam Flow.",
    'fc.fp.account': "Akaun",
    /* ── Flow Ultra jenis 2: credit digunakan ────────────────── */
    'fc.t2.title': "Anggaran credit digunakan",
    'fc.t2.estimateNote': "Angka ini ialah anggaran yang dibaca secara automatik daripada aktiviti Google Flow anda dan mungkin berbeza sedikit daripada angka Google.",
    'fc.t2.credits': "credit",
    'fc.t2.refresh': "Kemas kini",
    'fc.t2.refreshing': "Membaca…",
    'fc.t2.near': "Mengikut anggaran kami, anda telah menggunakan lebih 80% had credit anda.",
    'fc.t2.full': "Mengikut anggaran kami, anda telah mencapai had credit. Penjanaan dihentikan. Sila hubungi admin untuk menyambung penggunaan.",
    'fc.t2.updated': "Kali terakhir dikemas kini",
    'fc.t2.useBefore': "Gunakan credit anda sebelum {date}. Baki yang tidak digunakan akan luput selepas tarikh ini.",
    'fc.t2.never': "Belum dibaca. Buka Flow sekali, kemudian tekan Kemas kini.",
    'fc.t2.errGmail': "Akaun Google yang dibuka dalam browser ini bukan akaun Flow anda. Sila buka Flow semula dari halaman ini.",
    'fc.t2.errTimeout': "Bacaan credit mengambil masa terlalu lama. Pastikan Chrome kekal terbuka dan cuba semula.",
    'fc.t2.errKerap': "Credit baru sahaja dibaca. Sila tunggu 2 minit sebelum mengemas kini semula.",
    'fc.t2.errGeneric': "Credit tidak dapat dibaca buat masa ini. Sila cuba sebentar lagi.",
    'fc.t2.openError': "Log masuk Flow tidak dapat diselesaikan. Sila cuba semula atau hubungi admin.",
    'fc.t2.err.title': "Log masuk Flow tidak berjaya",
    'fc.t2.err.retry': "Cuba semula",
    'fc.t2.err.contact': "Hubungi admin",
    'fc.t2.err.close': "Tutup",
    'fc.t2.err.waText': "Salam admin, log masuk Flow saya tidak berjaya. Kod: {kod}. Akaun SESAAT: {emel}",
    'fc.t2.err.tab': "Tab log masuk Flow ditutup sebelum selesai. Sila tekan Open Flow sekali lagi dan biarkan tab itu terbuka sehingga Flow dipaparkan.",
    'fc.t2.err.masa': "Log masuk Flow mengambil masa terlalu lama. Sila semak sambungan internet anda, kemudian tekan Open Flow sekali lagi.",
    'fc.t2.err.semak': "Google meminta pengesahan keselamatan tambahan untuk akaun Flow anda. Sila hubungi admin dan nyatakan kod ini.",
    'fc.t2.err.admin': "Akaun Flow anda memerlukan tindakan admin sebelum boleh digunakan. Sila hubungi admin dan nyatakan kod ini.",
    'fc.t2.err.ulang': "Sambungan ke pelayan Flow terganggu seketika. Sila tekan Open Flow sekali lagi. Jika masalah berulang, hubungi admin.",
    'fc.t2.err.halaman': "Halaman log masuk Google bagi akaun Flow anda tidak dapat diselesaikan secara automatik. Sila hubungi admin dan nyatakan kod ini.",
    /* ── Umum (dikongsi merentas halaman) ───────────────────── */
    'common.save': 'Simpan',
    'common.cancel': 'Batal',
    'common.change': 'Tukar',
    'common.back': 'Kembali',
    'common.logout': 'Log keluar',
    'common.loggingOut': 'Log keluar…',
    'common.saving': 'Menyimpan…',
    'common.none': 'Tiada',
    'common.unlimited': 'Tanpa had',
    'common.noRecord': 'Tiada rekod',
    'common.noNumber': 'Tiada nombor',
    'common.today': 'Hari ini',
    'common.status': 'Status',
    'common.copyright': '© 2026 Sesaat · v{versi}',

    /* ── Rangka setting ─────────────────────────────────────── */
    'settings.loading': 'Memuatkan setting…',
    'settings.planNote': 'Pelan · /settings-v3.9',

    'settings.group.account': 'Akaun',
    'settings.group.security': 'Keselamatan',
    'settings.group.subscription': 'Langganan',
    'settings.group.extension': 'Extension',
    'settings.group.referral': 'Rujukan',

    'settings.nav.account': 'Profil',
    'settings.nav.appearance': 'Paparan',
    'settings.nav.security': 'Kata laluan',
    'settings.nav.billing': 'Pakej saya',
    'settings.nav.storage': 'Storage & kuota',
    'settings.nav.extension': 'Status extension',
    'settings.nav.referral': 'Ejen rujukan',

    /* ── Tajuk + penerangan setiap halaman ──────────────────── */
    'settings.page.account.title': 'Profil',
    'settings.page.account.desc': 'Maklumat akaun anda dan cara kami menghubungi anda.',
    'settings.page.appearance.title': 'Paparan',
    'settings.page.appearance.desc': 'Pilih tema dan bahasa untuk paparan SESAAT anda.',
    'settings.page.security.title': 'Kata laluan',
    'settings.page.security.desc': 'Kata laluan yang sama digunakan untuk webapp dan Extension SESAAT.',
    'settings.page.billing.title': 'Pakej saya',
    'settings.page.billing.desc': 'Pelan langganan dan tarikh tamat tempoh anda.',
    'settings.page.storage.title': 'Storage & kuota',
    'settings.page.storage.desc': 'Ruang simpanan video dan baki generation hari ini.',
    'settings.page.extension.title': 'Extension',
    'settings.page.extension.desc': 'Status pemasangan Extension SESAAT pada browser ini.',
    'settings.page.referral.title': 'Ejen rujukan',
    'settings.page.referral.desc': 'Ejen yang membawa anda ke SESAAT.',

    /* ── Halaman Profil ─────────────────────────────────────── */
    'settings.profile.photo': 'Gambar profil',
    'settings.profile.upload': 'Muat naik',
    'settings.profile.remove': 'Buang',
    'settings.profile.photoHint': 'Format imej, maksimum 5MB.',
    'settings.profile.displayName': 'Nama paparan',
    'settings.profile.email': 'Alamat emel',
    'settings.profile.emailPlaceholder': 'masukkan emel baharu',
    'settings.profile.emailNote': 'Emel pengesahan akan dihantar ke alamat baharu. Emel lama kekal berfungsi sehingga anda klik pautan pengesahan. Kata laluan semasa diperlukan.',
    'settings.profile.whatsapp': 'Nombor WhatsApp',
    'settings.profile.whatsappPlaceholder': 'Contoh: 0123456789',
    'settings.profile.whatsappNote': 'Nombor untuk akaun SESAAT anda. Untuk nombor yang dipaparkan kepada rujukan affiliate, sila ke halaman Affiliate > Tetapan.',
    'settings.profile.package': 'Pakej',
    'settings.profile.memberSince': 'Ahli sejak',

    /* ── Halaman Paparan (tema + bahasa) ────────────────────── */
    'settings.appearance.themeTitle': 'Tema paparan',
    'settings.appearance.themeDesc': 'Terang ialah tema lalai SESAAT. Pilihan anda berkuat kuasa serta-merta.',
    'settings.appearance.dark': 'Gelap',
    'settings.appearance.light': 'Terang',
    'settings.appearance.themeFoot': 'Pilihan disimpan pada browser ini sahaja — browser lain kekal dengan pilihan masing-masing.',
    'settings.appearance.langTitle': 'Bahasa paparan',
    'settings.appearance.langDesc': 'English ialah bahasa lalai SESAAT. Pilih Bahasa Melayu jika anda lebih selesa dengannya — pilihan anda berkuat kuasa serta-merta.',
    'settings.appearance.langFoot': 'Sama seperti tema, bahasa disimpan pada browser ini sahaja. Sebahagian halaman lama mungkin kekal dalam Bahasa Melayu buat sementara.',

    /* ── Halaman Kata laluan ────────────────────────────────── */
    'settings.password.googleOnly': 'Anda log masuk menggunakan butang Google sahaja. Tetapkan kata laluan di bawah — selepas itu anda boleh log masuk menggunakan {emel} dan kata laluan pada mana-mana browser, termasuk Extension SESAAT.',
    'settings.password.current': 'Kata laluan semasa',
    'settings.password.new': 'Kata laluan baharu',
    'settings.password.confirm': 'Sahkan kata laluan baharu',
    'settings.password.retype': 'Taip semula',
    'settings.password.strength': 'Kekuatan: {tahap}',
    'settings.password.mismatch': 'Kata laluan tidak sepadan.',
    'settings.password.matches': 'Kata laluan sepadan.',
    'settings.password.rule': 'Kata laluan mestilah sekurang-kurangnya 6 aksara, dan sebaiknya mengandungi huruf besar serta nombor.',
    'settings.password.checkInbox': 'Sila semak peti masuk (atau folder spam) di {emel}.',
    'settings.password.stayLoggedIn': 'Anda akan kekal log masuk selepas menukar kata laluan.',
    'settings.password.emailIsUsername': 'Emel anda menjadi nama pengguna.',
    'settings.password.resetSent': 'Emel dihantar',
    'settings.password.sendReset': 'Hantar emel tetapan semula',
    'settings.password.update': 'Kemas kini',
    'settings.password.set': 'Tetapkan',

    /* ── Halaman Pakej saya ─────────────────────────────────── */
    'settings.billing.currentPlan': 'Pelan semasa',
    'settings.billing.activeUntil': 'Aktif sehingga',
    'settings.billing.manageFoot': 'Perbaharui atau tukar pelan anda.',
    'settings.billing.manage': 'Urus langganan',
    'settings.billing.upgradeTitle': 'Naik taraf ke pelan berbayar',
    'settings.billing.upgradeDesc': 'Buka semua modul, kuota {kuota} generation sehari, dan automasi Flow serta TikTok tanpa had percubaan.',
    'settings.billing.upgradeFoot': 'Bayaran sekali, akses penuh sepanjang tempoh.',
    'settings.billing.smartTitle': 'Naik taraf ke Premium',
    'settings.billing.smartDesc': 'Anda sedang menggunakan pakej SMART. Naik taraf sekali sahaja untuk membuka semua module siap pakai dan 100 generate sehari.',
    'settings.billing.smartFoot': 'Tempoh langganan anda kekal seperti sedia ada.',
    'settings.billing.seePricing': 'Lihat harga',
    'settings.billing.slotTitle': 'Slot anda',
    'settings.billing.slotDesc': 'Satu kuota untuk kedua-duanya. Setiap browser Chrome yang anda log masuk mengambil satu slot, begitu juga setiap avatar yang anda simpan.',
    'settings.billing.slotBrowser': 'Browser Chrome',
    'settings.billing.slotAvatar': 'Avatar disimpan',
    'settings.billing.slotOf': 'daripada {n} digunakan',
    'settings.billing.slotUnlimited': 'sedang digunakan · tanpa had',
    'settings.billing.slotUnknown': 'Tidak dapat dibaca sekarang',
    'settings.billing.slotFoot': 'Perlu slot tambahan? Hubungi kami di WhatsApp.',
    'settings.billing.modulesTitle': 'Modul anda',
    'settings.billing.modulesDesc': 'Modul yang terbuka pada akaun anda.',
    'settings.billing.modulesNone': 'Belum ada modul yang dibuka pada akaun ini.',
    'settings.billing.flowTitle': 'Langganan Flow',
    'settings.billing.flowDesc': 'Akses Flow Google anda — langganan berasingan daripada pelan utama.',
    'settings.billing.flowPlan': 'Pelan Flow',
    'settings.billing.flowChecking': 'Menyemak langganan Flow anda…',
    'settings.billing.flowUnavailable': 'Tidak dapat memuatkan status Flow anda sekarang.',
    'settings.billing.flowNone': 'Anda belum ada langganan Flow.',
    'settings.billing.flowManage': 'Butiran penuh',
    'settings.billing.flowManageFoot': 'Lihat pelan Flow, bil dan sejarah bayaran anda.',
    'settings.billing.flowGet': 'Dapatkan Flow',
    'settings.billing.flowGetFoot': 'Tambah automasi Flow Google ke akaun anda.',
    'settings.billing.yearly': 'Tahunan',
    'settings.billing.monthly': 'Bulanan',

    /* ── Halaman Storage & kuota ────────────────────────────── */
    'settings.storage.title': 'Ruang simpanan',
    'settings.storage.desc': 'Video dan gambar yang disimpan ke Cloud.',
    'settings.storage.of': 'daripada {jumlah}',
    'settings.storage.almostFull': 'Ruang hampir penuh. Video baharu mungkin gagal disimpan sehingga anda melapangkan ruang.',
    'settings.storage.hint': 'Padam video yang sudah dimuat naik ke TikTok untuk melapangkan ruang.',
    'settings.storage.foot': 'Video dipadam di Workspace.',
    'settings.storage.manage': 'Urus video',
    'settings.storage.quotaTitle': 'Kuota generation',
    'settings.storage.quotaDesc': 'Satu generation menghasilkan 3 set prompt.',
    'settings.storage.quotaAdmin': '{n} digunakan · tanpa had',
    'settings.storage.quotaOfToday': 'daripada {n} hari ini',
    'settings.storage.quotaResetNote': 'Kuota kembali penuh pada pukul 12:00 tengah malam (waktu Malaysia). Kuota ini dikongsi antara semua modul.',
    'settings.storage.quotaOfTrial': 'daripada {n} percubaan',
    'settings.storage.quotaTrialNote': 'Kuota percubaan diberi sekali sahaja dan tidak diisi semula setiap hari.',

    /* ── Halaman Extension ──────────────────────────────────── */
    'settings.ext.title': 'Status pada browser ini',
    'settings.ext.desc': 'Setiap browser perlu memasang extension secara berasingan.',
    'settings.ext.connected': 'Tersambung',
    'settings.ext.checking': 'Sedang menyemak…',
    'settings.ext.missing': 'Tidak dikesan',
    'settings.ext.installedVersion': 'Versi dipasang',
    'settings.ext.oldVersion': 'Versi lama',
    'settings.ext.latestVersion': 'Versi terkini yang diedarkan:',
    'settings.ext.duplicateWarn': 'Browser ini mempunyai lebih daripada satu Extension SESAAT yang aktif. Sila buka {laluan} dan buang pemasangan yang lama — dua pemasangan serentak boleh menyebabkan automasi berkelakuan pelik.',
    'settings.ext.missingNote': 'Extension tidak menjawab pada browser ini. Ia mungkin belum dipasang, atau baru dipasang tetapi halaman ini belum dimuat semula.',
    'settings.ext.checkFoot': 'Semakan dibuat terus pada browser ini.',
    'settings.ext.recheck': 'Semak semula',
    'settings.ext.download': 'Muat turun extension',
    'settings.ext.howToInstall': 'Cara pasang',
    'settings.ext.storeNote': 'SESAAT tidak diedarkan melalui Chrome Web Store. Selepas memasang versi baharu, muat semula halaman ini supaya status di atas dikemas kini.',

    /* ── Halaman Ejen rujukan ───────────────────────────────── */
    'settings.referral.loading': 'Memuatkan maklumat ejen…',
    'settings.referral.agentName': 'Nama ejen',
    'settings.referral.agentFallback': 'Ejen Affiliate',
    'settings.referral.code': 'Kod rujukan',
    'settings.referral.contact': 'Hubungi ejen',
    'settings.referral.inaccurate': 'Sekiranya maklumat ejen ini tidak tepat, sila hubungi admin SESAAT untuk semakan.',
    'settings.referral.emptyTitle': 'Tiada ejen rujukan',
    'settings.referral.emptyDesc': 'Anda mendaftar secara terus tanpa pautan affiliate. Sekiranya anda klik pautan ejen tetapi maklumatnya tidak dipaparkan di sini, sila hubungi admin untuk semakan.',

    /* ── Mesej operasi akaun (useAccountSettings) ────────────
       Ini mesej hasil yang dipapar pada kad setting selepas
       pelanggan menekan Simpan. Ia lahir DALAM hook, bukan
       dalam fail rupa — hook itu otak yang dikongsi oleh rupa
       lama (ProfileView) dan rupa v3.9 (SettingsV39View), jadi
       menterjemah di situ membetulkan kedua-duanya sekali. */
    'acc.nameEmpty': 'Nama tidak boleh kosong.',
    'acc.nameUpdated': 'Nama telah dikemas kini.',
    'acc.nameFailed': 'Gagal mengemas kini nama: {ralat}',
    'acc.waInvalid': 'Nombor WhatsApp tidak sah. Sila masukkan 9 hingga 15 digit.',
    'acc.waUpdated': 'Nombor WhatsApp telah dikemas kini.',
    'acc.waFailed': 'Gagal mengemas kini nombor: {ralat}',
    'acc.emailInvalid': 'Sila masukkan alamat emel yang sah.',
    'acc.emailInUse': 'Alamat emel ini sudah digunakan oleh akaun lain.',
    'acc.emailBad': 'Alamat emel tidak sah.',
    'acc.sessionExpiredRetry': 'Sesi anda telah tamat tempoh. Sila log masuk semula dan cuba sekali lagi.',
    'acc.emailFailed': 'Gagal menukar emel: {ralat}',
    'acc.unknownError': 'Ralat tidak diketahui',
    'acc.pwMismatchNew': 'Kata laluan baharu tidak sepadan.',
    'acc.pwTooShortNew': 'Kata laluan baharu mestilah sekurang-kurangnya 6 aksara.',
    'acc.pwUpdated': 'Kata laluan telah dikemas kini.',
    'acc.pwCurrentWrong': 'Kata laluan semasa tidak betul.',
    'acc.tooManyAttempts': 'Terlalu banyak percubaan. Sila tunggu sebentar.',
    'acc.sessionExpired': 'Sesi anda telah tamat tempoh. Sila log masuk semula.',
    'acc.pwChangeFailed': 'Gagal menukar kata laluan: {ralat}',
    'acc.pwMismatch': 'Kata laluan tidak sepadan.',
    'acc.pwTooShort': 'Kata laluan mestilah sekurang-kurangnya 6 aksara.',
    'acc.noEmail': 'Akaun ini tiada alamat emel. Sila hubungi admin SESAAT.',
    'acc.alreadyHasPw': 'Akaun ini sudah mempunyai kata laluan. Sila muat semula halaman.',
    'acc.emailInUseAdmin': 'Emel ini sudah digunakan oleh akaun lain. Sila hubungi admin SESAAT.',
    'acc.pwTooWeak': 'Kata laluan terlalu lemah. Sila guna sekurang-kurangnya 6 aksara.',
    'acc.googleCancelled': 'Pengesahan Google dibatalkan. Sila cuba sekali lagi.',
    'acc.googleBlocked': 'Tetingkap Google disekat oleh browser. Sila benarkan popup untuk laman ini, kemudian cuba sekali lagi.',
    'acc.sessionExpiredGoogle': 'Sesi anda telah tamat tempoh. Sila log keluar, log masuk semula dengan Google, kemudian cuba sekali lagi.',
    'acc.pwSetFailed': 'Gagal menetapkan kata laluan: {ralat}',
    'acc.tooManyRequests': 'Terlalu banyak permintaan. Sila tunggu sebentar.',
    'acc.resetEmailFailed': 'Gagal menghantar emel tetapan semula: {ralat}',
    'acc.logoutFailed': 'Gagal log keluar.',
    'acc.pickImageOnly': 'Sila pilih fail imej sahaja.',
    'acc.fileTooBig': 'Saiz fail terlalu besar. Maksimum 5MB.',
    'acc.avatarFailed': 'Gagal memuat naik gambar.',
    'acc.reauthEnterPw': 'Sila masukkan kata laluan semasa anda.',
    'acc.reauthWrongPw': 'Kata laluan tidak betul. Sila cuba sekali lagi.',
    'acc.reauthFailed': 'Pengesahan gagal: {ralat}',
    'acc.pwStrength1': 'Sangat Lemah',
    'acc.pwStrength2': 'Lemah',
    'acc.pwStrength3': 'Sederhana',
    'acc.pwStrength4': 'Kuat',
    'acc.pwStrength5': 'Sangat Kuat',

    /* ── Modal pengesahan semula ────────────────────────────── */
    'settings.reauth.title': 'Pengesahan keselamatan',
    'settings.reauth.desc': 'Masukkan kata laluan semasa anda untuk meneruskan.',
    'settings.reauth.emailNote': 'Menukar emel kepada {emel}. Emel pengesahan akan dihantar ke alamat baharu.',
    'settings.reauth.placeholder': 'Masukkan kata laluan anda',
    'settings.reauth.verifying': 'Mengesahkan…',
    'settings.reauth.confirm': 'Sahkan dan teruskan',

    /* ── adminmarket ─────────────────────────────────────────── */
    'adminmarket.accessDenied': 'Akses ditolak — admin sahaja.',
    'adminmarket.addProduct': 'Tambah Produk',
    'adminmarket.cancel': 'Batal',
    'adminmarket.card.affiliateGlobal': 'Affiliate global',
    'adminmarket.card.affiliatePct': 'Affiliate {peratus}%',
    'adminmarket.card.autoDeliver': 'Auto serah',
    'adminmarket.card.autoDeliverDays': 'Auto serah · {n} hari',
    'adminmarket.card.delete': 'Padam',
    'adminmarket.card.edit': 'Edit',
    'adminmarket.card.manageStock': 'Urus Stok Akaun',
    'adminmarket.card.stockN': 'Stok {n}',
    'adminmarket.card.stockUnlimited': 'Stok ∞',
    'adminmarket.close': 'Tutup',
    'adminmarket.file.change': 'Tukar fail',
    'adminmarket.file.choose': 'Pilih fail',
    'adminmarket.file.none': 'Tiada fail dipilih',
    'adminmarket.form.affiliateEnable': 'Benarkan affiliate promosikan produk ini',
    'adminmarket.form.affiliateRate': 'Kadar komisen khas (%) — kosong = guna kadar global (25%)',
    'adminmarket.form.affiliateRatePlaceholder': 'cth 40',
    'adminmarket.form.category': 'Kategori',
    'adminmarket.form.created': 'Produk dicipta.',
    'adminmarket.form.description': 'Penerangan',
    'adminmarket.form.duration': 'Tempoh akses (hari) — kosong = milik selamanya',
    'adminmarket.form.durationHint1': 'Isi ',
    'adminmarket.form.durationHint2': ' untuk sewa bulanan (Flow Ultra) — pembeli berhenti nampak kredential selepas tamat. Biar ',
    'adminmarket.form.durationHint3': ' untuk jual putus (akaun TikTok).',
    'adminmarket.form.durationHintBlank': 'kosong',
    'adminmarket.form.durationPlaceholder': 'cth 30 untuk sewa sebulan',
    'adminmarket.form.ebook': 'Fail ebook (PDF)',
    'adminmarket.form.ebookMustPdf': 'Fail ebook mesti PDF.',
    'adminmarket.form.editProduct': 'Edit Produk',
    'adminmarket.form.fulfillment': 'Cara hantar',
    'adminmarket.form.image': 'Gambar produk',
    'adminmarket.form.internalNotes': 'Nota dalaman (admin sahaja)',
    'adminmarket.form.keepBlank': ' (biar kosong kalau tak nak tukar)',
    'adminmarket.form.needTitle': 'Sila isi tajuk produk.',
    'adminmarket.form.order': 'Susunan (order)',
    'adminmarket.form.originalPrice': 'Harga asal / coret (RM)',
    'adminmarket.form.paid': 'Bayar',
    'adminmarket.form.price': 'Harga (RM)',
    'adminmarket.form.pricingMode': 'Mod harga',
    'adminmarket.form.rateRange': 'Kadar komisen mesti antara 1–100%.',
    'adminmarket.form.saveFailed': 'Gagal simpan: {ralat}',
    'adminmarket.form.status': 'Status',
    'adminmarket.form.stock': 'Stok',
    'adminmarket.form.stockAccounts': '{n} akaun',
    'adminmarket.form.stockAutoHint1': 'Dikira automatik daripada senarai akaun. Guna butang ',
    'adminmarket.form.stockAutoHint2': ' pada kad produk.',
    'adminmarket.form.stockManual': 'Stok (kosong = tanpa had)',
    'adminmarket.form.stockNone': 'Belum ada akaun',
    'adminmarket.form.title': 'Tajuk',
    'adminmarket.form.updated': 'Produk dikemaskini.',
    'adminmarket.free': 'Percuma',
    'adminmarket.noTitle': '(tiada tajuk)',
    'adminmarket.orders.accessExtended': 'Akses disambung pada akaun sedia ada pembeli.',
    'adminmarket.orders.accountHandedOver': 'Satu akaun diserahkan automatik daripada stok.',
    'adminmarket.orders.commission': '{asas} Komisen {jumlah} dikreditkan.',
    'adminmarket.orders.deliverFailed': 'Gagal hantar: {ralat}',
    'adminmarket.orders.deliveryPlaceholder': 'Info penghantaran: username / password / akses Gmail…',
    'adminmarket.orders.emptyDesc': 'Tiada pesanan dalam status ini buat masa sekarang.',
    'adminmarket.orders.emptyTitle': 'Tiada order',
    'adminmarket.orders.filter.delivered': 'Dihantar',
    'adminmarket.orders.filter.rejected': 'Ditolak',
    'adminmarket.orders.filter.partial': 'Separa',
    'adminmarket.orders.shortfall': '{n} belum diserah',
    'adminmarket.orders.filter.requested': 'Diminta',
    'adminmarket.orders.loadFailed': 'Gagal muat order: {ralat}',
    'adminmarket.orders.markDelivered': 'Tandakan Dihantar',
    'adminmarket.orders.markedDelivered': 'Order ditandakan dihantar.',
    'adminmarket.orders.needDeliveryInfo': 'Sila isi info penghantaran (kredential/akses) dahulu.',
    'adminmarket.orders.notePlaceholderEbook': 'Nota (opsyenal) — ebook auto-download',
    'adminmarket.orders.notePlaceholderStock': 'Nota dalaman (opsyenal) — akaun diserahkan automatik daripada stok',
    'adminmarket.orders.processing': 'Memproses…',
    'adminmarket.orders.ref': 'Ref: {kod}',
    'adminmarket.orders.reject': 'Tolak',
    'adminmarket.orders.rejectFailed': 'Gagal tolak: {ralat}',
    'adminmarket.orders.rejectPrompt': 'Sebab tolak (opsyenal):',
    'adminmarket.orders.rejected': 'Order ditolak.',
    'adminmarket.orders.viewProof': 'Lihat bukti bayar',
    'adminmarket.orders.whatsapp': 'WhatsApp: {nombor}',
    'adminmarket.products.confirmDelete': 'Padam produk "{tajuk}"? Tindakan ini kekal.',
    'adminmarket.products.deleteFailed': 'Gagal padam: {ralat}',
    'adminmarket.products.deleted': 'Produk dipadam.',
    'adminmarket.products.emptyDesc': 'Produk yang dicipta di sini akan muncul dalam Marketplace pembeli.',
    'adminmarket.products.emptyTitle': 'Belum ada produk',
    'adminmarket.products.loadFailed': 'Gagal muat produk: {ralat}',
    'adminmarket.save': 'Simpan',
    'adminmarket.saving': 'Menyimpan…',
    'adminmarket.stock.addFailed': 'Gagal tambah: {ralat}',
    'adminmarket.stock.addN': 'Tambah {n} akaun',
    'adminmarket.stock.added': '{n} akaun ditambah ke stok.',
    'adminmarket.stock.aria': 'Stok akaun',
    'adminmarket.stock.available': '{n} tersedia',
    'adminmarket.stock.badgeAvailable': 'Tersedia',
    'adminmarket.stock.badgeSold': 'Terjual',
    'adminmarket.stock.buyerFallback': 'pembeli',
    'adminmarket.stock.confirmDelete': 'Padam akaun ini daripada stok? Tindakan ini kekal.',
    'adminmarket.stock.deleteAria': 'Padam akaun',
    'adminmarket.stock.detected': 'Dikesan: {senarai}',
    'adminmarket.stock.empty': 'Belum ada akaun dalam stok. Tampal di atas untuk mula.',
    'adminmarket.stock.forever': ' · selamanya',
    'adminmarket.stock.hint1': 'Satu akaun satu blok. Pisahkan setiap akaun dengan ',
    'adminmarket.stock.hint2': ' atau baris ',
    'adminmarket.stock.hintBlankLine': 'baris kosong',
    'adminmarket.stock.labelEmpty': '(kosong)',
    'adminmarket.stock.loadFailed': 'Gagal muat stok: {ralat}',
    'adminmarket.stock.loading': 'Memuatkan…',
    'adminmarket.stock.pasteLabel': 'Tampal akaun baharu',
    'adminmarket.stock.pastePlaceholder': 'contoh@gmail.com\nkata laluan: abc123\n2FA: 1234 5678\n\ncontoh2@gmail.com\nkata laluan: xyz789',
    'adminmarket.stock.sold': '{n} terjual',
    'adminmarket.stock.title': 'Stok akaun — {tajuk}',
    'adminmarket.stock.until': ' · sehingga {tarikh}',
    'adminmarket.subtitle': 'Urus produk yang dijual dan serahkan pesanan pembeli.',
    'adminmarket.tab.orders': 'Orders',
    'adminmarket.tab.products': 'Products',
    'adminmarket.title': 'Kelola Marketplace',

    /* ── affiliate ───────────────────────────────────────────── */
    'affiliate.badge.credited': 'Dikreditkan',
    'affiliate.badge.done': 'Selesai',
    'affiliate.badge.pending': 'Menunggu',
    'affiliate.codeHint': 'Pilih pautan mengikut sejauh mana orang itu sudah mengenali SESAAT.',
    'affiliate.codeLine': 'Kod ejen anda ialah {kod}.',
    'affiliate.copied': 'Disalin',
    'affiliate.copy': 'Salin',
    'affiliate.historyTitle': 'Sejarah payout',
    'affiliate.link.pricing': 'Pricing',
    'affiliate.link.pricingDesc': 'Untuk yang sudah yakin — terus melihat harga',
    'affiliate.link.salespage': 'Salespage',
    'affiliate.link.salespageDesc': 'Untuk audience baharu — biarkan mereka membaca salespage dahulu',
    'affiliate.link.signup': 'Daftar terus',
    'affiliate.link.signupDesc': 'Untuk hot lead — langkau salespage, terus masuk app',
    'affiliate.linksTitle': 'Pautan anda',
    'affiliate.payout.countHint': '{n} payout',
    'affiliate.payout.earnings': 'Jumlah pendapatan',
    'affiliate.payout.earningsHint': 'Sepanjang hayat akaun',
    'affiliate.payout.minHint': 'Minimum {jumlah}',
    'affiliate.payout.paid': 'Sudah dibayar',
    'affiliate.payout.withdrawable': 'Boleh dikeluarkan',
    'affiliate.prototypeNote': 'Prototaip · /affiliate-v3.9',
    'affiliate.recentTitle': 'Rujukan terkini',
    'affiliate.requestPayout': 'Minta payout',
    'affiliate.stat.available': 'Baki tersedia',
    'affiliate.stat.availableHint': 'Boleh dikeluarkan',
    'affiliate.stat.clicks': 'Jumlah klik',
    'affiliate.stat.conversion': 'Kadar tukaran',
    'affiliate.stat.conversionHint': 'Rujukan dibahagi klik',
    'affiliate.stat.pending': 'Baki menunggu',
    'affiliate.stat.pendingHint': 'Matang selepas 14 hari',
    'affiliate.stat.referrals': 'Jumlah rujukan',
    'affiliate.subtitle': 'Kongsi pautan anda, dapat komisen setiap kali seseorang melanggan.',
    'affiliate.tabDashboard': 'Dashboard',
    'affiliate.tabPayouts': 'Payouts',
    'affiliate.th.amount': 'Jumlah',
    'affiliate.th.commission': 'Komisen',
    'affiliate.th.customer': 'Pelanggan',
    'affiliate.th.date': 'Tarikh',
    'affiliate.th.method': 'Kaedah',
    'affiliate.th.package': 'Pakej',
    'affiliate.title': 'Affiliates',

    /* ── dashboard ───────────────────────────────────────────── */
    'dashboard.campaign.daysLeft': '{n} hari lagi',
    'dashboard.campaign.holiday': 'Cuti umum',
    'dashboard.campaign.platform': 'Kempen platform',
    'dashboard.campaign.title': 'Kalendar Kempen',
    /* Kalendar Kempen SEBENAR (CampaignCalendarSection) — bukan lagi
       versi contoh. Nama event sendiri (Hari Raya, 11.11, cuti sekolah)
       TIDAK masuk kamus: ia nama khas, dan ia datang daripada
       data/campaignCalendar.js + doc admin, bukan daripada kod. */
    'dashboard.campaign.eyebrow': 'Rancang Awal',
    'dashboard.campaign.edit': 'Edit kalendar',
    'dashboard.campaign.saveFailed': 'Simpan gagal: {sebab}',
    'dashboard.campaign.upcoming': 'Akan datang',
    'dashboard.campaign.startContent': 'Mula konten {tarikh}',
    'dashboard.campaign.startPrep': 'Mula sedia konten {tarikh} ({n} hari sebelum)',
    'dashboard.campaign.prepStarted': 'Masa sedia konten sudah bermula',
    'dashboard.campaign.prepStartedLong': 'Masa sedia konten sudah bermula — jangan tunggu lagi',
    'dashboard.campaign.ongoing': 'Sedang berlangsung',
    'dashboard.campaign.tomorrow': 'Esok',
    'dashboard.campaign.holidaysMissing': 'Cuti umum {tahun} belum diisi — hanya kempen platform dan tarikh komersial dipapar. Ambil senarai rasmi dari kabinet.gov.my, kemudian masukkan dalam fail data kalendar.',
    'dashboard.campaign.tierBig': 'Besar',
    'dashboard.campaign.tierMid': 'Sederhana',
    'dashboard.campaign.tierSmall': 'Kecil',
    'dashboard.campaign.tierBigOpt': 'Besar (merah)',
    'dashboard.campaign.tierMidOpt': 'Sederhana (kuning)',
    'dashboard.campaign.tierSmallOpt': 'Kecil (kelabu)',
    'dashboard.campaign.legendHint': '· Klik hari untuk tumpu pada event tersebut',
    'dashboard.campaign.eventsOf': 'Event {bulan} {tahun}',
    'dashboard.campaign.showAll': 'Papar semua',
    'dashboard.campaign.emptyMonth': 'Tiada event bulan ini.',
    'dashboard.campaign.emptyDay': 'Tiada event pada tarikh ini.',
    'dashboard.campaign.emptyDayShort': 'Tiada event pada hari ini.',
    'dashboard.campaign.hiddenTag': '(disorok)',
    'dashboard.campaign.prevMonth': 'Bulan sebelum',
    'dashboard.campaign.nextMonth': 'Bulan seterusnya',
    'dashboard.campaign.school': 'Cuti sekolah',
    'dashboard.campaign.commerce': 'Tarikh komersial',
    'dashboard.campaign.custom': 'Tambahan SESAAT',
    /* Mod edit — admin sahaja. */
    'dashboard.campaign.newEvent': 'Event baharu',
    'dashboard.campaign.introLabel': 'Ayat pengenalan (atas kalendar)',
    'dashboard.campaign.noTitle': '(tanpa tajuk)',
    'dashboard.campaign.hide': 'Sorok',
    'dashboard.campaign.showAgain': 'Papar semula',
    'dashboard.campaign.delete': 'Padam',
    'dashboard.campaign.fTitle': 'Tajuk',
    'dashboard.campaign.fDate': 'Tarikh',
    'dashboard.campaign.fUntil': 'Sampai (pilihan)',
    'dashboard.campaign.fPriority': 'Keutamaan',
    'dashboard.campaign.fNote': 'Nota',
    'dashboard.campaign.fNoteExtra': 'Nota tambahan — {tarikh}',
    'dashboard.campaign.phTitle': 'Cth: Kempen Raya',
    'dashboard.campaign.phNote': 'Cth: Pulun baju tema Merdeka, mula 17 Ogos. Fokus niche fesyen.',
    'dashboard.footer.rights': '© 2026 SESAAT. All rights reserved.',
    /* Ucapan ikut waktu — dipilih oleh greetingKeyNow() dlm useDashboard. */
    'dashboard.greeting.morning': 'Selamat Pagi',
    'dashboard.greeting.afternoon': 'Selamat Tengahari',
    'dashboard.greeting.evening': 'Selamat Malam',
    'dashboard.help.extension.cta': 'Buka panduan',
    'dashboard.help.extension.desc': 'Langkah pasang dan cara kemas kini ke versi terbaharu.',
    'dashboard.help.extension.title': 'Pasang extension',
    'dashboard.help.faq.browsers.a': 'Satu lesen boleh dipasang pada 3 hingga 5 browser. Setiap browser perlu memasang extension berasingan dan log masuk dengan akaun SESAAT yang sama.',
    'dashboard.help.faq.browsers.q': 'Boleh guna pada berapa browser?',
    'dashboard.help.faq.flow.a': 'Pastikan extension SESAAT sudah dipasang pada browser yang sedang anda guna, dan anda sudah log masuk ke Google Labs Flow dalam browser yang sama.',
    'dashboard.help.faq.flow.q': 'Video tidak keluar selepas tekan Run Flow.',
    'dashboard.help.faq.quota.a': 'Kuota berbayar ialah 100 generate sehari, dikongsi antara semua formula. Ia kembali penuh pada 12:00 tengah malam waktu Malaysia. Satu generate menghasilkan 3 set, jadi sehingga 300 video sehari.',
    'dashboard.help.faq.quota.q': 'Kuota generate saya habis.',
    'dashboard.help.faq.storage.a': 'Setiap akaun ada 5 GB. Buka Workspace, padam video yang sudah dimuat naik ke TikTok — video itu tidak perlu disimpan lagi selepas berjaya dipos.',
    'dashboard.help.faq.storage.q': 'Storage saya penuh.',
    'dashboard.help.faqTitle': 'Soalan lazim',
    'dashboard.help.group.cta': 'Sertai group',
    'dashboard.help.group.desc': 'Tempat paling cepat untuk mendapat jawapan. Tanya terus, ada orang akan menjawab.',
    'dashboard.help.group.title': 'Group WhatsApp',
    'dashboard.help.protoNote': 'Prototaip · /help-v3.9',
    'dashboard.help.subtitle': 'Tersekat? Mulakan di sini.',
    'dashboard.help.title': 'Help',
    'dashboard.help.tutorial.cta': 'Buka playlist',
    'dashboard.help.tutorial.desc': 'Daripada memasang extension sehingga video pertama anda naik ke TikTok.',
    'dashboard.help.tutorial.title': 'Tutorial video',
    'dashboard.newProducts.emptyDesc': 'Produk baharu daripada pustaka System akan muncul di sini setiap kali ia ditambah.',
    /* Nama ganti bila produk memang tiada nama — bukan ralat, cuma jarang. */
    'dashboard.newProducts.fallbackName': 'Produk #{n}',
    'dashboard.newProducts.emptyTitle': 'Belum ada produk baharu',
    'dashboard.newProducts.eyebrow': 'Terbaru',
    'dashboard.newProducts.seeAll': 'Lihat semua',
    'dashboard.newProducts.title': 'Produk Baru',
    'dashboard.passwordNotice.cta': 'Tetapkan',
    /* ⛔ Ayat ini SAMA TEPAT dengan notis yang pelanggan baca hari ini pada
       rupa lama. Versi v3.9 pernah membawa ayat yang lebih kemas, tetapi
       tiada siapa memutuskan untuk menukar ayat notis akaun — jadi ia
       dipulangkan. Nak tukar? Tukar di sini DAN sahkan dengan user. */
    'dashboard.passwordNotice.desc': 'Set sekarang supaya anda boleh login di browser lain dan pada Extension SESAAT.',
    'dashboard.passwordNotice.title': 'Akaun anda belum ada password.',
    'dashboard.planNote': 'Pelan · /dashboard-v3.9',
    'dashboard.stat.quota': 'Kuota hari ini',
    'dashboard.stat.quotaHint': 'Penuh semula 12:00 tengah malam',
    'dashboard.stat.storage': 'Storage',
    'dashboard.stat.storageHint': 'Padam video yang sudah dipos',
    'dashboard.stat.videos': 'Video siap minggu ini',
    'dashboard.stat.videosHint': 'Merentas semua formula',
    'dashboard.state.newUser': 'Pengguna baharu',
    'dashboard.state.noProducts': 'Tiada produk',
    'dashboard.state.normal': 'Biasa',
    'dashboard.subtitle': 'Tempat mula setiap hari.',
    'dashboard.support.cta': 'Sertai Group WhatsApp',
    'dashboard.support.desc': 'Ada masalah atau ingin bertanya? Team support akan membantu anda terus dalam group WhatsApp.',
    'dashboard.support.title': 'Group Support',
    'dashboard.title': 'Dashboard',
    'dashboard.wish.editAria': 'Edit hasrat',

    /* ── ext ─────────────────────────────────────────────────── */
    'ext.downloadBtn': 'Download Extension',
    'ext.heroDesc': 'Automate Google Flow dan upload TikTok terus dari browser anda.',
    'ext.heroTitle': 'SESAAT Browser Extension',
    'ext.pageSubtitle': 'Extension inilah yang menjalankan Flow dan menghantar video ke TikTok.',
    'ext.pageTitle': 'Extension',
    'ext.planNote': 'Pelan · /extension-v3.9',
    'ext.platformNote': 'Untuk Google Chrome dan Microsoft Edge di komputer',
    /* Baris pautan ke Tutorial. Menggantikan langkah pasang + FAQ yang
       dibuang daripada halaman Extension (2026-08-16) — panduan penuh
       kini hidup di /tutorial/v_install sahaja. */
    'ext.tutorialLink.desc': 'Panduan langkah demi langkah ada dalam Tutorial.',
    'ext.tutorialLink.title': 'Cara install Extension SESAAT',

    /* ── formula ─────────────────────────────────────────────── */
    'formula.action.new': 'Formula baharu',
    'formula.badge.active': 'Aktif',
    'formula.badge.locked': 'Berkunci',
    'formula.card.meta': '{engine} · 3 set setiap generate',
    'formula.card.open': 'Buka',
    'formula.card.options': 'Pilihan untuk {name}',
    'formula.card.ready': 'Sedia untuk run.',
    'formula.card.upgrade': 'Naik taraf untuk membukanya.',
    'formula.create.body': 'Ada sudut jualan yang konsisten menjadi? Bina sekali sahaja — tetapkan scene, kunci gayanya, kemudian run pada setiap produk yang anda tambah.',
    'formula.create.cta': 'Mula bina',
    'formula.create.private': 'Milik anda sahaja. Orang lain tidak nampak.',
    'formula.create.title': 'Bina formula anda sendiri',
    'formula.desc.ai16saat-half': 'Dedahkan produk, kemudian tunjukkan cara ia berfungsi.',
    'formula.desc.ai8saat': 'Creator memegang produk dan bercakap terus ke kamera.',
    'formula.desc.fallback': 'Formula rasmi Sesaat.',
    'formula.desc.flownity': 'Satu cerita penuh merentas beberapa scene.',
    'formula.desc.goyang': 'Template bergerak dengan latar belakangnya sendiri.',
    'formula.desc.homeniche': 'Barangan rumah ditunjukkan dalam suasana rumah sebenar.',
    'formula.desc.smartcustom': 'Anda menulis prompt sendiri.',
    'formula.editor.aksara': '{n} aksara',
    'formula.editor.enjin.banyak': 'Banyak babak (3–6)',
    'formula.editor.enjin.banyakNota': 'Satu video panjang, cerita bersambung. Belum dibuka.',
    'formula.editor.enjin.dua': '2 babak',
    'formula.editor.enjin.duaNota': 'Reveal produk dahulu, kemudian tunjuk cara guna.',
    'formula.editor.edar.notis': 'Formula ini akan dilihat oleh semua pelanggan berlesen sebaik ia disimpan.',
    'formula.editor.enjin.satu': '1 babak',
    'formula.editor.enjin.satuNota': 'Creator pegang produk dan bercakap terus ke kamera.',
    'formula.editor.kaki.kembali': 'Kembali',
    'formula.editor.kaki.langkah': 'Langkah {kini} daripada {jumlah}',
    'formula.editor.kaki.seterusnya': 'Seterusnya',
    'formula.editor.kaki.simpanDraf': 'Simpan draf',
    'formula.editor.kaki.simpanFormula': 'Simpan formula',
    'formula.editor.langkah.bentuk': 'Bentuk video',
    'formula.editor.langkah.nama': 'Nama',
    'formula.editor.langkah.prompt': 'Master prompt',
    'formula.editor.langkah.simpan': 'Simpan',
    'formula.editor.langkah.uji': 'Uji',
    'formula.editor.lulus': 'Lulus',
    'formula.editor.milik.label': 'Admin',
    'formula.editor.milik.sendiri': 'Milik saya',
    'formula.editor.milik.system': 'Untuk system',
    'formula.editor.prototaip': 'Prototaip · /formula/editor',
    'formula.editor.rel.aria': 'Langkah membina formula',
    'formula.editor.rel.kembaliKe': 'Kembali ke: {tajuk}',
    'formula.editor.s1.huraianAria': 'Penerangan formula',
    'formula.editor.s1.huraianPlaceholder': 'Creator tunjuk kulit sebelum, kemudian hasil selepas 3 minggu.',
    'formula.editor.s1.namaAria': 'Nama formula',
    'formula.editor.s1.namaPlaceholder': 'Serum Review — gaya sebelum & selepas',
    'formula.editor.s1.nota': 'Satu nama pendek yang anda sendiri kenal, dan satu ayat penerangan. Nama ialah satu-satunya medan wajib selain master prompt.',
    'formula.editor.s1.tajuk': 'Formula ini nak dipanggil apa?',
    'formula.editor.s2.amaran': 'Bentuk video dikunci selepas formula digunakan buat kali pertama. Bilangan set dan master prompt boleh ditukar bila-bila.',
    'formula.editor.s2.nanti': 'Nanti',
    'formula.editor.s2.nota': 'Pilihan ini menentukan dua perkara: robot mana yang berjalan dalam Google Flow, dan nama medan dalam kontrak output langkah seterusnya.',
    'formula.editor.s2.setLabel': 'Set setiap Generate',
    'formula.editor.s2.setNota': 'Setiap set jadi satu video. Tiga set patut menyerang dari tiga sudut berbeza.',
    'formula.editor.s2.tajuk': 'Video anda satu babak atau dua babak?',
    'formula.editor.s3.belumDiisi': 'Belum diisi',
    'formula.editor.s3.hintSatu': 'Satu arahan dipakai untuk kesemua {bil} set.',
    'formula.editor.s3.hintSetiap': '{bil} set = {bil} prompt berasingan.',
    'formula.editor.s3.kontrakBadge': 'Tetap',
    'formula.editor.s3.kontrakNota': 'Blok ini dicantum selepas prompt anda, setiap kali Generate. Anda tidak perlu menulisnya — dan tidak boleh membuangnya, kerana nama medan inilah yang dicari oleh robot Flow.',
    'formula.editor.s3.kontrakTajuk': 'Kontrak output yang sistem tambah',
    'formula.editor.s3.modSatu': 'Satu prompt',
    'formula.editor.s3.modSetiap': 'Setiap set',
    'formula.editor.s3.mulaContoh': 'Mula daripada contoh',
    'formula.editor.s3.mulaContohNota': 'Rangka siap yang boleh anda edit. Tukar watak, lokasi dan tone jadi milik anda.',
    'formula.editor.s3.nota': 'Ini otak formula anda: watak, gaya, jalan cerita, tone, hook, caption. AI akan ikut arahan ini untuk setiap produk yang anda lampirkan.',
    'formula.editor.s3.phSatu': 'Tulis arahan anda di sini — peranan, watak, lokasi, sudut cerita, gaya hook, gaya caption, pantang larang.',
    'formula.editor.s3.phSetiap': 'Arahan untuk Set {n} sahaja — sudut cerita yang berbeza daripada set lain.',
    'formula.editor.s3.promptPendek': 'Prompt pendek biasanya menghasilkan video generik. Rangka contoh lebih kurang 900 aksara.',
    'formula.editor.s3.setBelumDiisi': 'Set {senarai} belum diisi',
    'formula.editor.s3.tajuk': 'Tulis master prompt anda',
    'formula.editor.s4.hintUji': 'Satu produk contoh sahaja — produk anda tidak disentuh.',
    'formula.editor.s4.amaranProto': 'Prototaip: keputusan dan teks di atas ditulis dalam kod, bukan hasil AI daripada prompt anda.',
    'formula.editor.s4.barisGagal': 'prompt video kosong',
    'formula.editor.s4.barisOk': 'gambar · video · caption',
    'formula.editor.s4.barisOk2': 'gambar · video babak 1 · video babak 2 · caption',
    'formula.editor.s4.belumLulus': 'Belum lulus',
    'formula.editor.s4.betulkanSet': 'Betulkan Set {n}',
    'formula.editor.s4.butangUji': 'Uji formula · 1 kuota',
    'formula.editor.s4.captionTiktok': 'Caption TikTok',
    'formula.editor.s4.gagalNota': 'Satu set tidak menghasilkan prompt video.',
    'formula.editor.s4.hasilSet1': 'Hasil Set 1',
    'formula.editor.s4.kuotaNota': 'Setiap ujian guna 1 kuota Generate.',
    'formula.editor.s4.lengkap': 'lengkap',
    'formula.editor.s4.lulusNota': 'Semua medan wajib berisi, setiap set.',
    'formula.editor.s4.lulusNota2': 'Semua medan wajib berisi (termasuk dua babak video), setiap set.',
    'formula.editor.s4.nota': 'Ujian menjana satu produk contoh dan menyemak setiap medan wajib, setiap set. Ini yang menghalang prompt rosak daripada menjadi 20 minit Run Flow yang sia-sia. Ia memakan 1 kuota daripada 100 sehari.',
    'formula.editor.s4.promptGambar': 'Prompt gambar',
    'formula.editor.s4.promptVideo': 'Prompt video',
    'formula.editor.s4.promptVideo1': 'Prompt video · babak 1',
    'formula.editor.s4.promptVideo2': 'Prompt video · babak 2',
    'formula.editor.s4.sedangUji': 'Sedang menguji…',
    'formula.editor.s4.suisGagal': 'Prototaip: tunjuk keadaan GAGAL',
    'formula.editor.s4.tajuk': 'Cuba prompt anda pada satu produk',
    'formula.editor.s4.ujiSemula': 'Uji semula',
    'formula.editor.s5.huraianKosong': 'Penerangan anda muncul di sini.',
    'formula.editor.s5.kadMeta': '{babak} babak · {set} set per generate',
    'formula.editor.s5.lblBentuk': 'Bentuk video',
    'formula.editor.s5.lblMod': 'Mod prompt',
    'formula.editor.s5.lblNama': 'Nama',
    'formula.editor.s5.lblPanjang': 'Panjang prompt',
    'formula.editor.s5.lblSet': 'Set per Generate',
    'formula.editor.s5.lblUjian': 'Ujian',
    'formula.editor.s5.modSatu': 'Satu prompt semua set',
    'formula.editor.s5.modSetiap': 'Setiap set berasingan ({bil} prompt)',
    'formula.editor.s5.nilaiBabak': '{n} babak',
    'formula.editor.s5.nota': 'Selepas Simpan, anda terus dibawa ke Workspace dengan formula ini sudah dipilih — jadi boleh terus lampirkan produk dan tekan Generate.',
    'formula.editor.s5.rupaRak': 'Rupa pada rak',
    'formula.editor.s5.tajuk': 'Ini yang akan disimpan',
    'formula.editor.sekat.bentuk': 'Pilih satu bentuk video untuk teruskan.',
    'formula.editor.sekat.nama': 'Beri nama kepada formula ini untuk teruskan.',
    'formula.editor.sekat.prompt': 'Tulis master prompt anda, atau tekan "Mula daripada contoh".',
    'formula.editor.sekat.setKosong': 'Set {senarai} masih kosong — setiap set perlukan promptnya sendiri.',
    'formula.editor.sekat.ujiBelum': 'Jalankan ujian dahulu — ia menyemak prompt anda betul-betul menjana medan yang diperlukan.',
    'formula.editor.sekat.ujiGagal': 'Betulkan set yang gagal, kemudian uji semula.',
    'formula.editor.tajuk.draf': '· draf',
    'formula.editor.tajuk.kembali': 'Kembali ke rak Formulas',
    'formula.editor.tajuk.tanpaNama': 'Formula tanpa nama',
    'formula.empty.loading.body': 'Tunggu sebentar. Muat semula halaman kalau ia berterusan.',
    'formula.empty.loading.title': 'Memuatkan formula…',
    'formula.empty.noMatch.body': 'Kosongkan carian untuk melihat semua formula.',
    'formula.empty.noMatch.title': 'Tiada padanan untuk carian itu',
    'formula.engine.manual': 'Manual',
    'formula.engine.scene.many': '{n} scene',
    'formula.engine.scene.one': '1 scene',
    'formula.lock.maintenance': 'Formula ini sedang diselenggara.',
    'formula.lock.noAccess': 'Formula ini belum dibuka untuk akaun anda.',
    'formula.lock.trialUsed': 'Percubaan percuma anda telah habis. Dapatkan add-on untuk teruskan.',
    'formula.mine.badge.draft': 'Draf',
    'formula.mine.edit': 'Edit prompt',
    'formula.mine.intro': 'Formula anda tulis master prompt sendiri, dan ia berjalan atas robot yang sama seperti engine rasmi.',
    'formula.mine.meta': '{scene} babak · {set} set · {mode}',
    'formula.mine.mode.separate': 'prompt setiap set',
    'formula.mine.mode.single': 'satu prompt',
    'formula.mine.prototypeNote': 'Prototaip — dua kad di bawah data contoh.',
    'formula.mine.sample.f1.desc': 'Creator tunjuk kulit sebelum, kemudian hasil selepas 3 minggu.',
    'formula.mine.sample.f1.name': 'Serum Review saya',
    'formula.mine.sample.f2.desc': 'Buka kotak dengan reaksi berlebihan, kemudian demo guna.',
    'formula.mine.sample.f2.name': 'Unboxing lucu',
    'formula.mine.tip.draft': 'Formula draf perlu lulus ujian dahulu',
    'formula.mine.tip.use': 'Guna formula ini di Workspace',
    'formula.mine.untested': 'Belum diuji',
    'formula.mine.use': 'Guna',
    'formula.page.subtitle': 'Pilih resipi yang sudah terbukti, masukkan produk anda, kemudian run.',
    'formula.page.title': 'Formula',
    'formula.scope.community': 'Komuniti',
    'formula.scope.engine': 'Engine',
    'formula.scope.mine': 'Formula saya',
    'formula.search.placeholder': 'Cari formula',

    /* ── login ───────────────────────────────────────────────── */
    'login.backToLogin': 'Kembali ke Log Masuk',
    'login.contactAdminWa': 'Hubungi Admin melalui WhatsApp',
    'login.continueEmail': 'Teruskan dengan Emel',
    'login.continueGoogle': 'Teruskan dengan Google',
    'login.emailPlaceholder': 'Emel',
    'login.err.badCredentials': 'Emel atau kata laluan tidak sah.',
    'login.err.emailInUse': 'Emel ini sudah didaftarkan.',
    'login.err.emailNotFound': 'Emel tidak ditemui dalam sistem.',
    'login.err.googleDisabled': 'Log masuk Google belum diaktifkan buat masa ini. Sila guna emel dan kata laluan.',
    'login.err.googleFailed': 'Gagal log masuk dengan Google. Sila cuba lagi.',
    'login.err.invalidEmail': 'Sila masukkan emel yang sah.',
    'login.err.invalidPhone': 'Nombor WhatsApp tidak sah. Contoh: 0123456789 atau +60123456789',
    'login.err.linkFailed': 'Gagal menyambungkan akaun. Sila cuba lagi.',
    'login.err.loginFailed': 'Gagal log masuk. Sila semak maklumat anda.',
    'login.err.popupBlocked': 'Popup disekat oleh browser. Sila benarkan popup untuk laman ini dan cuba lagi.',
    'login.err.refRequired': 'Pendaftaran memerlukan pautan rujukan ejen affiliate. Sila hubungi admin.',
    'login.err.registerFailed': 'Gagal mendaftar. Sila cuba lagi.',
    'login.err.resetFailed': 'Gagal menghantar emel reset. Sila cuba lagi.',
    'login.err.tooManyAttempts': 'Terlalu banyak percubaan. Sila cuba sebentar lagi.',
    'login.err.tooManyRequests': 'Terlalu banyak permintaan. Sila cuba sebentar lagi.',
    'login.err.weakPassword': 'Kata laluan terlalu lemah. Minimum 6 aksara.',
    'login.err.wrongPassword': 'Kata laluan tidak sah.',
    'login.existingPasswordPlaceholder': 'Kata laluan akaun sedia ada',
    'login.feature.autoContent': 'Auto Content',
    'login.feature.autoContentDesc': 'Generate caption, gambar dan video secara automatik dengan AI.',
    'login.feature.more': 'Dan banyak lagi',
    'login.feature.moreDesc': 'Terokai alat yang dibina untuk menjimatkan masa dan memacu pertumbuhan anda.',
    'login.feature.multiPlatform': 'Multi Platform',
    'login.feature.multiPlatformDesc': 'Post ke TikTok, Instagram, Facebook dan lain-lain daripada satu tempat.',
    'login.feature.scheduling': 'Smart Scheduling',
    'login.feature.schedulingDesc': 'Jadualkan post anda lebih awal — biarkan SESAAT uruskan selebihnya.',
    'login.forgot': 'Lupa Kata Laluan?',
    'login.haveAccount': 'Sudah ada akaun?',
    'login.headlineLine1': 'Create, Generate & Post',
    'login.headlineLine2': '— Automatically',
    'login.linkDesc': 'Emel {emel} sudah mempunyai akaun. Masukkan kata laluan anda untuk menyambungkan log masuk Google.',
    'login.linkSubmit': 'Sambung & Log Masuk',
    'login.linkTitle': 'Sambungkan Akaun Google',
    'login.login': 'Log Masuk',
    'login.noAccount': 'Belum ada akaun?',
    'login.or': 'atau',
    'login.passwordPlaceholder': 'Kata Laluan',
    'login.refMissingDesc': 'Pendaftaran SESAAT memerlukan pautan rujukan daripada ejen affiliate. Sila hubungi admin untuk mendapatkan pautan.',
    'login.refMissingTitle': 'Tiada pautan rujukan ejen',
    'login.refOk': 'Anda dirujuk oleh ejen: {kod}',
    'login.register': 'Daftar',
    'login.registerLocked': 'Daftar (perlu pautan ejen)',
    'login.registerTitle': 'Daftar Akaun Baharu',
    'login.resetDesc': 'Masukkan emel anda dan kami akan menghantar pautan reset.',
    'login.resetSent': 'Emel reset telah dihantar. Sila semak inbox anda.',
    'login.resetTitle': 'Reset Kata Laluan',
    'login.sendReset': 'Hantar Emel Reset',
    'login.showcaseDesc': 'Dibina oleh penjual untuk penjual — menjana content produk, caption, skrip video dan banyak lagi.',
    'login.showcaseTitle': 'Automate Your Content',
    'login.terms': 'Dengan meneruskan, anda bersetuju dengan Terma Perkhidmatan & Dasar Privasi SESAAT.',
    'login.whatsappNote': 'Kami akan menggunakan WhatsApp untuk menghantar peringatan pembaharuan pakej.',
    'login.whatsappPlaceholder': 'No. WhatsApp (cth: 0123456789)',

    /* ── notes ───────────────────────────────────────────────── */
    'notes.addNote': 'Tambah nota',
    'notes.bodyPlaceholder': 'Tulis nota atau tampal link…',
    'notes.clearSearch': 'Kosongkan carian',
    'notes.confirmDelete': 'Padam nota ini?',
    'notes.copyLine': 'Salin baris',
    'notes.copyTitle': 'Salin tajuk',
    'notes.deleteNote': 'Padam nota',
    'notes.editNote': 'Edit nota',
    'notes.emptyDesc': 'Simpan hook, caption dan tetapan yang anda guna berulang kali di satu tempat.',
    'notes.emptyTitle': 'Belum ada nota',
    'notes.errAdd': 'Nota tidak dapat disimpan. Sila cuba lagi.',
    'notes.errDelete': 'Nota tidak dapat dipadam. Sila cuba lagi.',
    'notes.errUpdate': 'Nota tidak dapat dikemas kini. Sila cuba lagi.',
    'notes.filter.all': 'Semua ({n})',
    'notes.filter.pinned': 'Disemat ({n})',
    'notes.filter.quick': 'Quick Notes ({n})',
    'notes.more': 'Lagi',
    'notes.newNote': 'Nota baharu',
    'notes.noMatchPinned': 'Belum ada nota disemat. Tekan ikon pin pada mana-mana nota untuk mengekalkannya di bahagian atas.',
    'notes.noMatchQuick': 'Belum ada nota ditanda sebagai Quick Note. Tekan ikon kilat pada mana-mana nota untuk menandakannya.',
    'notes.noMatchSearch': 'Tiada nota mengandungi perkataan itu. Sila cuba perkataan lain, atau kosongkan carian.',
    'notes.noMatchTitle': 'Tiada nota sepadan',
    'notes.openMenu': 'Buka menu',
    'notes.pin': 'Pin',
    'notes.pinHint': 'Pin — nota ini kekal di bahagian atas senarai',
    'notes.pinnedSection': 'Disemat',
    'notes.pinNote': 'Pin nota',
    'notes.planNote': 'Pelan · /notes-v3.9',
    'notes.quickAdd': 'Tambah ke Quick Notes',
    'notes.quickAddHint': 'Tambah ke Quick Notes — nota ini muncul dalam panel Workspace semasa anda mengedit prompt',
    'notes.quickHint': 'Quick Notes — nota ini muncul dalam panel Workspace semasa anda mengedit prompt',
    'notes.quickNotes': 'Quick Notes',
    'notes.quickRemove': 'Buang daripada Quick Notes',
    'notes.quickRemoveHint': 'Buang daripada Quick Notes — nota ini berhenti muncul semasa anda mengedit prompt',
    'notes.search': 'Cari nota',
    'notes.time.days': '{n} hari lalu',
    'notes.time.hours': '{n} jam lalu',
    'notes.time.minutes': '{n} min lalu',
    'notes.time.now': 'baru sahaja',
    'notes.time.yesterday': 'semalam',
    'notes.title': 'Nota',
    'notes.titlePlaceholder': 'Tajuk (pilihan)',
    'notes.unpin': 'Buang pin',
    'notes.untitled': 'Tanpa tajuk',

    /* ── pricing ─────────────────────────────────────────────── */
    'pricing.bonus.boost': 'Sesaat BOOST — senarai produk & seller yang run GMV MAX dari 3 MCN/TAP',
    'pricing.bonus.title': 'Bonus',
    'pricing.cta.renewSmart': 'Renew — RM99',
    'pricing.cta.subscribePrice': 'Langgan — RM{harga}',
    'pricing.cta.subscribeSmart': 'Langgan — RM99',
    'pricing.cta.upgradeSmart': 'Naik taraf ke Premium — RM100',
    'pricing.cta.upgradeSmartNote': 'Bayar sekali. Tempoh langganan anda kekal seperti sedia ada.',
    'pricing.flowUltra.detailLink': 'lihat butiran',
    'pricing.flowUltra.freeGpts': 'Percuma GPTS / Gems TTS & TPS',
    'pricing.flowUltra.oneMonth': 'RM100 ini untuk 1 bulan akses Flow Ultra sahaja',
    'pricing.row.aiIncluded': 'AI SESAAT disediakan',
    'pricing.row.cloudVideoPerDay': 'Video simpan cloud / hari',
    'pricing.row.ownFormula': 'Create Your Own Formula',
    'pricing.tier.browser3': '3 browser untuk run 3 akaun TikTok',
    'pricing.tier.browser6': '6 browser untuk run 6 akaun TikTok',
    'pricing.tier.fighter.priceNote': 'Bayar sekali untuk 12 bulan',
    'pricing.tier.premium.demo': 'Tengok demo Premium',
    'pricing.tier.premium.p1': 'Termasuk SMART — connect GPT / Gems anda sendiri',
    'pricing.tier.premium.p2': 'Boleh "Create Your Own Formula"',
    'pricing.tier.premium.p3': '4 module siap pakai, tak perlu GPT sendiri',
    'pricing.tier.premium.p4': '100 generate sehari (300 video)',
    'pricing.tier.premium.subNew': 'AI kami yang tulis untuk anda',
    'pricing.tier.smart.demo': 'Tengok demo SMART',
    'pricing.tier.smart.h1': 'Connect GPT / Gems anda sendiri',
    'pricing.tier.smart.h3': 'Flow automation (gambar + video)',
    'pricing.tier.smart.h4': 'TikTok automation (direct / draft schedule)',
    'pricing.tier.smart.h5': '300 video simpan cloud setiap hari',
    'pricing.tier.smart.h6': 'Group Support (WhatsApp)',
    'pricing.tier.smart.priceNote': 'RM99 setiap bulan · tiada bayaran masuk',
    'pricing.tier.smart.sub': 'Anda dah ada GPT atau Gems sendiri',
    'pricing.toggle.monthly': 'Bulanan',
    'pricing.toggle.yearly': 'Tahunan · jimat RM389',
    'pricing.val.ownGpt': 'GPT / Gems sendiri',
    'pricing.flowUltra.bonusCta': 'Klik untuk butiran penuh',
    'pricing.flowUltra.bonusGone': 'Bonus 50 orang terawal telah habis',
    'pricing.flowUltra.bonusLeft': 'Tinggal {baki} / {jumlah}',
    'pricing.flowUltra.bonusTitle': 'Bonus 50 orang terawal',
    'pricing.smartPick.ai8saat': 'Video 1 babak, terus siap',
    'pricing.smartPick.goyang': 'Video guna template GOYANG',
    'pricing.smartPick.semasa': 'Module tambahan anda sekarang. Ia kekal apabila anda menyambung langganan.',
    'pricing.smartPick.info': 'Setiap pelanggan SMART memilih satu semasa mendaftar.',
    'pricing.smartPick.sub': 'Pakej SMART termasuk satu module siap pakai. Pilih satu — ia dibuka sebaik bayaran disahkan.',
    'pricing.smartPick.title': 'Pilih 1 module tambahan',
    'pricing.smartPick.wajib': 'Pilih satu module dahulu sebelum meneruskan.',
    'pricing.tier.smart.h7': '1 module siap pakai — pilih AI8SAAT atau GOYANG',
    'pricing.val.ownGptPlus': 'GPT / Gems sendiri + 1 module',
    'pricing.val.pilihSatu': 'Pilih 1',
    'pricing.bonus.toukey': 'Akses Toukey Viral (AIT Fighter).',
    'pricing.badge.popular': 'Popular',
    'pricing.compare.hide': 'Sembunyikan perbandingan',
    'pricing.compare.show': 'Bandingkan semua pakej',
    'pricing.cta.continue': 'Teruskan',
    'pricing.cta.continuePrice': 'Teruskan — RM{harga}',
    'pricing.cta.currentPlan': 'Pelan Semasa',
    'pricing.cta.renew': 'Renew',
    'pricing.cta.renewPrice': 'Renew — RM99',
    'pricing.cta.subscribe': 'Langgan',
    'pricing.cta.subscribePremium': 'Langgan — RM199',
    'pricing.cta.subscribePremiumUltra': 'Langgan — RM299',
    'pricing.flowUltra.b1': 'Akaun Google Flow Ultra (sharing) — ada waranti',
    'pricing.flowUltra.b2': 'Guna mode "Lite (Lower Priority)" sahaja — 0 kredit, video tanpa had',
    'pricing.flowUltra.b3': 'Login 1 device sahaja',
    'pricing.flowUltra.b4': 'Tidak dibenarkan guna kredit / mode lain (Omni, Fast, Quality)',
    'pricing.gate.closedLabel': 'Ditutup Sementara',
    'pricing.gate.closedNote': 'Pendaftaran pelanggan baharu ditutup sementara. Pelanggan sedia ada boleh menyambung langganan seperti biasa.',
    'pricing.perMonth': '/bulan',
    'pricing.row.browserPerAccount': 'Browser / akaun TikTok',
    'pricing.row.generationsPerDay': 'Generation / hari',
    'pricing.row.support': 'Sokongan',
    'pricing.row.videoOutputPerDay': 'Output video / hari',
    'pricing.section.modules': 'Modul',
    'pricing.section.toolsSupport': 'Tools & Sokongan',
    'pricing.section.usage': 'Penggunaan',
    'pricing.tier.fighter.h1': '6 browser untuk 6 akaun TikTok',
    'pricing.tier.fighter.h2': 'Akses GOYANG, SMART & FLOWNITY',
    'pricing.tier.fighter.h3': 'Bayaran tahunan — jimat RM389',
    'pricing.tier.fighter.intro': 'Semua dalam Premium, plus:',
    'pricing.tier.fighter.period': 'setahun',
    'pricing.tier.fighter.sub': 'Semua modul · 6 browser',
    'pricing.tier.premium.h1': '3 browser untuk 3 akaun TikTok',
    'pricing.tier.premium.h2': '100 generate sehari (300 video sehari)',
    'pricing.tier.premium.h5': 'Group Support (Whatsapp)',
    'pricing.tier.premium.period': 'bulan pertama',
    'pricing.tier.premium.priceNote': 'RM99 renew setiap bulan',
    'pricing.tier.premium.sub': 'Semua modul · 3 browser',
    'pricing.val.notAvailable': 'Tidak Disediakan',
    'pricing.val.whatsappGroup': 'Group Whatsapp',

    /* ── products ────────────────────────────────────────────── */
    'products.action.cancel': 'Batal',
    'products.action.close': 'Tutup',
    'products.action.closeTooltip': 'Close',
    'products.action.processing': 'Memproses…',
    'products.action.save': 'Simpan',
    'products.action.saving': 'Menyimpan…',
    'products.actions': 'Tindakan',
    'products.addToWorkspace': 'Tambah ke Workspace',
    'products.admin.genIntel': 'Generate Intelligence',
    'products.admin.genIntelTooltip': 'Run Stage 1 (vision) + Stage 2 (research) — admin pre-cache',
    'products.admin.regenIntel': 'Re-Generate Intelligence',
    'products.admin.regenIntelTooltip': 'Re-generate (bypass cache) — bayar lagi sekali',
    'products.alert.addGroupFailed': 'Gagal tambah kumpulan: {ralat}',
    'products.alert.addManualFailed': 'Gagal tambah produk: {ralat}',
    'products.alert.addToMineFailed': 'Gagal tambah ke My Products: {ralat}',
    'products.alert.assignGroupFailed': 'Gagal assign kumpulan: {ralat}',
    'products.alert.bulkDeleteFailed': 'Gagal padam bulk: {ralat}',
    'products.alert.bulkUploadFailed': 'Gagal bulk upload: {ralat}',
    'products.alert.confirmDeleteProduct': 'Padam produk ini?',
    'products.alert.deleteGroupFailed': 'Gagal padam kumpulan: {ralat}',
    'products.alert.groupNameExists': 'Nama kumpulan sudah wujud.',
    'products.alert.invalidJson': 'JSON format tidak valid! Sila semak semula.',
    'products.alert.moveToGroupFailed': 'Gagal move ke group: {ralat}',
    'products.alert.renameGroupFailed': 'Gagal rename kumpulan: {ralat}',
    'products.alert.replaceImageFailed': 'Gagal ganti gambar: {ralat}',
    'products.alert.saveFailed': 'Gagal simpan: {ralat}',
    'products.bulk.clearing': 'Clearing...',
    'products.bulk.clearIntel': 'Clear Intel',
    'products.bulk.clearIntelTitle': 'Clear intelligence cache (admin only) — reset hasIntelligence + remove cached JSON',
    'products.bulk.copyNTo': 'Salin {n} ke:',
    'products.bulk.deleteN': 'Delete ({n})',
    'products.bulk.moveNTo': 'Pindah {n} ke:',
    'products.bulk.moveToGroup': 'Move to group',
    'products.bulk.moveToGroupTitle': 'Move selected products to a group',
    'products.bulk.moving': 'Moving...',
    'products.bulk.noGroupsForProfile': 'Akaun ini belum ada group. Cipta group melalui butang Group.',
    'products.bulk.noGroupsYet': 'Tiada group dicipta lagi.',
    'products.bulk.processing': 'Memproses…',
    'products.bulk.profile': 'Profile',
    'products.bulk.profileTitle': 'Pindah atau salin produk terpilih ke profile TikTok',
    'products.bulk.removeGroup': 'Remove group',
    'products.bulk.sendCapped': 'Maksimum {n} produk dihantar ke Workspace pada satu masa. {n} pertama dihantar — teruskan baki selepas ini.',
    'products.bulk.sendChanged': 'Tiada produk dihantar. Produk berikut sudah berubah selepas halaman ini dibuka (dipadam, atau kini PENDING):\n{nama}\n\nMuat semula halaman ini, kemudian cuba lagi.',
    'products.bulk.sendFailed': 'Gagal menghantar produk ke Workspace: {ralat}. Cuba lagi.',
    'products.bulk.sendMore': 'dan {n} lagi',
    'products.bulk.sendPending': 'Tiada produk dihantar. Produk berikut dalam pilihan masih PENDING (data produk belum lengkap):\n{nama}\n\nBuang tanda pada produk PENDING, atau lengkapkan datanya dahulu, kemudian tekan Hantar ke Workspace semula.',
    'products.bulk.sendToWorkspace': 'Hantar ke Workspace',
    'products.bulk.sendToWorkspaceTitle': 'Hantar produk terpilih ke Workspace',
    'products.bulk.tipEscClear': '{kekunci} to clear',
    'products.bulk.tipShiftRange': 'Tip: {kekunci} + click to select range',
    'products.bulk.unselectAll': 'Unselect all',
    'products.bulk.selectPage': 'Pilih halaman ({n})',
    'products.bulk.selectAllN': 'Pilih semua {n}',
    'products.bulkDelete.confirmBtn': 'Delete {n} Products',
    'products.bulkDelete.deleting': 'Deleting...',
    'products.bulkDelete.msgAll': 'You are about to delete {n} products. This action cannot be undone.',
    'products.bulkDelete.msgGroup': 'You are about to delete {n} products in group "{group}". This action cannot be undone.',
    'products.bulkDelete.msgNoGroup': 'You are about to delete {n} products in "No Group". This action cannot be undone.',
    'products.bulkDelete.title': 'Delete Products?',
    'products.bulkUpload.emptyHint': 'Sila masukkan data',
    'products.bulkUpload.formatExample': 'No *|* Nama Product *|* Image URL *|* Link',
    'products.bulkUpload.formatLabel': 'Format:',
    'products.bulkUpload.formatNote': 'Atau cukup tulis nama product sahaja (1 per baris). No. akan auto-generate.',
    'products.bulkUpload.linesDetected': '{n} baris dikesan',
    'products.bulkUpload.placeholder': '1 *|* Product Name A *|* https://image.url *|* https://link.url\n2 *|* Product Name B\n3 *|* Product Name C *|* https://image.url\n\nAtau tulis nama sahaja:\nProduct Name X\nProduct Name Y',
    'products.bulkUpload.submit': 'Upload',
    'products.bulkUpload.subtitle': 'Masukkan satu produk per baris',
    'products.bulkUpload.title': 'Bulk Upload Products',
    'products.bulkUpload.uploading': 'Sedang Upload...',
    'products.card.addToMine': 'Tambah ke My Products',
    'products.card.alreadyInMine': 'Dah ada dalam My Products',
    'products.card.completeData': 'Lengkapkan Data',
    'products.card.completeProductData': 'Lengkapkan data produk',
    'products.card.copyData': 'Copy product data',
    'products.card.copyScrapeSource': 'Salin link sumber scrape',
    'products.card.copyShowcase': 'Salin link showcase',
    'products.card.discountLabel': 'Diskaun',
    'products.card.editProduct': 'Edit produk',
    'products.card.editProductData': 'Edit data produk',
    'products.card.fillDataTooltip': 'Taip sendiri data produk ini',
    'products.card.genPrompt': 'Generate Prompt',
    'products.card.genPromptTooltip': 'Powered by OpenAI GPT-5 Mini',
    'products.card.idTooltip': 'ID produk TikTok',
    'products.card.intelPartialTitle': 'Stage 1 atau 2 gagal sebahagian',
    'products.card.intelPendingTooltip': 'Belum ada Intelligence Data',
    'products.card.intelReadyTooltip': 'Intelligence Data Ready',
    'products.card.noName': '(No name)',
    'products.card.originalLabel': 'Asal',
    'products.card.pasteIntel': 'Paste Intelligence JSON',
    'products.card.pending': 'Pending',
    'products.card.priceLabel': 'Harga',
    'products.card.ready': 'Ready',
    'products.card.replaceImage': 'Ganti gambar',
    'products.card.scrapeSource': 'Sumber scrape',
    'products.card.scrapeSourceTooltip': 'Sumber scrape — {url}',
    'products.card.select': 'Select',
    'products.card.selectForIntel': 'Select for intel generation',
    'products.card.showcase': 'Showcase',
    'products.card.showcaseTooltip': 'Showcase — {link}',
    'products.card.soon': 'SOON',
    'products.card.tiktokIdTooltip': 'ID produk TikTok',
    'products.card.unselect': 'Unselect',
    'products.card.uploading': 'Uploading...',
    'products.card.viewIntel': 'Lihat Intelligence Data',
    'products.card.viewScraped': 'Lihat Scraped Data',
    'products.cell.clickToType': '{label} — klik untuk taip',
    'products.changeGroup': 'Tukar kumpulan',
    'products.clearIntel.clearing': 'Clearing...',
    'products.clearIntel.confirmBtn': 'Clear Intel for {n} Products',
    'products.clearIntel.msg': 'You are about to clear cached intelligence (Stage 1+2) for {n} products.',
    'products.clearIntel.note': 'Produk masih wujud — hanya cache intelligence yang dibuang. Re-generate akan call API balik (~${kos} kos).',
    'products.clearIntel.title': 'Clear Intelligence?',
    'products.clearSelection': 'Batal pilihan',
    'products.col.creator14': 'Creator 14H',
    'products.col.creator7': 'Creator 7H',
    'products.col.discount': 'Diskaun',
    'products.col.gmv': 'GMV (Max)',
    'products.col.gmvShort': 'GMV',
    'products.col.group': 'Kumpulan',
    'products.col.id': 'ID',
    'products.col.original': 'Asal',
    'products.col.price': 'Harga',
    'products.col.product': 'Produk',
    'products.complete.closeAria': 'Tutup',
    'products.complete.descHint': 'Tiada had panjang — lagi banyak butiran yang anda beri, lagi baik skrip video yang dihasilkan.',
    'products.complete.descPlaceholder': 'Taip atau salin keterangan produk di sini — ciri-ciri, kelebihan, bahan, saiz, cara guna…',
    'products.complete.imgHint': 'Tampal pautan gambar, atau tekan Upload untuk memilih gambar daripada peranti anda.',
    'products.complete.shopeeHint': 'Untuk Facebook Reels — tampal link affiliate Shopee anda. Boleh dibiar kosong buat masa ini.',
    'products.complete.imgNotImage': 'Fail itu bukan gambar. Sila pilih fail JPG atau PNG.',
    'products.complete.imgPending': 'akan dimuat naik semasa Simpan',
    'products.complete.imgRemove': 'Buang',
    'products.complete.imgTooBig': 'Gambar terlalu besar — maksimum 5 MB.',
    'products.complete.extraLabel': 'Gambar tambahan untuk Flow',
    'products.complete.extraHint': 'Sehingga {max} gambar tambahan. Flow memakai kesemuanya sebagai rujukan supaya produk keluar tepat. Pilih dari galeri TikTok (tanpa muat naik) atau muat naik dari peranti anda.',
    'products.complete.extraGallery': 'Galeri TikTok ({n})',
    'products.complete.extraUpload': 'Upload',
    'products.complete.extraFull': 'Had dicapai — buang satu gambar dahulu.',
    'products.complete.extraPickHint': 'Tekan gambar untuk tambah atau buang. Tekan ikon kanta untuk lihat saiz besar.',
    'products.complete.extraDone': 'Selesai',
    'products.complete.extraPending': 'Fail yang dipilih akan dimuat naik semasa Simpan.',
    'products.complete.kad.skopTitle': 'Guna perubahan pada',
    'products.complete.kad.skopSemua': 'Semua kad + My Products',
    'products.complete.kad.skopKad': 'Kad ini sahaja',
    'products.complete.kad.skopHintSemua': 'Item My Products dikemas kini, dan semua kad produk ini di Workspace ikut berubah.',
    'products.complete.kad.skopHintKad': 'Hanya kad ini berubah. My Products dan kad lain tidak disentuh.',
    'products.complete.kad.notisSystem': 'Produk ini datang dari System. Simpan akan menyalinnya ke My Products anda — pilih tempat menyimpannya di bawah.',
    'products.complete.kad.notisBaru': 'Produk ini belum ada dalam My Products. Simpan akan menambahnya — pilih tempat menyimpannya di bawah.',
    'products.complete.kad.notisTiadaLink': 'Kad ini tiada link TikTok, jadi ia tidak dapat dipadankan dengan My Products. Perubahan hanya terpakai pada kad ini.',
    'products.complete.kad.notisShopee': 'Produk Shopee — data di bawah diambil dari My Products anda. Perubahan hanya terpakai pada kad ini.',
    'products.complete.sah.tajuk': 'Perubahan ini melibatkan {n} tempat',
    'products.complete.sah.tajukSemua': 'Perubahan ini melibatkan My Products dan semua kad produk ini',
    'products.complete.sah.item': 'Item ini dalam My Products',
    'products.complete.sah.itemBaru': 'Item baharu ditambah ke My Products',
    'products.complete.sah.kad': 'Kad ini + {n} kad lain produk yang sama',
    'products.complete.sah.kadSemua': 'Kad ini dan semua kad lain produk yang sama',
    'products.complete.sah.nota': 'Gambar, link, harga dan data produk pada semua tempat di atas akan diganti. Nama kad lain tidak berubah.',
    'products.complete.sah.ya': 'Ubah My Products + semua {n} kad',
    'products.complete.sah.yaSemua': 'Ubah My Products + semua kad produk ini',
    'products.complete.sah.yaBaru': 'Tambah ke My Products + ubah semua {n} kad',
    'products.complete.sah.yaBaruSemua': 'Tambah ke My Products + ubah semua kad produk ini',
    'products.complete.sah.kadSahaja': 'Ubah kad ini sahaja',
    'products.complete.kad.profil': 'Profile',
    'products.complete.kad.group': 'Group',
    'products.complete.kad.tiadaProfil': 'Tiada profile',
    'products.complete.kad.tiadaGroup': 'Tiada group',
    'products.complete.kad.gagalKad': 'Disimpan ke My Products, tetapi kad Workspace tidak dapat dikemas kini. Buka Edit data sekali lagi dan tekan Simpan semula.',
    'products.complete.lbl.detail': 'Butiran Produk',
    'products.complete.lbl.nama': 'Nama Produk',
    'products.complete.lbl.gambar': 'Gambar Produk',
    'products.complete.lbl.tiktok': 'Link TikTok',
    'products.complete.lbl.nombor': 'Nombor',
    'products.complete.status.ready': "Cukup — produk ini READY dan boleh run di Workspace.",
    'products.complete.status.notReady': "Belum cukup — produk ini PENDING dan belum boleh run di Workspace.",
    'products.complete.chk.nama': "Name",
    'products.complete.chk.gambar': "Image",
    'products.complete.chk.link': "Product link",
    'products.complete.sek.produk': "Product",
    'products.complete.sek.linkHarga': "Links and price",
    'products.complete.lbl.linkGambar': "Image link",
    'products.complete.linksHint': "Satu link sudah memadai. Link TikTok untuk beg kuning TikTok, link Shopee untuk Facebook Reels.",
    'products.complete.extraGalleryShopee': "Galeri Shopee ({n})",
    'products.complete.extraHintUmum': "Sehingga {max} gambar tambahan. Flow memakai kesemuanya sebagai rujukan supaya produk keluar tepat. Pilih dari galeri produk (tanpa muat naik) atau muat naik dari peranti anda.",
    'products.complete.butiran.tajuk': "Butiran tambahan untuk skrip yang lebih tajam",
    'products.complete.butiran.kira': "{n} daripada {total} diisi",
    'products.complete.kakiNota': "Perubahan dipakai pada generate yang seterusnya.",
    'gbrBesar.galeriShopee': "Galeri Shopee",
    'products.complete.lbl.links': 'Product Links',
    'products.complete.linkTiktokHint': 'Link produk TikTok Shop — diperlukan untuk beg kuning TikTok.',
    'products.complete.sumber.pill': 'Data produk di-scrape dari {platform}',
    'products.complete.sumber.short': 'Sumber: {platform}',
    'products.complete.lbl.shopee': 'Link Affiliate Shopee',
    'products.complete.lbl.harga': 'Harga',
    'products.complete.lbl.hargaAsal': 'Harga Asal',
    'products.complete.lbl.diskaun': 'Diskaun',
    'products.complete.lbl.skrip': 'Data Skrip',
    'products.complete.lbl.desc': 'Penerangan',
    'products.complete.lbl.kategori': 'Kategori',
    'products.complete.lbl.jenama': 'Jenama',
    'products.complete.lbl.kedai': 'Nama Kedai',
    'products.complete.lbl.rating': 'Rating',
    'products.complete.lbl.ratingCount': 'Bilangan Rating',
    'products.complete.lbl.terjual': 'Bilangan Terjual',
    'products.complete.lbl.variasi': 'Variasi',
    'products.complete.lbl.kelebihan': 'Kelebihan',
    'products.complete.lbl.spek': 'Spesifikasi',
    'products.complete.lbl.ulasan': 'Ulasan Pelanggan',
    'products.complete.lbl.idProduk': 'ID Produk (link TikTok)',
    'products.complete.lbl.namaPh': 'Nama produk',
    'products.complete.intro.edit': 'Maklumat di bawah ialah bahan yang digunakan untuk menghasilkan skrip video produk ini. Anda boleh membetulkan atau menambah butiran bila-bila masa — perubahan hanya digunakan pada generate yang seterusnya, skrip yang sudah dihasilkan tidak berubah.',
    'products.complete.intro.fill': 'Sesetengah penjual meletakkan keterangan produk di dalam gambar sahaja, jadi maklumat itu tidak dapat diambil secara automatik. Sila taip semula maklumat tersebut di sini. Selepas disimpan, produk ini terus boleh digunakan.',
    'products.complete.priceNote': 'Harga ini dipakai pada kad DAN dalam skrip video — satu tempat sahaja, jadi ia tidak boleh jadi berbeza.',
    'products.complete.bonusNote': 'Medan di atas tidak wajib. Setiap satu yang diisi dihantar kepada AI dan menajamkan skrip video anda.',
    'products.complete.saveFailed': 'Gagal menyimpan. Sila cuba sekali lagi.',
    /* Tiada emoji — v3.9 monokrom; amaran dibawa oleh warna, bukan ikon. */
    'products.complete.status.downgrade': 'Belum cukup — produk ini akan turun semula ke PENDING selepas disimpan.',
    'products.complete.status.readyBecome': 'Cukup — produk ini akan bertukar READY selepas disimpan.',
    'products.complete.status.readyKeep': 'Cukup — produk ini kekal READY selepas disimpan.',
    'products.complete.status.stayPending': 'Belum cukup — produk masih kekal PENDING selepas disimpan.',
    'products.complete.title.edit': 'Data Produk',
    'products.complete.title.fill': 'Data Produk',
    'products.confirm.deleteGroup': 'Padam kumpulan ini? Produk dalam kumpulan ini tidak akan terpadam, tapi akan jadi tidak berkumpulan.',
    'products.copyToMine': 'Salin ke Milik Saya',
    'products.countPending': '{n} pending',
    'products.countReady': '{n} ready',
    'products.countTotal': '{n} Total',
    'products.delete': 'Padam',
    'products.edit.discountPlaceholder': 'Diskaun',
    'products.edit.linkPlaceholder': 'Link TikTok Shop',
    'products.edit.namePlaceholder': 'Nama produk',
    'products.edit.numberPlaceholder': 'No. / Product ID',
    'products.edit.originalPlaceholder': 'Asal',
    'products.edit.priceHint': '💡 Auto-prefill dari scrape. Harga + diskaun akan diinject ke prompt skrip (cth fragment hook TIBA-TIBA). Pastikan tepat.',
    'products.edit.pricePlaceholder': 'Harga',
    'products.empty.adminDesc': 'Klik "Bulk Upload" untuk menambah produk secara pukal.',
    'products.empty.bulkUploadCta': 'Bulk Upload Products',
    'products.empty.filterDesc': 'Tiada produk dalam kategori ini',
    'products.empty.noneTitle': 'Belum Ada Produk',
    'products.empty.notFoundTitle': 'Tiada Produk Dijumpai',
    'products.empty.ownDesc': 'Belum ada My Products. Tambah produk anda sendiri.',
    'products.empty.searchDesc': 'Tiada produk sepadan dengan "{carian}"',
    'products.empty.systemDesc': 'Admin belum menambah produk lagi.',
    'products.emptyImport': 'Import produk daripada TikTok Shop untuk bermula.',
    'products.emptySearch': 'Kosongkan carian untuk melihat semua.',
    'products.emptyTitle': 'Tiada produk di sini',
    'products.folders.editNameTitle': 'Edit nama folder',
    'products.folders.emptyDesc': 'Library akan di-setup oleh admin.',
    'products.folders.emptyTitle': 'Tiada Folder',
    'products.folders.noDescription': 'No description',
    'products.folders.subtitle': 'Pusat sumber kongsi — akses data produk, hook, eCourse dan lain-lain',
    'products.folders.title': 'Library',
    'products.group.all': 'Semua Group',
    'products.group.fallbackName': 'Group',
    'products.group.moveGroupTitle': 'Pindah semua produk dalam group ini ke satu profile',
    'products.group.moveGroupToProfile': 'Pindah group ke profile',
    'products.group.none': 'Tiada Group',
    'products.group.pick': 'Pilih Group',
    'products.groups.addBtn': 'Tambah',
    'products.groups.addNewTitle': 'Tambah Group Baru',
    'products.groups.deleteTooltip': 'Padam kumpulan',
    'products.groups.empty': 'Belum ada kumpulan. Cipta kumpulan pertama di bawah.',
    'products.groups.namePlaceholder': 'Nama kumpulan (cth: Pakaian)',
    'products.groups.newForProfile': 'Group ini milik akaun: {nama}',
    'products.groups.newShared': 'Tiada akaun dipilih — group ini akan berkongsi (tiada akaun). Pilih satu akaun dahulu untuk group khas akaun.',
    'products.groups.productCount': '{n} produk',
    'products.groups.renameTooltip': 'Rename kumpulan',
    'products.groups.subtitle': 'Cipta kumpulan untuk asingkan produk mengikut kategori',
    'products.groups.title': 'Urus Group Produk',
    'products.import': 'Import products',
    'products.intel.clear': 'Clear',
    'products.intel.clearData': 'Padam Intelligence Data',
    'products.intel.clearFailed': 'Gagal clear intelligence: {ralat}',
    'products.intel.confirmRegenerate': 'Re-generate intelligence untuk "{nama}"?\n\nIni akan replace cache sedia ada (cost ~${kos}).',
    'products.intel.copyJson': 'Copy JSON',
    'products.intel.editSubtitle': 'Paste data Intelligence (format JSON)',
    'products.intel.editTitle': 'Intelligence JSON — #{no} {nama}',
    'products.intel.errors': '({n} error)',
    'products.intel.generateN': 'Generate ({n})',
    'products.intel.jsonInvalid': 'JSON tidak valid',
    'products.intel.jsonValid': 'JSON valid',
    'products.intel.loading': 'Memuatkan intelligence data...',
    'products.intel.loadingExisting': 'Memuatkan intelligence sedia ada...',
    'products.intel.noneWithIntel': 'Tiada produk yang ada intelligence dalam selection. Pilih produk yang ada badge READY.',
    'products.intel.progress': 'Generating intelligence — {siap}/{jumlah} done',
    'products.intel.regenerate': 'Re-Generate',
    'products.intel.regenTitle': 'Resubmit — bypass cache & re-generate (cost lagi sekali)',
    'products.intel.running': '({n} running)',
    'products.intel.selectAllPending': 'Select all pending',
    'products.intel.status.done': 'Done',
    'products.intel.status.failed': 'Failed',
    'products.intel.status.generating': 'Generating',
    'products.intel.status.partial': 'Partial',
    'products.intel.status.queued': 'Queued',
    'products.intel.stop': 'Stop',
    'products.intel.viewSubtitle': 'Data Intelligence untuk generate prompt',
    'products.intel.viewTitle': 'Intelligence Data — #{no} {nama}',
    'products.intelBulk.cacheHit': 'Cache hit (skip, free)',
    'products.intelBulk.estCost': 'Anggaran kos (USD)',
    'products.intelBulk.noteForce': 'Mode resubmit — bypass cache. Setiap item akan call OpenAI walau dah ada intelligence.',
    'products.intelBulk.noteNormal': 'Parallel max {n} concurrent. Boleh Stop bila-bila masa.',
    'products.intelBulk.run': 'Generate Sekarang',
    'products.intelBulk.runForce': 'Re-Generate Sekarang',
    'products.intelBulk.selected': 'Items dipilih',
    'products.intelBulk.willCall': 'Akan call API',
    'products.manual.addMore': 'Tambah Lagi',
    'products.manual.imageUrlLabel': 'URL Gambar',
    'products.manual.imageUrlPlaceholder': 'https://... atau klik thumbnail untuk upload',
    'products.manual.linkLabel': 'Link TikTok',
    'products.manual.nameExample': 'Cth: Baju Kurung Moden',
    'products.manual.nameLabel': 'Nama Produk',
    'products.manual.namePlaceholder': 'Nama produk...',
    'products.manual.numberLabel': 'No.',
    'products.manual.productIdPlaceholder': 'Product ID',
    'products.manual.productIdTooltip': 'Masukkan Product ID sahaja',
    'products.manual.saving': 'Saving...',
    'products.manual.submit': 'Tambah ({n})',
    'products.manual.subtitle': 'Masukkan data produk secara manual ke Library',
    'products.manual.title': 'Tambah Produk Manual',
    'products.manual.upload': 'Upload',
    // ── Troli Marketplace (beli banyak barang sekali bayar) ──
    'market.cart.title': 'Troli',
    'market.cart.subtitle': 'Semak barang anda sebelum membuat bayaran.',
    'market.cart.back': 'Kembali ke Marketplace',
    'market.cart.emptyTitle': 'Troli anda kosong',
    'market.cart.emptyDesc': 'Pilih barang di Marketplace, kemudian kembali ke sini untuk membayar semuanya sekali gus.',
    'market.cart.browse': 'Lihat Marketplace',
    'market.cart.summary': 'Ringkasan',
    'market.cart.units': '{n} unit',
    'market.cart.total': 'Jumlah',
    'market.cart.checkout': 'Bayar {jumlah}',
    'market.cart.preparing': 'Menyediakan…',
    'market.cart.payNote': 'Anda akan dibawa ke halaman pembayaran Billplz (FPX atau kad). Sebaik bayaran selesai, akses anda dilepaskan di Pembelian Saya.',
    'market.cart.whatsapp': 'No. WhatsApp (opsyenal — untuk admin hubungi jika perlu)',
    'market.cart.whatsappPh': 'cth 60123456789',
    'market.cart.remove': 'Buang dari troli',
    'market.cart.less': 'Kurangkan',
    'market.cart.more': 'Tambah',
    'market.cart.stockLeft': 'Tinggal {n}',
    'market.cart.maxStock': 'Ini semua stok yang ada',
    'market.cart.rentalOne': 'Sewa — satu akaun sahaja',
    'market.cart.soldOut': 'Habis stok',
    'market.cart.gone': 'Produk sudah tiada',
    'market.cart.withdrawn': 'Ditarik daripada jualan',
    'market.cart.isFree': 'Produk percuma — ambil di halaman produk',
    'market.cart.skipNote': '{n} barang tidak dapat dibeli sekarang dan tidak dikira dalam jumlah. Buang atau cuba lagi kemudian.',
    'market.cart.loadFailed': 'Gagal muat troli: {ralat}',
    'market.cart.payFailed': 'Gagal mula pembayaran: {ralat}',
    'market.cart.loginFirst': 'Sila log masuk dahulu.',
    'market.cart.addToCart': 'Masuk Troli',
    'market.cart.added': 'Dimasukkan ke troli ({n} unit).',
    'market.cart.full': 'Troli penuh — maksimum {n} jenis barang.',
    'market.cart.qtyLabel': 'Kuantiti',

    'products.market.cat.all': 'Semua',
    'products.market.cat.ebook': 'Ebook',
    'products.market.cat.flowUltra': 'Flow Ultra',
    'products.market.cat.tiktok': 'Akaun TikTok',
    'products.market.demo.empty': 'Kosong',
    'products.market.demo.loading': 'Memuat',
    'products.market.demo.normal': 'Biasa',
    'products.market.emptyDesc': 'Produk baharu ditambah dari semasa ke semasa. Sila cuba kategori lain dahulu.',
    'products.market.emptyTitle': 'Tiada produk dalam kategori ini',
    'products.market.free': 'PERCUMA',
    'products.market.loadFailed': 'Gagal muat marketplace: {ralat}',
    'products.market.myPurchases': 'Pembelian Saya',
    'products.market.planNote': 'Pelan · /marketplace-v3.9',
    'products.market.soldOut': 'SOLD OUT',
    'products.market.stockLeft': 'Tinggal {n} sahaja',
    'products.market.subtitle': 'Akaun TikTok, Flow Ultra dan ebook — sedia untuk dibeli.',
    'products.market.title': 'Marketplace',
    'products.moveGroup.desc': 'Group {group} dan semua produk di dalamnya akan menjadi milik akaun yang dipilih. Selepas ini group ini hanya muncul di bawah akaun tersebut.',
    'products.moveGroup.noProfiles': 'Belum ada profile. Tambah profile dahulu.',
    'products.moveGroup.profileProductCount': '{n} produk',
    'products.moveGroup.removeFromProfile': 'Keluarkan dari profile',
    'products.moveGroup.title': 'Pindah group ke profile',
    'products.noGroup': 'Tiada kumpulan',
    'products.openInTikTok': 'Buka di TikTok Shop',
    'products.pagination.next': 'Next →',
    'products.pagination.prev': '← Prev',
    'products.pagination.showing': 'Showing {dari}–{hingga} of {jumlah}',
    /* Sebab kad PENDING — dipulangkan oleh services/productReadyService.js.
       {medan} ialah senarai nama medan yang ditulis semasa scrape
       (Description, Price…) — ia data, jadi ia tidak diterjemah. */
    'products.pending.incomplete': 'Data produk belum lengkap.',
    'products.pending.missing': 'Belum ada: {medan}',
    'products.pending.noData': 'Belum ada data produk — scrape menggunakan butang Import Products.',
    'products.pendingLock': 'PENDING — tiada data produk',
    'products.pendingNote': 'Produk PENDING belum ada data produk, jadi ia tidak boleh dipilih. Sila lengkapkan menggunakan butang Import Products terlebih dahulu.',
    'products.profile.active': 'Aktif',
    'products.profile.add': 'Tambah profile',
    'products.profile.addTitle': 'Tambah profile TikTok',
    'products.profile.allAlreadyExist': 'Semua {n} produk yang dipilih sudah wujud dalam profile ini.',
    'products.profile.allSub': 'Termasuk tanpa profile',
    'products.profile.allTitle': 'Semua produk',
    'products.profile.confirmDelete': 'Padam profile "{nama}"?',
    'products.profile.confirmDeleteWithProducts': 'Padam profile "{nama}"?\n\n{n} produk di dalamnya TIDAK akan dipadam — ia akan kembali menjadi "Tanpa profile".',
    'products.profile.copy': 'Salin',
    'products.profile.copyFailed': 'Gagal salin ke profile: {ralat}',
    'products.profile.copyResultCopied': '{n} produk disalin',
    'products.profile.copyResultFailed': '{n} gagal',
    'products.profile.copyResultSkipped': '{n} dilangkau (sudah wujud)',
    'products.profile.deleteFailed': 'Gagal padam profile: {ralat}',
    'products.profile.editTooltip': 'Sunting profile',
    'products.profile.emptyMenu': 'Belum ada profile. Tambah profile dahulu.',
    'products.profile.groupEmpty': 'Tiada produk dalam group ini.',
    'products.profile.groups': '{n} group',
    'products.profile.group1': '{n} group',
    'products.profile.lastUsed': 'Terakhir: {v}',
    'products.profile.limitReached': 'Had {n} profile telah dicapai.',
    'products.profile.move': 'Pindah',
    'products.profile.moveFailed': 'Gagal pindah ke profile: {ralat}',
    'products.profile.moveGroupFailed': 'Gagal pindah group: {ralat}',
    'products.profile.nameExists': 'Nama profile ini sudah wujud.',
    'products.profile.nameRequired': 'Sila masukkan nama profile.',
    'products.profile.noUsername': 'Tiada username',
    'products.profile.pending': '{n} Pending',
    'products.profile.products': '{n} produk',
    'products.profile.product1': '{n} produk',
    'products.profile.ready': '{n} Ready',
    'products.profile.removeFromProfile': 'Keluarkan dari profile',
    'products.profile.saveFailed': 'Gagal simpan profile: {ralat}',
    'products.profile.slot': 'Profile {n}',
    'products.profile.syncHint': 'Sync Showcase untuk mula',
    'products.profile.unused': 'Belum digunakan',
    'products.profile.withoutProfile': 'Tanpa profile {n}',
    'products.profile.withoutProfileTip': 'Papar produk yang belum ada dalam mana-mana profile sahaja',
    'products.profileModal.addTitle': 'Tambah Profile TikTok',
    'products.profileModal.colorLabel': 'Warna',
    'products.profileModal.desc': 'Satu profile mewakili satu akaun TikTok anda. Produk boleh dipindahkan antara profile pada bila-bila masa.',
    'products.profileModal.editTitle': 'Sunting Profile',
    'products.profileModal.iconLabel': 'Ikon',
    'products.profileModal.iconLetter': 'Huruf',
    'products.profileModal.nameLabel': 'Nama profile',
    'products.profileModal.namePlaceholder': 'Contoh: TT Utama',
    'products.profileModal.usernameLabel': 'Username TikTok (pilihan)',
    'products.profileModal.usernamePlaceholder': 'contoh: ttutama.my',
    'products.prototypeNote': 'Prototaip · /products-v3.9',
    'products.scope.mine': 'Milik Saya',
    'products.scope.system': 'System',
    'products.scraped.badge.sourceTooltip': 'Data daripada {source}',
    'products.scraped.badge.title': 'Scraped Data',
    'products.scraped.close': 'Tutup',
    'products.scraped.closeAria': 'Tutup',
    'products.scraped.legend.source': 'Sumber:',
    'products.scraped.row.affiliateLink': 'Pautan Affiliate',
    'products.scraped.row.avgUnitPrice': 'Purata Harga Seunit',
    'products.scraped.row.badges': 'Lencana',
    'products.scraped.row.brand': 'Jenama',
    'products.scraped.row.category': 'Kategori',
    'products.scraped.row.commissionAmount': 'Jumlah Komisen',
    'products.scraped.row.commissionRate': 'Kadar Komisen',
    'products.scraped.row.creatorConvRatio': 'Nisbah Penukaran Creator',
    'products.scraped.row.creatorNumber': 'Bilangan Creator',
    'products.scraped.row.eta': 'Anggaran Tiba',
    'products.scraped.row.followers': 'Pengikut',
    'products.scraped.row.gallery': 'Galeri',
    'products.scraped.row.images': 'Gambar',
    'products.scraped.row.kalodataUrl': 'URL Kalodata',
    'products.scraped.row.launchDate': 'Tarikh Lancar',
    'products.scraped.row.liveRevenue': 'Hasil Live',
    'products.scraped.row.mallRevenue': 'Hasil Shopping Mall',
    'products.scraped.row.originalPrice': 'Harga Asal',
    'products.scraped.row.points': 'Kelebihan',
    'products.scraped.row.primaryImage': 'Gambar Utama',
    'products.scraped.row.productId': 'ID Produk',
    'products.scraped.row.productVideo': 'Video Produk',
    'products.scraped.row.promoEnds': 'Promosi Tamat',
    'products.scraped.row.promoLabel': 'Label Promosi',
    'products.scraped.row.rating': 'Rating',
    'products.scraped.row.ratingCount': 'Bilangan Rating',
    'products.scraped.row.resolvedUrl': 'URL Sebenar',
    'products.scraped.row.responseRate': 'Kadar Respons',
    'products.scraped.row.returnPolicy': 'Polisi Pemulangan',
    'products.scraped.row.revenue': 'Hasil',
    'products.scraped.row.shipFrom': 'Dihantar Dari',
    'products.scraped.row.shippingFee': 'Kos Penghantaran',
    'products.scraped.row.shopBadges': 'Lencana Kedai',
    'products.scraped.row.shopName': 'Nama Kedai',
    'products.scraped.row.shopRating': 'Rating Kedai',
    'products.scraped.row.shopUrl': 'URL Kedai',
    'products.scraped.row.sold': 'Terjual',
    'products.scraped.row.source': 'Sumber',
    /* Jamak — baris berasingan daripada 'row.source' di atas. Tanpa kunci ini
       pelanggan nampak nama kunci mentah tercetak sebagai label. */
    'products.scraped.row.sources': 'Sumber',
    'products.scraped.row.sourceUrl': 'URL Sumber',
    'products.scraped.row.specifications': 'Spesifikasi',
    'products.scraped.row.stockCount': 'Bilangan Stok',
    'products.scraped.row.stockStatus': 'Status Stok',
    'products.scraped.row.tags': 'Tag',
    'products.scraped.row.text': 'Teks',
    'products.scraped.row.topReviews': 'Ulasan Terbaik',
    'products.scraped.row.variants': 'Variasi',
    'products.scraped.row.videoRevenue': 'Hasil Video',
    'products.scraped.row.videos': 'Video',
    'products.scraped.section.affiliate': 'Affiliate',
    'products.scraped.section.analytics': 'Analitik (Kalodata)',
    'products.scraped.section.basic': 'Asas',
    'products.scraped.section.content': 'Kandungan',
    'products.scraped.section.description': 'Penerangan',
    'products.scraped.section.extraFields': 'Medan Tambahan',
    'products.scraped.section.gallery': 'Galeri Produk',
    'products.scraped.section.meta': 'Meta',
    'products.scraped.section.pricePromo': 'Harga & Promosi',
    'products.scraped.section.rating': 'Rating',
    'products.scraped.section.sellingPoints': 'Kelebihan Produk',
    'products.scraped.section.shippingReturn': 'Penghantaran & Pemulangan',
    'products.scraped.section.shop': 'Kedai',
    'products.scraped.section.variantsStock': 'Variasi & Stok',
    'products.scraped.variants.name': 'Nama',
    'products.scraped.variants.stock': 'Stok',
    'products.searchPlaceholder': 'Cari produk',
    'products.selectAll': 'Pilih semua',
    'products.selectedCount': '{n} dipilih',
    'products.selectProduct': 'Pilih produk',
    'products.setGroup': 'Set…',
    'products.sort.label': 'Susunan',
    'products.sort.name': 'Sort: Name',
    'products.sort.newest': 'Sort: Terbaru',
    'products.sort.number': 'Sort: Number',
    'products.status.pending': 'PENDING',
    'products.status.ready': 'READY',
    'products.subtitle': 'Simpanan produk anda. Tarik masuk ke Workspace apabila anda mahu run.',
    'products.tab.myProducts': 'My Products',
    'products.table.completeData': 'Lengkapkan data produk',
    'products.table.dataIncomplete': 'Data produk belum lengkap',
    'products.table.deleteProduct': 'Padam produk',
    'products.table.editData': 'Edit data produk',
    'products.table.editProduct': 'Edit produk',
    'products.table.groupAria': 'Group produk',
    'products.table.selectAllPage': 'Pilih semua dalam halaman ini',
    'products.time.daysAgo': '{n} hari lalu',
    'products.time.monthsAgo': '{n} bulan lalu',
    'products.time.today': 'hari ini',
    'products.time.weeksAgo': '{n} minggu lalu',
    'products.time.yearsAgo': '{n} tahun lalu',
    'products.time.yesterday': 'semalam',
    'products.title': 'Products',
    'products.toolbar.bulkUpload': 'Bulk Upload',
    'products.toolbar.group': 'Group',
    'products.toolbar.intelSelectedN': 'Selected: {n}',
    'products.toolbar.intelSelectTitle': 'Pilih banyak items untuk generate intelligence sekaligus',
    'products.toolbar.import': 'Import Produk',
    'products.toolbar.manual': 'Manual',
    // ── Import stepper (Fasa 2) ──
    'import.title': 'Import Produk',
    'import.step.setup': 'Setup',
    'import.step.scrape': 'Scrape',
    'import.step.review': 'Review',
    'import.setup.linksLabel': 'Tampal link produk TikTok (satu atau banyak)',
    'import.setup.note': 'Extension yang buat kerja scrape di belakang tabir. Jika muncul captcha, ia akan keluar di tab TikTok untuk anda selesaikan sendiri.',
    'import.setup.count': 'link dikesan',
    'import.ext.on': 'Extension SESAAT aktif',
    'import.ext.off': 'Extension belum bersambung.',
    'import.ext.reconnect': 'Klik butang di bawah untuk sambung.',
    'import.ext.refreshBtn': 'Refresh halaman',
    'import.ext.check': 'Menyemak extension…',
    'import.captcha': 'Captcha muncul — sila selesaikan di tab TikTok yang terbuka. Scrape akan sambung sendiri selepas itu.',
    'import.scrape.ok': 'siap',
    'import.scrape.fail': 'gagal',
    'import.scrape.now': 'Sedang scrape: ',
    'import.scrape.starting': 'Menyambung ke extension…',
    'import.scrape.finishing': 'Menyelesaikan…',
    'import.scrape.running': 'Extension sedang bekerja…',
    'import.scrape.stop': 'Berhenti',
    'import.review.summary': '{ok} produk berjaya ({ready} READY). {fail} gagal.',
    'import.review.exists': 'DAH ADA',
    'import.review.failed': 'GAGAL',
    'import.review.dest': 'Produk akan disimpan ke akaun: {nama}',
    'import.review.destNone': 'Produk akan disimpan tanpa akaun — ia akan duduk dalam "Semua produk". Buka satu kad akaun dahulu kalau mahu ia terus masuk ke akaun itu.',
    'import.review.group': 'Group',
    'import.review.noGroup': 'Tiada group',
    'import.review.back': '← Import lagi',
    'import.review.empty': 'Tiada hasil. Balik ke Setup untuk mula.',
    'import.bulk.all': 'Pilih semua',
    'import.bulk.n': '{n} dipilih',
    'import.bulk.move': 'Masuk Group',
    'import.bulk.remove': 'Buang',
    'import.card.scraping': 'Scraping…',
    'import.card.failed': 'Scrape gagal',
    'import.card.price': 'Harga',
    'import.card.remove': 'Buang produk ni',
    'import.card.edit': 'Edit Manual',
    'import.card.retry': 'Retry',
    'import.card.fill': 'Lengkapkan Data',
    'import.card.pendingWarn': 'Data tak cukup — akan simpan sebagai PENDING',
    'import.card.stillNeed': 'Masih perlu',
    'import.copy.view': '✓ Link produk disalin',
    'import.copy.viewBtn': 'Link produk',
    'import.copy.src': '✓ Link sumber disalin',
    'import.copy.srcBtn': 'Link sumber',
    'import.copyFail': 'Gagal salin',
    'import.group.pick': 'Pilih Group',
    'import.group.none': 'Tiada Group',
    'import.group.new': 'Group Baru',
    'import.group.name': 'Nama group',
    'import.group.saving': 'Menyimpan…',
    'import.group.saveUse': 'Simpan & Guna',
    'import.group.dup': 'Nama group dah wujud',
    'import.group.addFail': 'Gagal tambah group',
    'import.group.noneForProfile': 'Akaun ini belum ada group',
    'import.group.pickProfile': 'Pilih akaun dahulu untuk group khas akaun',
    'import.edit.title': 'Edit Produk Manual',
    'import.edit.hint': 'Isi data produk sendiri. Nama, Harga & Description penting untuk jadi READY.',
    'import.edit.name': 'Nama Produk *',
    'import.edit.price': 'Harga *',
    'import.edit.orig': 'Harga Asal',
    'import.edit.disc': 'Diskaun %',
    'import.edit.cat': 'Kategori',
    'import.edit.img': 'Image URL',
    'import.edit.desc': 'Description *',
    'import.edit.descPh': 'Apa produk ni, kelebihannya, bahan, cara guna…',
    'import.edit.spec': 'Specification',
    'import.edit.rev': 'Customer Reviews',
    'import.edit.ok': '✓ Cukup — produk ini akan jadi READY',
    'import.edit.notReady': '⚠ Belum cukup untuk READY',
    'import.edit.need': 'Nama dan Harga wajib diisi',
    'import.edit.saved': '✓ Produk dikemas kini',
    'import.edit.save': 'Simpan',
    'import.saved': '{n} kad disimpan ke My Products',
    'import.saveFail': 'Gagal simpan — cuba lagi',
    'import.cancel': 'Batal',
    'import.start': 'Mula scrape',
    'import.save': 'Simpan {n} kad',
    'import.saving': 'Menyimpan…',
    'import.mode.link': 'Tampal Link',
    'import.mode.showcase': 'Scrape Showcase',
    'import.showcase.note': 'Extension akan buka showcase Seller anda, kumpul semua produk, kemudian anda pilih yang mana nak import. Pastikan anda sudah log masuk TikTok Seller.',
    'import.showcase.collect': 'Kutip dari Showcase',
    'import.showcase.fromPage': 'Dari page',
    'import.showcase.toPage': 'Hingga page',
    'import.showcase.toPagePh': 'semua',
    'import.showcase.pageHint': '1 page = 20 produk. Biar "Hingga page" kosong untuk kutip semua.',
    'import.showcase.pageErr': '"Hingga page" mesti lebih besar atau sama dengan page mula ({start}).',
    'import.showcase.collecting': 'Mengumpul… page {page} · {found} produk',
    'import.showcase.search': 'Cari nama produk…',
    'import.showcase.all': 'Pilih semua',
    'import.showcase.none': 'Nyahpilih',
    'import.showcase.selected': '{n} dipilih daripada {total}',
    'import.showcase.chosen': 'produk dipilih',
    'import.showcase.timeout': 'Tiada respons dari extension — pastikan ia aktif.',
    'import.showcase.fail': 'Gagal kutip showcase.',
    'import.showcase.empty': 'Tiada produk dijumpai — pastikan anda log masuk TikTok Seller.',
    // ── Import stepper — tab Shopee (2026-10-03) ──
    'importShopee.ext.old': 'Extension anda belum menyokong import Shopee. Sila pasang versi extension yang terbaru, kemudian refresh halaman ini.',
    'importShopee.close': 'Tutup',
    'importShopee.setup.linksLabel': 'Tampal link produk Shopee (satu atau banyak)',
    'importShopee.setup.skipped': '{n} link diabaikan — bukan halaman produk Shopee Malaysia.',
    'importShopee.setup.autoAff': 'Tukar ke link affiliate secara automatik',
    'importShopee.setup.subId': 'Sub ID',
    'importShopee.setup.subIdHint': 'Huruf dan nombor sahaja. Sub ID membantu anda menjejak klik dalam laporan Shopee Affiliate.',
    'importShopee.setup.noteAff': 'Extension akan membuka setiap halaman produk dalam browser ini, kemudian menukar link di Shopee Affiliate. Pastikan anda sudah log masuk Shopee dan Shopee Affiliate (akaun affiliate yang diluluskan).',
    'importShopee.setup.note': 'Extension akan membuka setiap halaman produk dalam browser ini. Pastikan anda sudah log masuk Shopee.',
    'importShopee.mode.storefront': 'Scrape Storefront',
    'importShopee.sf.urlLabel': 'Link storefront',
    'importShopee.sf.maksLabel': 'Bilangan produk (terbaru dahulu)',
    'importShopee.sf.maksHint': 'Produk dikutip ikut susunan "Latest" storefront. Maksimum {maks}.',
    'importShopee.sf.collect': 'Kutip dari Storefront',
    'importShopee.sf.collecting': 'Mengutip produk dari storefront…',
    'importShopee.sf.wait': 'Extension sedang membuka storefront dan scroll senarai produk. Ini boleh mengambil masa 1–2 minit — jangan tutup tab itu.',
    'importShopee.sf.errUrl': 'Link storefront tidak sah. Contoh: https://collshp.com/namaanda',
    'importShopee.sf.fail': 'Gagal mengutip produk dari storefront.',
    'importShopee.sf.empty': 'Tiada produk dijumpai dalam storefront ini.',
    'importShopee.sf.partial': 'Senarai storefront berhenti dimuat sebelum habis — mungkin tidak semua produk dikutip.',
    'importShopee.sf.soldOutBtn': 'Sold Out ({n})',
    'importShopee.sf.soldOutTipOff': 'Buang tanda semua produk Sold Out',
    'importShopee.sf.soldOutTipOn': 'Tanda semula semua produk Sold Out',
    'importShopee.sf.pickPh': 'Pilih storefront…',
    'importShopee.sf.edit': 'Edit',
    'importShopee.sf.savedLabel': 'Storefront tersimpan',
    'importShopee.sf.newOption': '+ Storefront baharu',
    'importShopee.sf.nameLabel': 'Nama',
    'importShopee.sf.namePh': 'cth: Kedai utama',
    'importShopee.sf.saveNew': 'Simpan storefront ini',
    'importShopee.sf.saveEdit': 'Simpan perubahan',
    'importShopee.sf.remove': 'Buang dari senarai',
    'importShopee.sf.saved': 'Storefront disimpan',
    'importShopee.sf.removed': 'Storefront dibuang',
    'importShopee.sf.saveFail': 'Gagal menyimpan storefront — cuba lagi.',
    'importShopee.sf.dupUrl': 'Link storefront ini sudah tersimpan di bawah nama lain.',
    'importShopee.sf.full': 'Maksimum {maks} storefront tersimpan. Buang satu dahulu.',
    'importShopee.sf.again': 'Kutip semula',
    'importShopee.aff.running': 'Menukar link affiliate… {siap} / {jumlah}',
    'importShopee.row.ok': 'Siap',
    'importShopee.row.fail': 'Gagal',
    'importShopee.err.notReached': 'Belum sempat di-scrape — batch dihentikan. Tekan Retry.',
    'importShopee.notice.stopped': 'Scrape dihentikan awal. Semak sebab pada produk yang gagal, kemudian tekan Retry.',
    'importShopee.bulk.retry': 'Retry semua yang gagal ({n})',
    'importShopee.bulk.aff': 'Tukar link affiliate ({n})',
    'importShopee.card.idTip': 'ID produk Shopee (kedai.produk)',
    'importShopee.card.dup': 'PRODUK SAMA',
    'importShopee.card.dupNote': 'Link ini menunjuk produk yang sama dengan baris lain — ia tidak akan disimpan dua kali.',
    'importShopee.card.sold': 'terjual',
    'importShopee.card.aff': 'Link affiliate',
    'importShopee.card.affNone': 'Link affiliate belum ada.',
    'importShopee.card.affOff': 'Toggle tukar automatik dimatikan.',
    'importShopee.card.edit': 'Edit data',
    'importShopee.copy.aff': 'Link affiliate disalin',
    'importShopee.copy.btn': 'Salin',
    'importShopee.save': 'Simpan {n} produk',
    'importShopee.saved': '{n} produk disimpan ke My Products',
    'importShopee.saveFail': 'Gagal simpan — cuba lagi',
    'importShopee.save.rejected': '{n} produk TIDAK disimpan:',
    'importShopee.edit.title': 'Edit data produk',
    'importShopee.edit.hint': 'Nama, gambar dan description diperlukan untuk jadi READY.',
    'importShopee.edit.price': 'Harga',
    'importShopee.edit.img': 'Image URL *',
    'importShopee.edit.ok': 'Cukup — produk ini akan jadi READY',
    'importShopee.edit.notReady': 'Belum cukup untuk READY',
    'importShopee.edit.needName': 'Nama produk wajib diisi',
    'importShopee.edit.needImg': 'Image URL wajib bermula dengan https://',
    'importShopee.edit.noId': 'Link ini tiada ID produk — tidak boleh diisi manual',
    'importShopee.edit.saved': 'Produk dikemas kini',
    'products.toolbar.selectForIntel': 'Select for Intel',
    'products.view.grid': 'Paparan grid',
    'products.view.table': 'Paparan jadual',
    'products.view.imgSizeTip': 'Saiz gambar: {saiz} — tekan untuk tukar',
    'products.view.imgS': 'Kecil',
    'products.view.imgM': 'Sederhana',
    'products.view.imgL': 'Besar',

    /* ── prostudio ───────────────────────────────────────────── */
    'prostudio.agent.mockBadge': 'Rangka paparan',
    'prostudio.backToHub': 'Kembali ke PRO Studio',
    'prostudio.cfg.adv': 'Tetapan lanjutan',
    'prostudio.cfg.advHint': 'Hanya perlu bila ada yang tidak kena',
    'prostudio.cfg.again': 'Configure semula',
    'prostudio.cfg.backResult': 'Kembali ke hasil',
    'prostudio.cfg.blokAjar': 'Satu blok hanyalah sepotong teks tajuk. Pilih LABELnya — HOOK: — bukan jawapan di bawahnya. Label muncul pada setiap set dan pada setiap produk yang anda jalankan kemudian; jawapan hanya muncul sekali.',
    'prostudio.cfg.blokBuang': 'Buang',
    'prostudio.cfg.blokCount': '{n} buatan anda',
    'prostudio.cfg.blokDaripadaPilihan': 'Jadikan blok daripada teks dipilih',
    'prostudio.cfg.blokHint': 'Bila blok yang dikesan bukan bentuk yang betul',
    'prostudio.cfg.blokJumpa': 'Padan {n}× dalam jawapan',
    'prostudio.cfg.blokPesan.kosong': 'Tiada teks diserlah. Seret pada labelnya dalam kotak jawapan, kemudian tekan butang ini sekali lagi.',
    'prostudio.cfg.blokPesan.dikesan': 'Agent memang sudah menjumpai blok ini sendiri. Buka mana-mana medan di atas dan anda akan melihatnya dalam senarai blok di situ — tidak perlu ditambah di sini.',
    'prostudio.cfg.blokPesan.panjang': 'Terlalu panjang — ia nampak seperti satu baris penuh termasuk jawapannya. Serlah labelnya sahaja.',
    'prostudio.cfg.blokPesan.pendek': 'Terlalu pendek — satu blok perlukan sekurang-kurangnya 2 aksara.',
    'prostudio.cfg.blokPesan.sudah': 'Blok itu sudah wujud.',
    'prostudio.cfg.blokPilihHint': 'Serlah label dalam jawapan di atas, kemudian tekan ini.',
    'prostudio.cfg.blokPerluJawapan': 'Jawapan belum ada pada skrin, jadi tiada apa untuk diserlah. Jalankan Configure sekali, kemudian kembali ke sini.',
    'prostudio.cfg.blokPilihLabel': 'Serlah labelnya dalam jawapan',
    'prostudio.cfg.blokTakSemak': 'Tidak dapat disemak sekarang — jalankan Configure untuk melihat sama ada ia berpadan',
    'prostudio.cfg.blokTiada': 'Tiada jumpa — cuba label yang lebih pendek',
    'prostudio.cfg.blokTitle': 'Blok anda sendiri',
    'prostudio.cfg.composerPh': 'Klik blok di bawah untuk membina medan ini.',
    'prostudio.cfg.done': 'Selesai',
    'prostudio.cfg.errGemUrl': 'Itu bukan pautan Gem. Ia sepatutnya bermula dengan gemini.google.com/gem/',
    'prostudio.cfg.extBlocked': 'Pilih satu sebelum larian — cip ini mengubah cara GPT anda menjawab, jadi ia mesti sama setiap kali.',
    'prostudio.cfg.extHint': 'ChatGPT tiada senarai model untuk dipilih — cip ini sahaja tetapan larian yang ada di sana.',
    'prostudio.cfg.extKeep': 'Biarkan seperti ChatGPT tetapkan',
    'prostudio.cfg.extKeepDesc': 'SESAAT tidak menyentuh cip Thinking. Pilih ini kalau GPT anda memang dibina untuk berjalan dengan Thinking hidup.',
    'prostudio.cfg.extLabel': 'Thinking (ChatGPT)',
    'prostudio.cfg.extOff': 'Matikan Thinking',
    'prostudio.cfg.extOffDesc': 'SESAAT membuang cip Thinking sebelum menaip produk anda — GPT menjawab terus, lebih laju. SESAAT tidak menghidupkannya semula selepas larian.',
    'prostudio.cfg.thinkingGagal': 'Thinking tidak dapat dimatikan pada larian ini — jawapan di atas dijana dengan Thinking hidup. Jalankan Configure semula.',
    'prostudio.cfg.freshTitle': 'Jawapan baharu diambil',
    'prostudio.cfg.freshMeta': '{tarikh} · diuji dengan {produk}',
    'prostudio.cfg.freshSave': 'Belum disimpan — tekan Save',
    'prostudio.cfg.bukaPerbualan': 'Buka perbualan agent',
    'prostudio.cfg.hariIni': 'Hari ini, {jam}',
    'ext.ralatSambungan': 'SESAAT tidak dapat connect dengan extension. Tekan "Reload" di manage extension, kemudian cuba lagi.',
    'prostudio.cfg.tahapLabel': 'Thinking (ChatGPT)',
    'prostudio.cfg.tahapRead': 'Baca pilihan Thinking',
    'prostudio.cfg.tahapReading': 'Membaca pilihan…',
    'prostudio.cfg.tahapReadHint': 'SESAAT membuka GPT anda sebentar untuk membaca pilihan Thinking yang ada pada akaun ChatGPT anda. Tiada mesej dihantar.',
    'prostudio.cfg.tahapReadAgain': 'Baca semula',
    'prostudio.cfg.tahapAkaun': 'Akaun ChatGPT: {akaun}',
    'prostudio.cfg.tahapHint': 'Tahap ini ditetapkan setiap kali agent dijalankan, termasuk di tab My Agent.',
    'prostudio.cfg.tahapBlocked': 'Pilih satu tahap sebelum larian — tahap Thinking mengubah cara GPT anda menjawab.',
    'prostudio.cfg.tahapLama': 'Tetapan lama "Matikan Thinking" kini bermaksud tahap paling rendah. Pilih tahap di atas untuk menggantikannya.',
    'prostudio.cfg.tahapGagal': 'Thinking tidak dapat ditetapkan ke "{mahu}" pada larian ini ({nota}). Semak pilihan Thinking, kemudian jalankan Configure semula.',
    'prostudio.cfg.tahapNeedUrl': 'Tampal pautan GPT di Langkah 1 terlebih dahulu.',
    'prostudio.cfg.tahapFail': 'Pilihan Thinking tidak dapat dibaca. Sila cuba lagi.',
    'prostudio.cfg.tahapNone': 'Tiada pilihan Thinking dijumpai pada ChatGPT itu. Pastikan anda sudah log masuk ke ChatGPT.',
    'prostudio.cfg.tahapTiada': 'Akaun ChatGPT ini tiada pilihan Thinking — SESAAT ikut tetapan ChatGPT.',
    'prostudio.cfg.geminiExtGagalOn': 'Extended thinking tidak dapat dihidupkan pada larian ini — jawapan di atas dijana tanpa Extended thinking. Jalankan Configure semula.',
    'prostudio.cfg.geminiExtGagalOff': 'Extended thinking tidak dapat dimatikan pada larian ini — jawapan di atas dijana dengan Extended thinking hidup. Jalankan Configure semula.',
    'prostudio.cfg.geminiModelGagal': 'Model {mahu} tidak dapat dipilih pada larian ini — jawapan di atas dijana dengan model {guna}. Semak senarai model Gem anda, kemudian jalankan Configure semula.',
    'prostudio.cfg.geminiModelLabel': 'Model Gemini',
    'prostudio.cfg.geminiExtLabel': 'Extended thinking (Gemini)',
    'prostudio.cfg.geminiExtOn': 'Hidupkan',
    'prostudio.cfg.geminiExtOnDesc': 'SESAAT hidupkan Extended thinking sebelum menaip produk anda — Gem berfikir lebih dalam. Pilih ini kalau Gem anda dikalibrasi dengan ia hidup.',
    'prostudio.cfg.geminiExtOff': 'Matikan',
    'prostudio.cfg.geminiExtOffDesc': 'SESAAT matikan Extended thinking sebelum menaip — jawapan biasa, lebih laju. Pilih ini kalau Gem anda dikalibrasi tanpa ia.',
    'prostudio.cfg.geminiHint': 'Model dan tahap Thinking di atas ditetapkan pada setiap larian, jadi jawapan sentiasa sepadan dengan yang dikalibrasi.',
    'prostudio.cfg.geminiBlocked': 'Pilih model DAN tahap Thinking dahulu — dua-dua mengubah cara Gem menjawab, jadi ia mesti sama setiap kali.',
    'prostudio.cfg.geminiModelBlocked': 'Pilih model Gemini dahulu.',
    'prostudio.cfg.geminiExtBlocked': 'Pilih tahap Thinking (Low, Medium atau High) dahulu.',
    'prostudio.cfg.geminiTahapLabel': 'Tahap Thinking (Gemini)',
    'prostudio.cfg.geminiTahapLowDesc': 'Jawapan paling pantas. Pilih tahap ini jika Gem anda dikalibrasi pada Low.',
    'prostudio.cfg.geminiTahapMediumDesc': 'Seimbang antara kelajuan dan kedalaman. Pilih tahap ini jika Gem anda dikalibrasi pada Medium.',
    'prostudio.cfg.geminiTahapHighDesc': 'Gem berfikir paling mendalam dan jawapan lebih lambat. Pilih tahap ini jika Gem anda dikalibrasi pada High.',
    'prostudio.cfg.geminiTahapGagal': 'Tahap Thinking {mahu} tidak dapat ditetapkan pada larian ini — jawapan di atas dijana pada tahap {guna}. Jalankan Configure semula.',
    'prostudio.cfg.geminiTahapGagalUmum': 'Tahap Thinking {mahu} tidak dapat ditetapkan pada larian ini. Jalankan Configure semula.',
    'prostudio.cfg.fieldsHint': 'Lima medan ini tetap. Ia lima kotak yang sama seperti pada kad produk di Workspace. Automation Flow membaca medan gambar dan video itu secara terus.',
    'prostudio.cfg.fieldsName': 'Medan',
    'prostudio.cfg.fieldsQ': 'Apa yang perlu ada dalam setiap hasil?',
    'prostudio.cfg.edit': 'Tukar baris ini',
    'prostudio.cfg.editHint': 'Blok ialah serpihan jawapan agent anda. Apa sahaja yang anda taip di sekelilingnya kekal seperti yang anda taip.',
    'prostudio.cfg.insert': 'Selit blok:',
    'prostudio.cfg.introBody': 'Satu produk sebenar dihantar kepada agent anda melalui Extension SESAAT. Satu tab ChatGPT akan dibuka — biarkan ia berjalan sehingga selesai, lebih kurang satu hingga dua minit.',
    'prostudio.cfg.introBodyGemini': 'Satu produk sebenar dihantar kepada agent anda melalui Extension SESAAT. Satu tab Gemini akan dibuka — biarkan ia berjalan sehingga selesai, lebih kurang satu hingga dua minit.',
    'prostudio.cfg.modelDibaca': 'Senarai di atas dibaca daripada akaun Gemini anda. Baca semula jika Google menukar nama model.',
    'prostudio.cfg.modelReadAgain': 'Baca semula senarai model',
    'prostudio.cfg.modelEmpty': 'Tekan butang di bawah — SESAAT akan membuka Gem anda, menyalin senarai model akaun, dan menutupnya semula.',
    'prostudio.cfg.modelFail': 'Senarai model tidak dapat dibaca. Sila cuba lagi.',
    'prostudio.cfg.modelNeedUrl': 'Tampal pautan Gem di Langkah 1 terlebih dahulu.',
    'prostudio.cfg.modelNone': 'Tiada senarai model dijumpai pada Gem itu. Pastikan anda sudah log masuk ke Gemini.',
    'prostudio.cfg.modelRead': 'Baca senarai model saya',
    'prostudio.cfg.modelReadHint': 'Membuka Gem anda, menyalin senarainya, kemudian menutupnya. Tiada apa dihantar dan tiada kuota terpakai.',
    'prostudio.cfg.modelReading': 'Sedang membaca…',
    'prostudio.cfg.modelWarn': 'Tidak memilih bermakna SESAAT langsung tidak menyentuh menu model — Gem anda akan berjalan atas apa sahaja model yang Gemini sedang tetapkan pada masa itu, dan jawapannya boleh berbeza daripada model asal Gem itu dibina.',
    'prostudio.cfg.modelBoxHint': 'Model yang Gem guna semasa larian',
    'prostudio.cfg.preview': 'Pratonton kad produk',
    'prostudio.cfg.previewEmpty': '— kosong —',
    'prostudio.cfg.previewSet': 'Set {n}',
    'prostudio.cfg.previewHint': 'Rupanya di Workspace nanti',
    'prostudio.cfg.imgTitle': 'Gambar daripada jawapan agent',
    'prostudio.cfg.imgHint': 'Pratonton sahaja — gambar disimpan ke kad hanya semasa larian sebenar di Workspace.',
    'prostudio.cfg.imgNone': 'Tiada gambar diterima pada larian ini. Pastikan extension SESAAT versi 3.9.4 ke atas dipasang, dan agent memang menjana gambar pada jawapan yang ditanda.',
    'prostudio.cfg.prodImgOk': 'Gambar produk dihantar kepada agent: {n}.',
    'prostudio.cfg.prodImgShort': 'Hanya {dihantar} daripada {dijangka} gambar produk sampai kepada agent — jawapan agent mungkin tidak merangkumi semua gambar.',
    'prostudio.cfg.prodImgOld': 'Gambar tambahan produk ini tidak dihantar — pasang extension SESAAT terkini (3.9.4 ke atas), kemudian jalankan Configure semula.',
    'prostudio.cfg.readyMeta': 'Dikonfigurasi {tarikh} · diuji dengan {produk}',
    'prostudio.cfg.readyMetaBaharu': 'Diuji dengan {produk}',
    'prostudio.cfg.readyTitle': 'Agent ini sudah sedia',
    'prostudio.cfg.rematchBody': 'Hasil di bawah akan dikemas kini sebaik siap. Tunggu sebentar dan jangan ubah apa-apa dahulu.',
    'prostudio.cfg.rematchTitle': 'Sedang memadankan semula jawapan yang dipilih…',
    'prostudio.cfg.resultAll': 'Set: {set} · Babak: {babak} · kesemua {jum} medan berpadan. Tekan mana-mana baris untuk mengubahnya.',
    'prostudio.cfg.resultSome': '{n} daripada {jum} medan berpadan — selebihnya ditanda di bawah. Buka setiap baris bertanda dan pilih sumbernya.',
    'prostudio.cfg.resultTitle': 'Apa yang SESAAT ambil daripada jawapan',
    'prostudio.cfg.resultBlokAmaran': '{n} baris menuding kepada blok yang tidak muncul cukup kali. Baca nota di bawah setiap satu — set yang kehabisan akan mengambil teks set lain.',
    'prostudio.cfg.babakKe': 'Babak {n}',
    'prostudio.cfg.notaKosong': 'Blok "{blok}" langsung tidak dijumpai dalam jawapan ini.',
    'prostudio.cfg.notaTakCukup': 'Blok "{blok}" muncul {n}× dalam jawapan ini, sedangkan {perlu}× diperlukan untuk mengisi semua set. Set yang kehabisan akan mengambil teks set lain, atau keluar kosong.',
    'prostudio.cfg.rowEmpty': 'Belum ada sumber',
    'prostudio.cfg.run': 'Configure Agent',
    'prostudio.cfg.runningBody': 'Biarkan tab ChatGPT itu sehingga selesai. Halaman ini akan terisi dengan sendirinya.',
    'prostudio.cfg.runningTitle': 'Sedang menguji agent anda',
    'prostudio.cfg.stepOf': 'Langkah {n} daripada {jum}',
    'prostudio.hook.addHook': 'Tambah hook',
    'prostudio.hook.bulkAdd': 'Tambah semua',
    'prostudio.hook.bulkClose': 'Tutup tampal pukal',
    'prostudio.hook.bulkOpen': 'Tampal pukal',
    'prostudio.hook.bulkPlaceholder': 'Satu hook satu baris:\nHari ini sahaja murah\nSaya sudah cuba, memang berbaloi',
    'prostudio.hook.countInGroup': '{n} hook dalam group ini',
    'prostudio.hook.deleteGroup': 'Padam group',
    'prostudio.hook.emptyBody': 'Pilih satu group di sebelah kiri, atau cipta yang baharu.',
    'prostudio.hook.emptyTitle': 'Tiada group dipilih',
    'prostudio.hook.examplesDesc': 'Satu ayat satu baris. Sistem mencabut satu secara rawak setiap kali Generate.',
    'prostudio.hook.examplesTitle': 'Contoh hook',
    'prostudio.hook.groupMeta': '{n} hook · {mod}',
    'prostudio.hook.groupName': 'Nama group',
    'prostudio.hook.groupsDesc': 'Bintang menandakan group lalai anda di Workspace.',
    'prostudio.hook.groupsTitle': 'Group anda',
    'prostudio.hook.hookPlaceholder': 'Tulis ayat pembuka anda',
    'prostudio.hook.howToUse': 'Cara guna',
    'prostudio.hook.isDefaultGroup': 'Group lalai anda',
    'prostudio.hook.makeDefaultGroup': 'Jadikan group lalai',
    'prostudio.hook.modeAdapt': 'AI sesuaikan',
    'prostudio.hook.modeVerbatim': 'Guna terus',
    'prostudio.hook.newGroup': 'Group baharu',
    'prostudio.hook.noHooks': 'Belum ada contoh hook dalam group ini.',
    'prostudio.hook.pageDesc': 'Ayat pembuka simpanan anda. Setiap kali Generate, sistem mencabut satu contoh daripada group yang dipilih.',
    'prostudio.hook.removeHook': 'Buang hook',
    'prostudio.hook.settingsDesc': 'Nama untuk anda kenal sendiri, dan cara sistem menggunakan contoh di dalamnya.',
    'prostudio.hook.settingsTitle': 'Tetapan group',
    'prostudio.hook.sharedBadge': 'Dikongsi semua module',
    'prostudio.hook.styleNote': 'Nota gaya untuk AI (pilihan)',
    'prostudio.hook.styleNotePlaceholder': 'Contoh: nada mendesak tetapi mesra, ayat pendek',
    'prostudio.hook.useAdapt': 'Sesuaikan dengan produk',
    'prostudio.hook.useAdaptFor': 'Untuk anda yang mahu beri arah dan nada, tetapi biarkan AI yang menulis.',
    'prostudio.hook.useAdaptSummary': 'AI tiru gaya contoh, tulis ayat baharu yang padan dengan produk semasa.',
    'prostudio.hook.useVerbatim': 'Guna terus, tanpa ubah',
    'prostudio.hook.useVerbatimFor': 'Untuk anda yang sudah ada hook terbukti dan tidak mahu sesiapa mengubahnya.',
    'prostudio.hook.useVerbatimSummary': 'Contoh ditampal bulat-bulat sebagai hook. AI langsung tidak menyentuhnya.',
    'prostudio.hub.badge.agents': '{n} agent',
    'prostudio.hub.badge.cta': '{n} CTA',
    'prostudio.hub.badge.groups': '{n} group',
    'prostudio.hub.badge.templates': '{n} template',
    'prostudio.hub.coreRule': 'Peraturan teras SESAAT (tudung untuk produk wanita, produk mengikut gambar rujukan, pose mengikut saiz produk) sentiasa diutamakan — tetapan di sini tidak boleh melanggarnya.',
    'prostudio.hub.group.all': 'Untuk semua module',
    'prostudio.hub.group.allDesc': 'Tetapan ini disapu ke atas apa sahaja yang anda jalankan.',
    'prostudio.hub.group.proto': 'Prototaip — belum live',
    'prostudio.hub.group.protoDesc': 'Masih dalam reka bentuk. Pelanggan tidak nampak dan tidak boleh membukanya.',
    'prostudio.hub.group.smart': 'My Agent — untuk module SMART sahaja',
    'prostudio.hub.group.smartDesc': 'SMART tidak menggunakan master prompt SESAAT — ia menggunakan custom GPT milik anda sendiri.',
    'prostudio.agentLock.title': 'Module SMART belum dibuka untuk akaun anda',
    'prostudio.agentLock.body': 'Agent Saya ialah tempat anda menyambungkan custom GPT sendiri kepada SESAAT. Ia hanya berfungsi bersama module SMART, jadi ia belum boleh digunakan pada pakej semasa anda.',
    'prostudio.agentLock.cta': 'Lihat pakej',
    /* ── Agent Saya — seksyen SEBENAR (ProStudioAgentSection) ─────────
       Ayat di sini MESTI sama dengan ayat lalai dalam komponen — ayat
       lalai itulah yang menjaga rupa LAMA kekal Melayu. Kalau dua-dua
       terpesong, rupa lama dan rupa v3.9 bercakap lain-lain. */
    'prostudio.agentsec.introTitle': 'Sambungkan custom GPT anda sendiri',
    'prostudio.agentsec.introBody': 'Jika anda memiliki custom GPT yang dibeli daripada penjual lain, sambungkannya di sini. Tetapkan hasil yang anda mahu, dan SESAAT akan menghantar produk anda kepada GPT tersebut secara berkelompok, mengambil jawapannya, dan menjalankan automation Flow mengikut tetapan anda.',
    'prostudio.agentsec.introStrong': 'Configure sekali sahaja bagi setiap agent.',
    'prostudio.agentsec.listLoading': 'Memuatkan senarai agent...',
    'prostudio.agentsec.listEmpty': 'Belum ada agent.',
    'prostudio.agentsec.listEmptyCta': 'Klik {b} untuk bermula.',
    'prostudio.agentsec.rowMeta': '{set} set · {babak} babak · {hasil}',
    'prostudio.agentsec.hasilImage': 'gambar',
    'prostudio.agentsec.hasilImageVideo': 'gambar + video',
    'prostudio.agentsec.unsavedDot': 'Ada perubahan yang belum disimpan',
    'prostudio.agentsec.newAgent': 'Agent Baru',
    'prostudio.agentsec.railNote': 'Agent berstatus {b} tidak boleh dijalankan di Workspace — sila lengkapkan Langkah 5 terlebih dahulu.',
    'prostudio.agentsec.nonePickedTitle': 'Tiada agent dipilih',
    'prostudio.agentsec.nonePickedBody': 'Pilih agent di sebelah kiri, atau klik "Agent Baru".',
    'prostudio.agentsec.unnamed': 'Agent tanpa nama',
    'prostudio.agentsec.unsaved': 'Belum disimpan',
    'prostudio.agentsec.saved': 'Disimpan',
    'prostudio.agentsec.saving': 'Menyimpan...',
    'prostudio.agentsec.save': 'Simpan',
    'prostudio.agentsec.saveTitleOn': 'Simpan semua perubahan pada agent ini',
    'prostudio.agentsec.saveTitleOff': 'Tiada perubahan untuk disimpan',
    'prostudio.agentsec.s1sub': 'Maklumat asas custom GPT yang anda miliki.',
    'prostudio.agentsec.agentNamePh': 'cth: Storyboard GPT (Cikgu Ali)',
    'prostudio.agentsec.soon': 'SOON',
    'prostudio.agentsec.s2sub': 'Apa yang SESAAT hantar kepada agent anda setiap kali ia dijalankan.',
    'prostudio.agentsec.extraLineHint': 'Ayat ini ditampal di hujung mesej pertama, selepas nama dan link produk. Ia digunakan untuk {b} produk yang anda jalankan dengan agent ini — tidak perlu menaipnya semula pada setiap kad produk.',
    'prostudio.agentsec.extraLineHintEvery': 'setiap',
    'prostudio.agentsec.repliesLabel': 'Balasan berturutan (pilihan)',
    'prostudio.agentsec.repliesNote': 'Sesetengah agent {b1} sebelum menghasilkan output. Taipkan jawapan anda di sini mengikut urutan. SESAAT akan menghantarnya satu persatu dan menunggu agent selesai membalas setiap kali, kemudian mengambil {b2} sebagai output. Biarkan kosong jika agent anda terus memberikan output pada mesej pertama.',
    'prostudio.agentsec.repliesNoteAsk': 'bertanya soalan dahulu',
    'prostudio.agentsec.repliesNoteLast': 'jawapan terakhir',
    'prostudio.agentsec.replyPh1': 'Jawapan anda kepada soalan pertama agent',
    'prostudio.agentsec.replyPhN': 'Jawapan anda kepada soalan ke-{n}',
    'prostudio.agentsec.removeReply': 'Buang balasan ini',
    'prostudio.agentsec.addReply': 'Tambah Balasan',
    'prostudio.agentsec.repliesTimeHint': 'Setiap balasan menambah lebih kurang satu minit kepada masa larian bagi setiap produk.',
    'prostudio.agentsec.imgFirstToggle': 'Simpan gambar daripada jawapan pertama',
    'prostudio.agentsec.imgReplyToggle': 'Simpan gambar daripada jawapan ini',
    'prostudio.agentsec.imgCount': '{n}/{max} gambar ditanda',
    'prostudio.agentsec.imgNote': 'Hidupkan suis "Simpan gambar" pada jawapan yang agent anda keluarkan gambar (contoh: product sheet atau storyboard). SESAAT tunggu gambar itu siap, muat turun, dan simpan ke kad sebagai gambar tambahan — sehingga 5 gambar setiap kad termasuk gambar utama. Larian kedua menambah, bukan mengganti.',
    'prostudio.agentsec.imgFull': 'Had dicapai — matikan satu suis dahulu untuk menanda yang lain.',
    'prostudio.agentsec.previewImgMark': 'SESAAT simpan gambar daripada jawapan ini ke dalam kad',
    'prostudio.agentsec.sumImgOne': 'SESAAT juga menyimpan 1 gambar daripada jawapan agent ke dalam kad.',
    'prostudio.agentsec.sumImgMany': 'SESAAT juga menyimpan {n} gambar daripada jawapan agent ke dalam kad.',
    // Data produk yang ditampal kepada agent (Langkah 2) — 2026-08-21
    'prostudio.agentsec.dataLabel': 'Data produk yang SESAAT hantar',
    'prostudio.agentsec.produkPilih': 'Pilih produk',
    'prostudio.agentsec.produkCari': 'Cari nama produk…',
    'prostudio.agentsec.produkTiadaPadan': 'Tiada produk sepadan.',
    'prostudio.agentsec.produkReadyKosong': 'Tiada produk READY dalam My Products. Lengkapkan data sekurang-kurangnya satu produk di halaman Products sebelum menjalankan Configure.',
    'prostudio.agentsec.dataHint': 'Semua data produk yang ada pada kad — harga, kategori, spesifikasi, ulasan pelanggan dan lain-lain — ditampal sekali dengan nama dan link. Untuk mengubah data itu, gunakan borang Edit Data Produk pada halaman Products.',
    'prostudio.agentsec.previewDataEmpty': '(produk ujian ini belum ada data diisi)',
    'prostudio.agentsec.previewTitle': 'Contoh perbualan',
    'prostudio.agentsec.previewProduct': 'Nama produk anda',
    'prostudio.agentsec.previewAgentFallback': 'Agent anda',
    'prostudio.agentsec.previewReplyWord': 'balasan',
    'prostudio.agentsec.previewNoExtra': '(tiada ayat arahan tambahan)',
    'prostudio.agentsec.previewAsk': 'Agent anda bertanya soalan…',
    'prostudio.agentsec.previewLastReply': 'Balasan terakhir agent anda',
    'prostudio.agentsec.previewOutputBadge': 'SESAAT ambil balasan terakhir ini sebagai output',
    'prostudio.agentsec.previewFoot': 'Contoh sahaja — nama dan link produk sebenar diisi masa larian.',
    'prostudio.agentsec.s3sub': 'Tetapkan apa yang SESAAT patut hasilkan untuk setiap produk.',
    'prostudio.agentsec.setsHint': 'Satu set = satu hasil lengkap. Tiga set = tiga versi berbeza bagi produk yang sama.',
    'prostudio.agentsec.kunciTip': 'Belum tersedia — perlukan extension versi baharu',
    'prostudio.agentsec.babakKunciNota': 'Buat masa ini 1 hingga {siap} babak sahaja boleh dijalankan. Pilihan {seterusnya} ke atas akan dibuka apabila extension versi baharu dikeluarkan.',
    'prostudio.agentsec.hasilKunciNota': 'Buat masa ini setiap larian menjana gambar dan video. Pilihan gambar sahaja akan dibuka bersama extension versi baharu.',
    'prostudio.agentsec.produkKunciNota': 'Buat masa ini gambar produk sentiasa digunakan pada setiap babak. Memilih babak tertentu akan dibuka bersama extension versi baharu.',
    'prostudio.agentsec.avatarKunciNota': 'Guna atau tidak guna avatar dipilih di Workspace masa Generate (No avatar / Male / Female / avatar anda). Meletak avatar pada babak tertentu akan dibuka bersama extension versi baharu.',
    'prostudio.agentsec.scenesHint': 'Babak = potongan cerita di dalam satu set. Maksimum {n} babak.',
    'prostudio.agentsec.productPhotoHint': 'Gambar produk sebenar dimuat naik ke Flow sebagai rujukan — supaya produk kelihatan tepat, bukan rekaan AI.',
    'prostudio.agentsec.avatarLabel': 'Gambar avatar digunakan pada',
    'prostudio.agentsec.avatarHint': 'Avatar ialah wajah model tetap anda. Gunakannya supaya semua video kelihatan datang daripada orang yang sama.',
    'prostudio.agentsec.sceneEvery': 'Setiap babak',
    'prostudio.agentsec.sceneOnly': 'Babak {n} sahaja',
    'prostudio.agentsec.summary': 'RINGKASAN',
    'prostudio.agentsec.s4sub': 'Jalankan sekali dengan satu produk supaya SESAAT belajar membaca output agent anda.',
    'prostudio.agentsec.perSceneNote': 'Diulang {n}× bagi setiap set.',
    'prostudio.agentsec.perSetTitle': 'Sekali sahaja setiap set',
    'prostudio.agentsec.perSetNote': 'Tidak diulang mengikut babak.',
    'prostudio.agentsec.videoHidden': 'Field {b1} disembunyikan kerana Langkah 3 ditetapkan sebagai {b2}.',
    'prostudio.agentsec.fieldTypes': 'Dua jenis field:',
    'prostudio.agentsec.fieldEngine': 'ENJIN',
    'prostudio.agentsec.fieldEngineDesc': '— digunakan oleh automation Flow untuk menjana gambar dan video. Field ini wajib ada, tetapi anda boleh menamakannya ikut suka.',
    'prostudio.agentsec.fieldText': 'TEKS',
    'prostudio.agentsec.fieldTextDesc': '— dibawa masuk ke kad produk untuk paparan dan salinan (contoh: hook, skrip video, caption). Anda bebas menambah seberapa banyak yang perlu.',
    'prostudio.agentsec.lockedField': 'Field wajib — automation Flow menggunakan field ini untuk menjana gambar dan video.',
    'prostudio.agentsec.s5sub': 'Jalankan sekali dengan satu produk supaya SESAAT belajar membaca output agent anda.',
    'prostudio.agentsec.geminiModel': 'Model Gemini',
    'prostudio.agentsec.geminiModelDefault': 'Ikut tetapan Gemini',
    'prostudio.agentsec.geminiModelEmpty': 'Jalankan Configure di atas — selepas itu model akaun Gemini anda akan tersenarai di sini untuk dipilih.',
    'prostudio.agentsec.geminiModelFail': 'Senarai model akaun anda tidak dapat dibaca daripada Gemini. Tekan Configure Semula di atas untuk mencuba lagi.',
    'prostudio.agentsec.geminiModelHint': 'Menukar model memadam status Configured — jalankan Configure semula selepas menukar.',
    'prostudio.agentsec.runNote': 'Satu produk sebenar akan dihantar kepada agent anda melalui Extension SESAAT. Satu tab ChatGPT akan dibuka — {b} (lebih kurang satu hingga dua minit).',
    'prostudio.agentsec.runNoteStrong': 'biarkan ia berjalan sehingga selesai',
    'prostudio.agentsec.configuredOn': 'Agent ini telah dikonfigurasi pada {tarikh}. Anda boleh menjalankannya di Workspace.',
    'prostudio.agentsec.productsLoading': 'Memuatkan produk...',
    'prostudio.agentsec.productsEmpty': 'Tiada produk dalam Workspace',
    'prostudio.agentsec.productsEmptyHint': 'Tambah sekurang-kurangnya satu produk di Workspace sebelum menjalankan Configure.',
    'prostudio.agentsec.runBlockedUrl': 'Isi URL Custom GPT terlebih dahulu',
    'prostudio.agentsec.runBlockedProduct': 'Pilih produk untuk ujian terlebih dahulu',
    'prostudio.agentsec.runReady': 'Jalankan sekali untuk belajar format output',
    'prostudio.agentsec.running': 'Sedang menguji...',
    'prostudio.agentsec.configureAgain': 'Configure Semula',
    'prostudio.agentsec.configureAgent': 'Configure Agent',
    'prostudio.agentsec.notConfiguredTitle': 'Agent ini belum dikonfigurasi',
    'prostudio.agentsec.notConfiguredBody': 'Klik {b} di atas. SESAAT akan menghantar satu produk kepada agent anda, kemudian memadankan jawapannya dengan borang di Langkah 4 secara automatik. Anda hanya perlu menyemak dan mengesahkan.',
    'prostudio.agentsec.outputFrom': 'Output diambil daripada',
    'prostudio.agentsec.turnFirst': 'Jawapan pertama',
    'prostudio.agentsec.turnAfter': 'Selepas Balasan {n}',
    'prostudio.agentsec.turnEmpty': ' — kosong',
    'prostudio.agentsec.turnChars': ' — {n} aksara',
    'prostudio.agentsec.rematching': 'Memadankan semula...',
    'prostudio.agentsec.outputFromHint': 'Sesetengah agent memberikan output akhir hanya selepas beberapa balasan. Pilih pusingan yang mengandungi output sebenar — SESAAT akan memadankan semula serta-merta tanpa perlu menjalankan agent sekali lagi.',
    'prostudio.agentsec.matchTitle': 'Padanan yang dikesan',
    'prostudio.agentsec.matchBadge': '{set} SET · {babak} BABAK DIKESAN',
    'prostudio.agentsec.matchCheck': 'Semak setiap baris. Tukar jika padanan tidak tepat.',
    'prostudio.agentsec.missingWarn': '{b} belum berpadan. Automation Flow tidak dapat dijalankan tanpa field ini. Sila pilih sumbernya secara manual di bawah, atau jalankan Configure semula.',
    'prostudio.agentsec.missingAnd': ' dan ',
    'prostudio.agentsec.matchScene': 'Setiap babak — diulang {n}×',
    'prostudio.agentsec.colField': 'FIELD ANDA',
    'prostudio.agentsec.colSource': 'SUMBER DALAM OUTPUT AGENT',
    'prostudio.agentsec.colNone': '— Tiada —',
    'prostudio.agentsec.composerPh': 'Susun output di sini — klik blok di bawah untuk selitkan.',
    'prostudio.agentsec.composerInsert': 'Klik untuk selit:',
    /* ⚠️ Lihat nota dalam en.js — dua kunci ini dahulu berkongsi nama dengan
       kunci panel "Contoh perbualan", jadi tajuk Langkah 2 tersalah papar. */
    'prostudio.agentsec.previewKadTitle': 'Pratonton kad produk',
    'prostudio.agentsec.previewHint': 'Beginilah rupa di Workspace. Teks datang dari output Gem semasa Configure.',
    'prostudio.agentsec.previewKadProduk': 'Produk ujian',
    'prostudio.agentsec.previewSet': 'Set {n}',
    'prostudio.agentsec.previewEmpty': '— kosong (agent tidak keluarkan bahagian ini) —',
    'prostudio.agentsec.seeRaw': 'Lihat jawapan penuh daripada agent',
    'prostudio.agentsec.seeRawFirst': 'jawapan pertama',
    'prostudio.agentsec.seeRawAfter': 'selepas Balasan {n}',
    'prostudio.agentsec.saveHintTop': 'Semak padanan di atas, kemudian tekan {b} di bar atas — semua perubahan (Langkah 1 hingga 5) disimpan sekali.',
    'prostudio.agentsec.prev': 'Sebelum',
    'prostudio.agentsec.footNoteLabel': 'Nota:',
    'prostudio.agentsec.footNote': 'Agent yang telah dikonfigurasi akan muncul dalam pilihan di tab {b} di Workspace. Pilih produk anda di sana, kemudian jalankan secara berkelompok dengan satu klik — tidak perlu Configure semula.',
    'prostudio.agentsec.errCreate': 'Gagal mencipta agent baharu: ',
    'prostudio.agentsec.errDelete': 'Gagal memadam agent: ',
    'prostudio.agentsec.errSave': 'Gagal menyimpan agent: ',
    'prostudio.agentsec.confirmDelete': 'Padam agent "{nama}"? Tindakan ini tidak boleh dibatalkan.',
    'prostudio.agentsec.errTurnEmpty': 'Pusingan yang dipilih tidak mengandungi jawapan yang boleh dipadankan. Pilih pusingan lain.',
    'prostudio.agentsec.errRematch': 'Gagal memadankan semula. Sila cuba lagi.',
    'prostudio.agentsec.errNoProduct': 'Sila pilih produk untuk ujian terlebih dahulu.',
    'prostudio.agentsec.errNoExt': 'Extension SESAAT tidak dapat dihubungi. Pastikan ia dipasang dan aktif, kemudian refresh halaman ini.',
    'prostudio.agentsec.errNoAnswer': 'Agent tidak memberikan jawapan.',
    'prostudio.agentsec.errShort': 'Jawapan daripada agent kosong atau terlalu pendek. Pastikan GPT tersebut benar-benar membalas, kemudian cuba semula.',
    'prostudio.agentsec.errRun': 'Configure gagal. Sila cuba semula.',
    'prostudio.agentsec.errNoReply': 'Tiada jawapan daripada extension.',
    'prostudio.agentsec.errTimeout': 'Tamat masa menunggu jawapan agent ({n} minit).',
    'prostudio.agentsec.sumSetOne': 'Setiap produk menghasilkan {n} set.',
    'prostudio.agentsec.sumSetMany': 'Setiap produk menghasilkan {n} set — bermakna {n} hasil berasingan.',
    'prostudio.agentsec.sumSceneOne': 'Setiap set mengandungi 1 babak sahaja.',
    'prostudio.agentsec.sumSceneMany': 'Setiap set mengandungi {n} babak.',
    'prostudio.agentsec.sumImageOnly': 'SESAAT menjana {n} gambar sahaja — tiada video.',
    'prostudio.agentsec.sumImageVideo': 'SESAAT menjana {n} gambar, kemudian {n} video daripada gambar tersebut.',
    'prostudio.agentsec.sumPhotoNone': 'Gambar produk tidak dimasukkan.',
    'prostudio.agentsec.sumPhotoAll': 'Gambar produk dimasukkan pada setiap babak.',
    'prostudio.agentsec.sumPhotoOne': 'Gambar produk dimasukkan pada babak {n} sahaja.',
    'prostudio.agentsec.sumAvatarNone': 'Avatar tidak digunakan.',
    'prostudio.agentsec.sumAvatarAll': 'Avatar digunakan pada setiap babak.',
    'prostudio.agentsec.sumAvatarOne': 'Avatar digunakan pada babak {n} sahaja.',
    'prostudio.hub.previewBody': 'Ini tempat anda akan menyimpan gaya, hook dan arahan sendiri nanti. Klik mana-mana bahagian untuk melihat rupanya; tetapan belum boleh diubah buat masa ini.',
    'prostudio.hub.previewTitle': 'Belum dibuka — anda boleh tinjau dahulu.',
    'prostudio.hub.stat.agents': 'Agent tersambung',
    'prostudio.hub.stat.agentsHint': 'Custom GPT milik anda',
    'prostudio.hub.stat.groups': 'Group hook',
    'prostudio.hub.stat.groupsHint': 'Dikongsi semua module',
    'prostudio.hub.stat.templates': 'Template gaya',
    'prostudio.hub.stat.templatesHint': 'Slot ikut pakej langganan',
    'prostudio.hub.subtitle': 'Tempat anda simpan gaya, hook dan arahan sendiri. Apa yang disimpan di sini digunakan setiap kali anda tekan Generate di Workspace.',
    'prostudio.planNote': 'Pelan · /prostudio-v3.9',
    'prostudio.ready': 'Sedia',
    'prostudio.saved': 'Disimpan',
    'prostudio.section.agent.desc': 'Sambungkan custom GPT milik anda sendiri supaya SESAAT boleh menggunakannya semasa Generate.',
    'prostudio.section.agent.label': 'Agent Saya',
    'prostudio.cta.pageDesc': "Teks pada beg kuning TikTok dan beg produk Shopee di Facebook Reels.",
    'prostudio.cta.addTitle': "Tambah CTA",
    'prostudio.cta.addHint': "Teks ini muncul pada butang pautan produk (beg kuning) dalam video TikTok anda.",
    'prostudio.cta.add': "Tambah",
    'prostudio.cta.loading': "Memuatkan…",
    'prostudio.cta.save': "Simpan",
    'prostudio.cta.cancel': "Batal",
    'prostudio.cta.edit': "Edit",
    'prostudio.cta.defaultBadge': "Lalai",
    'prostudio.cta.defaultHint': "Digunakan secara automatik selagi anda tidak memilih CTA lain. Tidak boleh dipadam.",
    'prostudio.cta.delete': "Padam",
    'prostudio.cta.footNote': "Untuk memilih CTA mana yang dipakai semasa Run: buka Workspace → panel kanan → tab Schedule. Pilihan itu disimpan pada browser ini sahaja, jadi setiap browser boleh guna CTA berbeza.",
    'prostudio.section.shortcut.label': "Shortcut /",
    'prostudio.section.shortcut.desc': "Simpan teks yang kerap digunakan. Taip \"/\" dalam Edit Prompts untuk memasukkannya.",
    'prostudio.hub.badge.shortcut': "{n} shortcut",
    'prostudio.sc.pageDesc': "Teks tersimpan yang boleh dimasukkan ke mana-mana kotak Edit Prompts dengan menaip \"/\".",
    'prostudio.sc.addTitle': "Tambah shortcut",
    'prostudio.sc.addHint': "Di Workspace, buka Edit Prompts dan taip \"/\" untuk memilih shortcut. Teksnya akan dimasukkan di tempat kursor.",
    'prostudio.sc.teksPlaceholder': "Teks yang akan dimasukkan bila shortcut ini dipilih…",
    'prostudio.sc.add': "Simpan shortcut",
    'prostudio.sc.loading': "Memuatkan…",
    'prostudio.sc.empty': "Belum ada shortcut. Simpan yang pertama di atas.",
    'prostudio.sc.save': "Simpan",
    'prostudio.sc.cancel': "Batal",
    'prostudio.sc.edit': "Edit",
    'prostudio.sc.delete': "Padam",
    'prostudio.sc.confirmDelete': "Padam shortcut ini?",
    'prostudio.sc.locked': "Dikunci",
    'prostudio.sc.foot': "Anda boleh menyimpan sehingga {n} shortcut. Shortcut disimpan pada akaun anda, jadi ia sama di semua browser.",
    'prostudio.sc.err.kosong': "Isi nama dan teks dahulu.",
    'prostudio.sc.err.namaSalah': "Nama hanya boleh mengandungi huruf kecil, nombor dan _ (2–40 aksara), tanpa jarak.",
    'prostudio.sc.err.namaWujud': "Nama ini sudah digunakan. Sila pilih nama lain.",
    'prostudio.sc.err.terlaluPanjang': "Teks terlalu panjang (maksimum {n} aksara).",
    'prostudio.sc.err.hadPenuh': "Had {n} shortcut telah dicapai. Padam yang tidak digunakan dahulu.",
    'prostudio.sc.err.tiadaLagi': "Shortcut ini sudah dipadam di browser lain.",
    'prostudio.sc.err.ditolak': "Simpanan ditolak. Sila refresh halaman dan cuba lagi.",
    'prostudio.sc.err.umum': "Gagal menyimpan. Sila cuba lagi.",
    'prostudio.sc.err.padam': "Gagal memadam. Sila cuba lagi.",
    'prostudio.sc.err.muat': "Senarai shortcut tidak dapat dimuatkan. Sila refresh halaman.",
    'ws.sc.loading': "Memuatkan shortcut…",
    'ws.sc.empty': "Belum ada shortcut. Cipta di PRO Studio → Shortcut /.",
    'ws.sc.noMatch': "Tiada shortcut sepadan.",
    'ws.sc.hint': "↑↓ pilih · Enter masukkan · Esc tutup",
    'ciri.shortcut.popupTitle': "Cuba features \"Shortcut /\" secara percuma",
    'ciri.shortcut.popupBody': "Simpan prompt yang kerap anda guna, kemudian taip \"/\" dalam Edit Prompts untuk memasukkannya serta-merta.",
    'ciri.cta.popupTitle': "Cuba features \"CTA Beg Kuning\" secara percuma",
    'ciri.cta.popupBody': "Guna ayat anda sendiri pada beg kuning TikTok dan beg produk Shopee di Facebook Reels, bukan lagi \"BELI KAT SINI\". Pilih ayat CTA yang anda mahu gunakan di Control Panel.",
    'ciri.badgeFree': "Percuma sehingga 30 November 2026",
    'ciri.badgeGift': "Percuma untuk anda",
    'ciri.badgeShort': "Percuma hingga 30 Nov",
    'ciri.box.proTitle': "Sebahagian daripada PRO Studio",
    'ciri.box.proBody': "Pakej tambahan berbayar yang sedang kami siapkan.",
    'ciri.box.dateTitle': "Percuma sehingga 30 November 2026",
    'ciri.box.dateBody': "Selepas tarikh ini, ciri ini memerlukan pakej PRO Studio.",
    'ciri.later': "Nanti dulu",
    'ciri.claim': "Saya faham, aktifkan percuma",
    'ciri.claiming': "Mengaktifkan…",
    'ciri.activate': "Aktifkan percuma",
    'ciri.err.tamat': "Tempoh percuma sudah tamat.",
    'ciri.err.umum': "Tidak dapat mengaktifkan sekarang. Sila cuba lagi.",
    'ciri.st.admin': "Admin",
    'ciri.st.aktif': "Aktif · hingga {tarikh}",
    'ciri.st.tamat': "Tamat",
    'ciri.myplan.desc': "Ciri yang sudah siap boleh dicuba percuma sehingga 30 November 2026.",
    'ciri.myplan.cta': "CTA Beg Kuning",
    'ciri.myplan.agentSmart': "Ikut module SMART",
    'ciri.myplan.soonList': "Gaya · Hook Bank · Prompt Saya · Template Saya",
    'prostudio.ctaLock.belum': "CTA Beg Kuning percuma sehingga 30 November 2026. Aktifkan dahulu untuk menambah dan menggunakan CTA anda sendiri.",
    'prostudio.ctaLock.tamat': "Tempoh percuma CTA Beg Kuning telah tamat. CTA anda masih disimpan dan boleh digunakan semula dengan pakej PRO Studio.",
    'prostudio.sc.err.terkunci': "Aktifkan Shortcut / percuma dahulu untuk menyimpan.",
    'prostudio.sc.lockedBelum': "Shortcut / percuma sehingga 30 November 2026. Aktifkan dahulu untuk mula menyimpan.",
    'prostudio.sc.lockedTamat': "Tempoh percuma telah tamat. Shortcut anda masih disimpan dan boleh digunakan semula dengan pakej PRO Studio.",
    'prostudio.sc.footAktif': "Percuma sehingga 30 November 2026. Anda boleh menyimpan sehingga {n} shortcut, dan ia sama di semua browser.",
    'ws.sc.lockedBelum': "Shortcut / percuma sehingga 30 November 2026.",
    'ws.sc.lockedTamat': "Tempoh percuma Shortcut / telah tamat.",
    'ws.sc.activate': "Aktifkan sekarang",
    'workspace.cta.lockedTag': "dikunci",
    'workspace.cta.lockedBelum': "CTA anda sendiri dikunci. Lalai \"BELI KAT SINI\" digunakan.",
    'workspace.cta.lockedTamat': "Tempoh percuma CTA sendiri telah tamat. Lalai \"BELI KAT SINI\" digunakan.",
    'workspace.cta.activate': "Aktifkan CTA percuma hingga 30 Nov 2026",
    'workspace.cta.label': "CTA beg kuning",
    'workspace.cta.hint': "Teks butang pada pautan produk. Disimpan pada browser ini sahaja.",
    'workspace.cta.hintFb': "Ayat pada pautan produk reel (Facebook: Link name). Sama dengan CTA beg kuning TikTok — satu pilihan untuk kedua-dua. Disimpan pada browser ini sahaja.",
    'workspace.cta.default': "Lalai — BELI KAT SINI",
    'workspace.cta.manage': "Urus senarai di PRO Studio",
    'workspace.cta.missing': "CTA yang anda pilih sudah tiada. Lalai digunakan.",
    'prostudio.section.blok.desc': 'Seluruh arahan GOYANG, dipecahkan kepada block yang boleh anda edit, susun semula atau kunci sepatah demi sepatah.',
    'prostudio.section.blok.label': 'Blocks (prototaip)',
    'prostudio.section.cta.desc': "Teks pada beg kuning TikTok dan beg produk Shopee di Facebook Reels. Ayat caption menyusul kemudian.",
    'prostudio.section.cta.label': 'CTA & Hashtag',
    'prostudio.section.gaya.desc': 'Sudut kamera, latar, ekspresi dan cahaya — disimpan sebagai template, boleh berbeza ikut set.',
    'prostudio.section.gaya.label': 'Gaya',
    'prostudio.section.hook.desc': 'Simpan ayat pembuka anda. Sistem mencabut satu secara rawak setiap kali Generate.',
    'prostudio.section.hook.label': 'Hook Bank',
    'prostudio.section.prompt.desc': 'Arahan tetap anda yang ditambah pada setiap prompt gambar dan video.',
    'prostudio.section.prompt.label': 'Prompt Saya',
    'prostudio.section.template.desc': 'Gaya, hook dan CTA dibungkus menjadi satu pakej yang boleh ditukar sekali klik.',
    'prostudio.section.template.label': 'Template Saya',
    'prostudio.set.all.sub': 'Set 1 + 2 + 3 guna tetapan yang sama',
    'prostudio.set.all.title': 'Semua set',
    'prostudio.set.s1.sub': 'Angle: masalah',
    'prostudio.set.s1.title': 'Set 1',
    'prostudio.set.s2.sub': 'Angle: hasil / manfaat',
    'prostudio.set.s2.title': 'Set 2',
    'prostudio.set.s3.sub': 'Angle: curiosity',
    'prostudio.set.s3.title': 'Set 3',
    'prostudio.slotFull': 'Slot penuh',
    'prostudio.soon': 'Akan datang',
    'prostudio.soonBody': 'Ia akan dibuka selepas Gaya dan Hook Bank stabil.',
    'prostudio.soonTitle': 'Bahagian ini belum dibina',
    'prostudio.style.allSets': 'Semua set',
    'prostudio.style.allSetsSame': 'Semua set sama',
    'prostudio.style.applyBy': 'Tetapan ikut',
    'prostudio.style.auto': 'Auto (AI tentukan)',
    'prostudio.style.copyToOther': 'Salin tetapan set ini ke set lain',
    'prostudio.style.deleteTemplate': 'Padam template',
    'prostudio.style.emptyBody': 'Pilih satu template di sebelah kiri, atau cipta yang baharu.',
    'prostudio.style.emptyTitle': 'Tiada template dipilih',
    'prostudio.style.extraInstruction': 'Arahan tambahan (pilihan)',
    'prostudio.style.extraPlaceholder': 'Contoh: suasana pagi yang tenang',
    'prostudio.style.field.angle': 'Sudut kamera',
    'prostudio.style.field.expression': 'Ekspresi model',
    'prostudio.style.field.light': 'Pencahayaan',
    'prostudio.style.field.location': 'Lokasi / latar',
    'prostudio.style.isDefaultTpl': 'Template lalai anda',
    'prostudio.style.makeDefaultTpl': 'Jadikan template lalai',
    'prostudio.style.module': 'Module',
    'prostudio.style.moduleSoon': '{nama} — akan datang',
    'prostudio.style.moduleTitle': 'Tetapan gaya {nama}',
    'prostudio.style.newTemplate': 'Template baharu',
    'prostudio.style.noTemplate': 'Belum ada template.',
    'prostudio.style.pageDesc': 'Tetapan rupa gambar dan video untuk setiap set. Disimpan sebagai template — anda boleh ada beberapa dan tukar bila-bila.',
    'prostudio.style.perSet': 'Ikut set',
    'prostudio.style.random': 'Rawak',
    'prostudio.style.randomCount': 'Setiap Generate: satu dipilih secara rawak daripada {n} pilihan.',
    'prostudio.style.randomEmpty': 'Tanda sekurang-kurangnya satu pilihan untuk dirawak.',
    'prostudio.style.randomOff': 'Tutup mod rawak — kembali kepada satu nilai',
    'prostudio.style.randomOn': 'Mod rawak: tanda beberapa pilihan, sistem memilih satu setiap kali Generate',
    'prostudio.style.templateName': 'Nama template',
    'prostudio.style.templatesDesc': 'Bintang menandakan template lalai anda di Workspace.',
    'prostudio.style.templatesTitle': 'Template anda',
    'prostudio.wizard.add': 'Tambah agent',
    'prostudio.wizard.agentName': 'Nama agent',
    'prostudio.wizard.agentNameHint': 'Nama ini yang anda akan pilih di Workspace nanti.',
    'prostudio.wizard.agentNamePh': 'Contoh: Agent Skincare Saya',
    'prostudio.wizard.avatar': 'Avatar',
    'prostudio.wizard.avatarNone': 'Tidak digunakan',
    'prostudio.wizard.avatarUse': 'Guna avatar saya',
    'prostudio.wizard.back': 'Sebelum',
    'prostudio.wizard.cannotRun': 'Agent yang belum Configure tidak boleh dijalankan di Workspace — buka dan lengkapkan Langkah 5 terlebih dahulu.',
    'prostudio.wizard.deleteAgent': 'Padam agent',
    'prostudio.wizard.doneBody': 'Ia kini muncul dalam pilihan agent di Workspace. Pilih produk anda di sana, kemudian jalankan berkelompok — tidak perlu Configure semula.',
    'prostudio.wizard.doneTitle': '{nama} sedia digunakan.',
    'prostudio.wizard.dragHandle': 'Tarik untuk susun',
    'prostudio.wizard.showInWs': 'Papar di Workspace',
    'prostudio.wizard.hiddenFromWs': 'Disorok dari Workspace',
    'prostudio.wizard.moreActions': 'Tindakan lain',
    'prostudio.wizard.showInWsFail': 'Tetapan ini gagal disimpan: ',
    'prostudio.wizard.configureFirst': 'Agent ini belum Configure. Buka dan lengkapkan Langkah 5 — ia akan muncul di Workspace secara automatik sebaik sahaja siap.',
    'prostudio.wizard.edit': 'Edit',
    'prostudio.wizard.emptyBody': 'Sambungkan custom GPT milik anda supaya SESAAT boleh menggunakannya semasa Generate.',
    'prostudio.wizard.emptyTitle': 'Belum ada agent',
    'prostudio.wizard.errName': 'Beri nama kepada agent ini dahulu.',
    'prostudio.wizard.errNotRun': 'Jalankan Configure sekali sebelum menyimpan.',
    'prostudio.wizard.errProduct': 'Pilih satu produk untuk ujian.',
    'prostudio.wizard.errUrlBad': 'Pautan itu bukan pautan custom GPT. Ia sepatutnya bermula dengan chatgpt.com/g/',
    'prostudio.wizard.errUrlEmpty': 'Tampal pautan custom GPT anda.',
    'prostudio.wizard.extraLine': 'Ayat arahan tambahan (pilihan)',
    'prostudio.wizard.extraLineHint': 'Ditampal di hujung mesej pertama, selepas nama dan pautan produk. Ia digunakan untuk setiap produk yang anda jalankan dengan agent ini.',
    'prostudio.wizard.extraLinePh': 'Contoh: gunakan gaya bahasa santai. Fokus kepada masalah kulit berminyak.',
    'prostudio.wizard.fieldImage': 'Prompt Gambar',
    'prostudio.wizard.fieldVideo': 'Prompt Video',
    'prostudio.wizard.fieldCaption': 'Caption TikTok',
    'prostudio.wizard.fieldHook': 'Hook Text',
    'prostudio.wizard.fieldScript': 'Video Script',
    'prostudio.wizard.finalOutput': 'Hasil akhir',
    'prostudio.wizard.finish': 'Selesai',
    'prostudio.wizard.gptUrl': 'Pautan custom GPT',
    'prostudio.wizard.gptUrlHint': 'Buka GPT itu dalam pelayar anda, kemudian salin alamat daripada bar alamat.',
    'prostudio.wizard.gemUrl': 'Pautan Gem',
    'prostudio.wizard.gemUrlHint': 'Buka Gem itu dalam pelayar anda, kemudian salin alamat daripada bar alamat.',
    'prostudio.wizard.listDesc': 'Setiap agent disediakan sekali sahaja, kemudian boleh dipilih di Workspace.',
    'prostudio.wizard.listTitle': 'Agent anda',
    'prostudio.wizard.matchOk': 'Jawapan daripada agent anda difahami. Semak padanan di bawah — tukar kalau ada yang tidak tepat.',
    'prostudio.wizard.moveDown': 'Turun',
    'prostudio.wizard.moveUp': 'Naik',
    'prostudio.wizard.next': 'Seterusnya',
    'prostudio.wizard.notConfigured': 'Belum Configure',
    'prostudio.wizard.orderFail': 'Susunan baharu gagal disimpan: ',
    'prostudio.wizard.outImageOnly': 'Gambar sahaja',
    'prostudio.wizard.outImageOnlySub': 'Berhenti di situ. Sesuai untuk poster.',
    'prostudio.wizard.outImageVideo': 'Gambar dan video',
    'prostudio.wizard.outImageVideoSub': 'Generate gambar, kemudian animasikan.',
    'prostudio.wizard.photoEvery': 'Setiap babak',
    'prostudio.wizard.photoLast': 'Babak terakhir sahaja',
    'prostudio.wizard.photoNone': 'Tidak dimasukkan',
    'prostudio.wizard.pickProduct': '— Pilih satu produk —',
    'prostudio.wizard.platform': 'Platform',
    'prostudio.wizard.platformHint': 'Pilih tempat agent ini berada. Menukarnya membatalkan kalibrasi — jalankan Configure semula.',
    'prostudio.wizard.productPhoto': 'Gambar produk dimasukkan pada',
    'prostudio.wizard.ready': 'Ready',
    'prostudio.wizard.replies': 'Berapa kali agent membalas sebelum siap',
    'prostudio.wizard.repliesHint': 'Setengah agent bertanya soalan dahulu sebelum memberi output. Kalau agent anda terus memberi output pada mesej pertama, biarkan pada 1.',
    'prostudio.wizard.rowMeta': '{set} set · {babak} babak · {hasil}',
    'prostudio.wizard.rowUnfinished': 'Belum lengkap — Langkah 5 belum dijalankan',
    'prostudio.wizard.run1': 'Menyemak sambungan extension',
    'prostudio.wizard.run2': 'Menghantar produk dan menunggu jawapan agent',
    'prostudio.wizard.run3': 'Memadankan jawapan dengan borang anda',
    'prostudio.wizard.runAgain': 'Jalankan semula',
    'prostudio.wizard.runConfigure': 'Jalankan Configure',
    'prostudio.wizard.s1.name': 'Agent anda',
    'prostudio.wizard.s1.q': 'Agent yang mana?',
    'prostudio.wizard.s2.name': 'Perbualan',
    'prostudio.wizard.s2.q': 'Apa yang SESAAT beritahu agent anda?',
    'prostudio.wizard.s3.name': 'Hasil',
    'prostudio.wizard.s3.q': 'Anda mahu hasil apa?',
    'prostudio.wizard.s4.name': 'Configure',
    'prostudio.wizard.s4.q': 'Mari uji sekali',
    'prostudio.wizard.s5.name': 'Configure',
    'prostudio.wizard.s5.q': 'Mari uji sekali',
    'prostudio.wizard.scenesPerSet': 'Berapa babak setiap set',
    'prostudio.wizard.setsPerProduct': 'Berapa set setiap produk',
    'prostudio.wizard.sketchBody': 'Tiada apa-apa yang disimpan. Muat semula halaman dan semuanya kembali kosong.',
    'prostudio.wizard.sketchTitle': 'Lakaran sahaja',
    'prostudio.wizard.stepOf': 'Langkah {n} daripada 4',
    'prostudio.wizard.sumAgent': 'Agent',
    'prostudio.wizard.sumDesc': 'Tekan Edit pada mana-mana baris untuk kembali ke langkah itu sahaja.',
    'prostudio.wizard.sumFields': 'Medan output',
    'prostudio.wizard.sumFieldsValue': '{n} medan',
    'prostudio.wizard.sumOutput': 'Hasil',
    'prostudio.wizard.sumPlatform': 'Platform',
    'prostudio.wizard.sumReplies': 'Balasan berturutan',
    'prostudio.wizard.sumSentence': 'Setiap produk menghasilkan {set} set. Setiap set mengandungi {babak} babak. {hasil} Gambar produk: {gambar}. Avatar: {avatar}.',
    'prostudio.wizard.sumSentenceImage': 'SESAAT menjana gambar sahaja — tiada video.',
    'prostudio.wizard.sumSentenceVideo': 'SESAAT menjana {babak} gambar, kemudian video daripada setiap gambar.',
    'prostudio.wizard.sumSets': 'Set dan babak',
    'prostudio.wizard.sumSetsValue': '{set} set · {babak} babak',
    'prostudio.wizard.sumTestProduct': 'Produk ujian',
    'prostudio.wizard.sumTitle': 'Ringkasan agent',
    'prostudio.wizard.tagImage': 'Enjin · gambar',
    'prostudio.wizard.tagVideo': 'Enjin · video',
    'prostudio.wizard.testHint': 'Satu produk sebenar dihantar kepada agent anda sekali sahaja, supaya SESAAT belajar membaca bentuk jawapannya. Selepas ini anda boleh terus jalankan berkelompok.',
    'prostudio.wizard.testProduct': 'Produk untuk ujian',

    /* ── purchases ───────────────────────────────────────────── */
    'purchases.accessFailed': 'Gagal mendapatkan akses: {ralat}',
    'purchases.accessInfo': 'Info Akses',
    'purchases.accountAccess': 'Akses Akaun',
    'purchases.activeUntil': 'Aktif sehingga {tarikh}.',
    'purchases.copied': 'Info akses disalin.',
    'purchases.copy': 'Salin',
    'purchases.copyFailed': 'Gagal salin — sila salin secara manual.',
    'purchases.downloadEbook': 'Muat Turun Ebook',
    'purchases.downloadFailed': 'Gagal memuat turun: {ralat}',
    'purchases.empty': 'Belum ada pembelian',
    'purchases.emptyDesc': 'Lawati Marketplace untuk mula membeli.',
    'purchases.expiredNote': 'Tempoh akses anda telah tamat. Sila beli semula untuk menyambung — anda akan menerima akaun yang sama.',
    'purchases.expiredOn': 'Tempoh akses tamat pada {tarikh}.',
    'purchases.free': 'Percuma',
    'purchases.loadFailed': 'Gagal memuatkan pembelian: {ralat}',
    'purchases.marketplace': 'Marketplace',
    'purchases.noInfo': 'Tiada info dipaparkan. Hubungi admin jika perlu.',
    'purchases.opening': 'Membuka…',
    'purchases.payIncomplete': 'Pembayaran belum selesai. Anda boleh menyambungnya semula.',
    'purchases.payNow': 'Bayar Sekarang',
    'purchases.payVerifying': 'Pembayaran anda sedang disahkan — biasanya beberapa saat sahaja.',
    'purchases.preparing': 'Menyediakan…',
    'purchases.rejectReason': 'Sebab: {sebab}',
    'purchases.renew': 'Sambung Langganan',
    'purchases.requestedNote': 'Pesanan diterima. Admin akan sahkan bayaran dan serahkan akses tidak lama lagi.',
    'purchases.status.awaitingPayment': 'Menunggu pembayaran',
    'purchases.copyAll': 'Salin semua',
    'purchases.status.partial': 'Sebahagian diserah',
    'purchases.shortfallNote': '{n} unit belum diserahkan kerana stok kehabisan. Admin sedang menguruskannya — anda akan dimaklumkan sebaik ia sedia.',
    'purchases.linePending': '{n} lagi menunggu stok',
    'purchases.status.delivered': 'Siap',
    'purchases.status.refunded': 'Dikembalikan',
    'purchases.status.rejected': 'Ditolak',
    'purchases.status.requested': 'Menunggu pengesahan',
    'purchases.subtitle': 'Akses semula barang yang anda beli — bila-bila masa.',
    'purchases.title': 'Pembelian Saya',
    'purchases.toMarketplace': 'Ke Marketplace',
    'purchases.viewAccess': 'Lihat Akses',

    /* ── sales ───────────────────────────────────────────────── */
    'sales.empty.body': 'Tukar penapis atau kosongkan carian.',
    'sales.empty.title': 'Tiada pesanan sepadan',
    'sales.exportCsv': 'Export CSV',
    'sales.filter.all': 'Semua',
    'sales.prototype': 'Prototaip · /sales-v3.9',
    'sales.searchPlaceholder': 'Search order atau email',
    'sales.stat.orders': 'Jumlah pesanan',
    'sales.stat.revenue': 'Hasil berbayar',
    'sales.stat.revenueHint': 'Pending & refund tidak dikira',
    'sales.stat.unsettledHint': 'Penghantaran belum lengkap',
    'sales.status.paid': 'Berbayar',
    'sales.status.pending': 'Pending',
    'sales.status.refund': 'Refund',
    'sales.subtitle': 'Setiap pesanan dan apa yang masih perlu dihantar kepada pelanggan.',
    'sales.th.addon': 'Add-on',
    'sales.th.amount': 'Jumlah',
    'sales.th.bindMcn': 'Bind MCN',
    'sales.th.customer': 'Pelanggan',
    'sales.th.date': 'Tarikh',
    'sales.th.flowUltra': 'Flow Ultra',
    'sales.th.order': 'Order',
    'sales.th.package': 'Pakej',
    'sales.title': 'Sales',
    'sales.unsettled': 'Belum settle',

    /* ── sidebar ─────────────────────────────────────────────── */
    'sidebar.affiliates': 'Affiliates',
    'sidebar.almostFull': 'Hampir penuh!',
    'sidebar.cleaning': 'Cleaning',
    'sidebar.cleaningTip': 'Sedang membersih…',
    'sidebar.closeMenu': 'Tutup menu',
    'sidebar.dashboard': 'Dashboard',
    'sidebar.extCardTip': 'Extension — install v{versi}',
    'sidebar.extension': 'Extension',
    'sidebar.extInstall': 'Install · v{versi}',
    'sidebar.notes': 'Notes',
    'sidebar.openMenu': 'Buka menu',
    'sidebar.optimize': 'Optimize',
    'sidebar.optimizeStorage': 'Optimize storage',
    'sidebar.optimizeTip': 'Optimize — buang fail tidak terpakai',
    'sidebar.payouts': 'Payouts',
    'sidebar.pricing': 'Pricing',
    'sidebar.products': 'Products',
    'sidebar.proStudio': 'PRO Studio',
    'sidebar.referrals': 'Referrals',
    'sidebar.resources': 'Resources',
    'sidebar.settings': 'Settings',
    'sidebar.storageFull': 'Storage penuh — sila optimize',
    'sidebar.storageTip': 'Storage: {guna} / {had}',
    'sidebar.storageTipOptimize': 'Storage: {guna} / {had} — klik untuk Optimize',
    'sidebar.subscribeNow': 'Langgan Sekarang',
    'sidebar.workspace': 'Workspace',

    /* ── tutorial ────────────────────────────────────────────── */
    'tutorial.a11y.deleteChapter': 'Padam chapter {nama}',
    'tutorial.a11y.deleteVideo': 'Padam video',
    'tutorial.a11y.markUnwatched': 'Tanda belum ditonton',
    'tutorial.a11y.markWatched': 'Tanda sudah ditonton',
    'tutorial.a11y.moveDown': 'Alih ke bawah',
    'tutorial.a11y.moveUp': 'Alih ke atas',
    'tutorial.a11y.playLesson': 'Main lesson: {tajuk}',
    'tutorial.a11y.removeStep': 'Buang langkah',
    'tutorial.a11y.videoUnavailable': 'Video belum tersedia',
    'tutorial.all.desc': 'Pilih chapter atau cari terus tajuk yang anda perlukan.',
    'tutorial.all.title': 'Semua Lesson',
    'tutorial.art.readTime': 'Bacaan {n} minit',
    'tutorial.art.toc': 'Dalam artikel ini',
    'tutorial.badge.current': 'Semasa',
    'tutorial.badge.new': 'Baharu',
    'tutorial.btn.cancel': 'Batal',
    'tutorial.btn.continue': 'Sambung',
    'tutorial.btn.continueWatching': 'Sambung menonton',
    'tutorial.btn.editPage': 'Edit halaman',
    'tutorial.btn.newVideo': 'Video baharu',
    'tutorial.btn.rewatch': 'Tonton semula',
    'tutorial.btn.save': 'Simpan',
    'tutorial.btn.saving': 'Menyimpan…',
    'tutorial.btn.seeLess': 'Tutup semula',
    'tutorial.btn.seeMore': 'Lihat penuh',
    'tutorial.btn.start': 'Mula',
    'tutorial.btn.startWatching': 'Mula menonton',
    'tutorial.btn.watch': 'Tonton',
    'tutorial.chapters.countMany': '{jumlah} lesson · {siap} selesai',
    'tutorial.chapters.countOne': '{jumlah} lesson · {siap} selesai',
    'tutorial.chapters.desc': 'Masuk mana-mana chapter dan lesson akan berjalan satu demi satu sehingga habis — anda tidak perlu cari video seterusnya sendiri.',
    'tutorial.chapters.eyebrow': 'CHAPTER {nombor}',
    'tutorial.chapters.title': 'Chapter',
    'tutorial.confirm.deleteVideo': 'Padam video ini?',
    'tutorial.confirm.leaveEdit': 'Perubahan belum disimpan. Tinggalkan halaman ini?',
    'tutorial.edit.addChapter': 'Chapter',
    'tutorial.edit.addStep': 'Tambah langkah…',
    'tutorial.edit.badge': 'Mod edit',
    'tutorial.edit.chapterName': 'Nama chapter',
    'tutorial.edit.ctaLabelPlaceholder': 'Label butang (pilihan)',
    'tutorial.edit.hint': 'Perubahan hanya disimpan bila anda tekan Simpan.',
    'tutorial.edit.lessonTitle': 'Tajuk lesson',
    'tutorial.edit.newBadgeTip': 'Tunjuk lencana NEW pada kad ini',
    'tutorial.edit.newToggle': 'NEW',
    'tutorial.edit.shortDesc': 'Penerangan ringkas',
    'tutorial.edit.startHereOrder': 'Mula Sini — susunan langkah',
    'tutorial.edit.subtitleLabel': 'Ayat pengenalan halaman',
    'tutorial.edit.subtitlePlaceholder': 'Satu baris yang memberitahu pelanggan halaman ini untuk apa',
    'tutorial.edit.ytInvalid': 'Link YouTube tidak dikenali — semak semula link tersebut.',
    'tutorial.edit.ytMissing': 'Tiada link YouTube — video ini tidak dipaparkan kepada pelanggan.',
    'tutorial.edit.ytPlaceholder': 'Tampal link YouTube di sini',
    'tutorial.empty.chapterBody': 'Pilih chapter lain, atau kembali semula nanti.',
    'tutorial.empty.chapterTitle': 'Belum ada lesson dalam chapter ini',
    'tutorial.empty.searchBody': 'Kosongkan carian untuk melihat semua lesson.',
    'tutorial.empty.searchTitle': 'Tiada lesson sepadan dengan carian anda',
    'tutorial.err.saveFailed': 'Simpan gagal: {ralat}',
    'tutorial.err.unknown': 'ralat tidak diketahui',
    'tutorial.filter.all': 'Semua',
    'tutorial.foot.helpDesc': 'Tanya terus dalam group support WhatsApp.',
    'tutorial.foot.helpTitle': 'Masih tersangkut?',
    'tutorial.foot.playlistDesc': 'Semua video tutorial dalam satu playlist.',
    'tutorial.foot.playlistTitle': 'Playlist penuh di YouTube',
    'tutorial.loading.body': 'Sekejap sahaja. Muat semula kalau ia berkekalan.',
    'tutorial.loading.title': 'Memuatkan tutorial…',
    'tutorial.page.title': 'Tutorial',
    'tutorial.rail.chapterCap': 'Chapter {nombor} · {nama}',
    'tutorial.rail.overview': 'Ringkasan',
    'tutorial.rail.progress': 'Kemajuan',
    'tutorial.search.placeholder': 'Cari lesson',
    'tutorial.startHere.desc': 'Lima langkah dari install extension sehingga video naik TikTok. Ikut turutan ini dahulu — selebihnya boleh dipelajari kemudian.',
    'tutorial.startHere.title': 'Mula Sini',
    'tutorial.state.comingSoon': 'Akan datang',
    'tutorial.state.notWatched': 'Belum ditonton',
    'tutorial.state.watched': 'Sudah ditonton',
    'tutorial.thumb.noVideo': 'Belum ada video',
    'tutorial.untitledCategory': 'Tanpa nama',
    'tutorial.untitledLesson': 'Tanpa tajuk',

    /* ── workspace ───────────────────────────────────────────── */
    'workspace.bulk.avatar': 'Tukar Avatar',
    'workspace.bulk.clear': 'Batal pilihan',
    'workspace.bulk.delete': 'Delete',
    'workspace.bulk.delVideo': 'Del Video',
    'workspace.bulk.duplicate': 'Duplicate',
    'workspace.bulk.markFlow': 'Mark Flow',
    'workspace.bulk.markSchedule': 'Mark Schedule',
    'workspace.bulk.moveGroup': 'Move Group',
    'workspace.bulk.retry': 'Retry',
    'workspace.bulk.saveCloud': 'Save Cloud',
    'workspace.bulk.selectAll': 'Pilih semua',
    'workspace.bulk.selected': '{n} dipilih',
    'workspace.clear': 'Kosongkan',
    'workspace.clickToEdit': 'Klik untuk edit',
    'workspace.close': 'Tutup',
    'workspace.closeEsc': 'Tutup (Esc)',
    'workspace.closeQuickNotes': 'Tutup Quick Notes',
    'workspace.collapseAll': 'Tutup semua kad',
    'workspace.composer.addProduct': 'Tambah Product',
    'workspace.composer.addProductTip': 'Lampirkan product daripada library anda',
    'workspace.composer.avatar': 'Avatar',
    'workspace.composer.avatarDefaultFemale': 'Default P',
    'workspace.composer.avatarDefaultMale': 'Default L',
    'workspace.composer.avatarNone': 'Tiada avatar',
    'workspace.composer.bulkImport': 'Bulk Import',
    'workspace.composer.bulkImportTip': 'Bulk import product dari Google Sheet / Excel',
    'workspace.composer.createOwn': 'Cipta sendiri',
    'workspace.composer.createOwnSub': 'Milik anda sahaja',
    'workspace.composer.createOwnTip': 'Ada angle yang memang laku? Bina sekali sahaja — tetapkan scene, kunci style, kemudian jalankan pada setiap product yang anda tambah. Milik anda sahaja. Tiada orang lain nampak.',
    'workspace.composer.editAvatar': 'Sunting avatar',
    'workspace.composer.formulaLabel': 'Formula',
    'workspace.composer.formulaLocked': 'Belum dibuka',
    'workspace.composer.formulaLockedMaintenance': 'Module ini ditutup sementara',
    'workspace.composer.formulaLockedPlan': 'Module ini belum dibuka untuk akaun anda',
    'workspace.composer.formulaNote': '— setiap formula menghasilkan video style yang berbeza.',
    'workspace.composer.newModule': 'New module',   // admin sahaja — UI admin = English (kedua-dua bahasa)
    'workspace.composer.generate': 'Generate',
    'workspace.composer.generateTip': 'Baki quota hari ini. Setiap product memakan satu quota; reset 12:00 tengah malam.',
    'workspace.composer.generateTipNeedProduct': 'Lampirkan product dahulu',
    'workspace.composer.genUpgrade': 'Upgrade',
    'workspace.composer.genPickFormula': 'Pilih formula dulu',
    'workspace.composer.genPickTemplate': 'Pilih template dulu',
    'workspace.composer.genTipTrialEnded': 'Coin percubaan sudah habis — upgrade ke lesen berbayar',
    'workspace.composer.genTipPickFormula': 'Pilih satu formula dahulu — setiap formula menghasilkan video style yang berbeza',
    'workspace.composer.genTipPickTemplate': 'Pilih template GOYANG dahulu sebelum generate',
    'workspace.composer.avatarDefaultM': 'Default (L)',
    'workspace.composer.avatarDefaultF': 'Default (P)',
    'workspace.composer.avatarGoyangNote': 'GOYANG guna tangan sahaja — tiada avatar',
    'workspace.composer.moduleSettingsTip': 'Tetapan module (admin) — nama, master prompt',
    'workspace.composer.newAvatar': 'Avatar baharu',
    'workspace.composer.noProductAttached': 'Belum ada product dilampirkan.',
    'workspace.composer.nota.ai16saat': '2 scene · 16s',
    'workspace.composer.nota.ai8saat': '1 scene · 3 set',
    'workspace.composer.nota.flownity': '5 scene, bersambung',
    'workspace.composer.nota.goyang': 'Template motion',
    'workspace.composer.nota.homeniche': '2 scene · home niche',
    'workspace.composer.nota.smart': 'Prompt anda sendiri',
    'workspace.composer.picker.add': 'Tambah ({n})',
    'workspace.composer.picker.added': 'Ditambah',
    'workspace.composer.picker.alreadyAttached': '{n} sudah dilampirkan',
    'workspace.composer.picker.cancel': 'Batal',
    'workspace.composer.picker.cartEmptyLine1': 'Tandakan product di sebelah kiri.',
    'workspace.composer.picker.cartEmptyLine2': 'Bilangan kad ditetapkan di sini.',
    'workspace.composer.picker.cartTitle': 'Dipilih ({n})',
    'workspace.composer.picker.clear': 'Kosongkan',
    'workspace.composer.picker.clearTip': 'Kosongkan semua',
    'workspace.composer.picker.close': 'Tutup',
    'workspace.composer.picker.closeTip': 'Tutup (Esc)',
    'workspace.composer.picker.decrease': 'Kurangkan',
    'workspace.composer.picker.empty': 'Tiada product sepadan. Kosongkan carian atau tukar group.',
    'workspace.composer.picker.gridView': 'Paparan grid',
    'workspace.composer.picker.groupAll': 'Semua group',
    'workspace.composer.picker.groupAria': 'Group',
    'workspace.composer.picker.increase': 'Tambah',
    'workspace.composer.picker.listView': 'Paparan senarai',
    'workspace.composer.picker.noneSelected': 'Tiada product dipilih',
    'workspace.composer.picker.nSelected': '{n} dipilih',
    'workspace.composer.picker.pending': 'Pending',
    'workspace.composer.picker.pendingLocked': '{n} pending dikunci',
    'workspace.composer.picker.pendingLockedTip': '{n} product tidak boleh dipilih — data product belum lengkap. Lengkapkannya menggunakan butang Import Products di halaman Products, kemudian cuba semula.',
    'workspace.composer.picker.ready': 'Ready',
    'workspace.composer.picker.reasonIncomplete': 'Data product belum lengkap.',
    'workspace.composer.picker.reasonNoData': 'Belum ada data product — scrape menggunakan butang Import Products.',
    'workspace.composer.picker.remove': 'Buang',
    'workspace.composer.picker.removeAria': 'Buang daripada pilihan',
    'workspace.composer.picker.searchPlaceholder': 'Cari',
    'workspace.composer.picker.selectAll': 'Pilih semua ({n})',
    'workspace.composer.picker.sort.name': 'Nama',
    'workspace.composer.picker.sort.productId': 'Product ID',
    'workspace.composer.picker.sort.status': 'Status',
    'workspace.composer.picker.sort.statusAsc': 'Pending dahulu',
    'workspace.composer.picker.sort.statusDesc': 'Ready dahulu',
    'workspace.composer.picker.sort.time': 'Masa',
    'workspace.composer.picker.sort.timeAsc': 'Lama dahulu',
    'workspace.composer.picker.sort.timeDesc': 'Terbaru dahulu',
    'workspace.composer.picker.tabMyProducts': 'My Products {n}',
    'workspace.composer.picker.tabSystem': 'System {n}',
    'workspace.composer.picker.title': 'Produk',
    'workspace.composer.picker.totalCard': 'JUMLAH KAD',
    'workspace.composer.proMode': 'Pro Mode',
    'workspace.composer.proModeOffTip': 'Pro Mode mati — AI memilih hook dan style terbaik',
    'workspace.composer.proModeOnTip': 'Pro Mode HIDUP — anda menetapkan hook dan style sendiri',
    'workspace.composer.proModeNoBlocks': 'GOYANG · belum ada blocks — buka PRO Studio',
    'workspace.composer.genPickBlocks': 'Pilih blocks dulu',
    'workspace.composer.genTipPickBlocks': 'Pro Mode hidup tetapi GOYANG belum ada blocks tersimpan — simpan di PRO Studio → Blocks, atau matikan Pro Mode',
    'workspace.composer.removeProduct': 'Buang {nama}',
    'workspace.composer.samplePreview': 'Pratonton contoh',
    'workspace.composer.showLess': 'Tunjuk kurang',
    'workspace.composer.showMore': '+{n} lagi',
    'workspace.composer.style.auto': 'Auto',
    'workspace.composer.style.autoNote': 'AI memilih hook dan style terbaik mengikut product anda.',
    'workspace.composer.style.pro': 'Pro Mode',
    'workspace.composer.style.proNote': 'Anda menetapkan hook dan style sendiri untuk setiap set.',
    'workspace.copyField': 'Salin {medan}',
    'workspace.copyLine': 'Salin baris',
    'workspace.copySetField': 'Salin {medan} {n}',
    'workspace.empty.groupDesc': 'Tambah produk melalui tab Generate, atau pindahkan produk sedia ada ke sini.',
    'workspace.empty.groupTitle': 'Group ini masih kosong',
    'workspace.empty.tabDesc': 'Tandakan produk pada tab lain, atau tambah produk baharu.',
    'workspace.empty.tabTitle': 'Tiada produk di sini',
    'workspace.expandAll': 'Buka semua kad',
    'workspace.group.baharu': 'New group',
    'workspace.group.batal': 'Cancel',
    'workspace.group.cariPlaceholder': 'Search group',
    'workspace.group.namaBaharuPlaceholder': 'New group name',
    'workspace.group.namaPlaceholder': 'Group name',
    'workspace.group.padamAmaran': 'This group contains {n} products. The products are not deleted — they move to the group you pick below.',
    'workspace.group.padamAria': 'Delete group {nama}',
    'workspace.group.padamButang': 'Delete group',
    'workspace.group.padamKosong': 'This group is empty. No products affected.',
    'workspace.group.padamTajuk': 'Padam group',
    'workspace.group.padamTitle': 'Delete group',
    'workspace.group.pindahKe': 'Move products to',
    'workspace.group.ralatKosong': 'Group name cannot be empty.',
    'workspace.group.ralatNamaBertindih': 'That name is already used by another group.',
    'workspace.group.ralatNamaTerpelihara': '"Main Group" is the default group name.',
    'workspace.group.renameAria': 'Namakan semula group {nama}',
    'workspace.group.renameTitle': 'Rename',
    'workspace.group.ringkasanPindah': '{n} products → {group}',
    'workspace.group.simpan': 'Simpan',
    'workspace.group.tiadaPadanan': 'Tiada group bernama itu.',
    'workspace.group.tukarTitle': 'Switch group',
    'workspace.group.tutupAria': 'Close',
    'workspace.group.tutupTitle': 'Close (Esc)',
    'workspace.group.utama': 'Main Group',
    'workspace.link.flowTip': 'Buka collection video di Google Flow',
    'workspace.link.tiktokTip': 'Buka halaman produk di TikTok Shop',
    'workspace.modal.aria': 'Butiran {nama}',
    'workspace.modal.hint': 'Klik petak untuk edit · Esc tutup',
    'workspace.modal.unsaved': 'Ada perubahan belum disimpan',
    'workspace.page.adminBadge': 'Admin',
    'workspace.page.chip.extension': 'Extension',
    'workspace.page.chip.fullPrompt': 'Full prompt',
    'workspace.page.controlPanel': 'Control Panel',
    'workspace.page.field.caption': 'Caption',
    'workspace.page.field.dialog': 'Dialog',
    'workspace.page.field.hook': 'Hook',
    'workspace.page.field.image': 'Image',
    'workspace.page.field.script': 'Script',
    'workspace.page.field.video': 'Video',
    'workspace.page.groupUtama': 'Main Group',
    'workspace.page.hide': 'Hide',
    'workspace.page.link.flow': 'Flow collection',
    'workspace.page.link.tiktok': 'Produk TikTok',
    'workspace.page.post.facebook': 'Facebook',
    'workspace.page.post.postOnly': 'Post Only',
    'workspace.page.post.scheduledPost': 'Scheduled Post',
    'workspace.page.post.showcaseOnly': 'Showcase Only',
    'workspace.page.post.threads': 'Threads',
    'workspace.page.post.tiktok': 'TikTok',
    'workspace.page.quickNotes': 'Quick Notes',
    'workspace.page.run.collection': 'Collection',
    'workspace.page.run.continueCollection': 'Continue Collection',
    'workspace.page.run.imageLabel': 'Image',
    'workspace.page.run.imageModelAria': 'Model image',
    'workspace.page.run.inProject': 'In project',
    'workspace.page.run.multiBrowser': 'Multi browser',
    'workspace.page.run.noSelection': 'Tiada produk dipilih',
    'workspace.page.run.runFlow': 'Run Flow',
    'workspace.run.maintenanceBar': 'Run Flow sedang dalam penyelenggaraan',
    'workspace.page.run.runTiktok': 'Run TikTok',
    'workspace.page.run.runFacebook': 'Run Facebook',
    'workspace.page.run.runPost': 'Run Post',
    'workspace.page.run.selectedCount': '{n} dipilih',
    'workspace.page.run.videoLabel': 'Video',
    'workspace.page.run.videoModelAria': 'Model video',
    'workspace.page.run.durationLabel': 'Tempoh video',
    'workspace.page.run.durationAria': 'Tempoh video',
    'workspace.page.run.ingredientsLabel': 'Ingredients',
    'workspace.page.schedule.createFirst': 'Cipta jadual pertama',
    'workspace.page.schedule.manage': 'Urus jadual',
    'workspace.page.schedule.use': 'Guna jadual',
    'workspace.page.scheduleTemplate': 'Template jadual',
    'workspace.page.sect.advanced': 'Advanced',
    'workspace.page.sect.destination': 'Destination',
    'workspace.page.sect.model': 'Model',
    'workspace.page.sect.postMode': 'Post Mode',
    'workspace.page.sect.postTo': 'Post To',
    'workspace.page.sect.schedule': 'Schedule',
    'workspace.page.sect.scene': 'Scene',
    'workspace.page.sect.set': 'Set',
    'workspace.page.setN': 'Set {n}',
    'workspace.page.setPill': 'S{n}',
    'workspace.page.showControlPanel': 'Papar Control Panel',
    'workspace.page.sort.module': 'Module',
    'workspace.page.sort.moduleAsc': 'A → Z',
    'workspace.page.sort.moduleDesc': 'Z → A',
    'workspace.page.sort.number': 'Nombor',
    'workspace.page.sort.numberAsc': '1 → 10',
    'workspace.page.sort.numberDesc': '10 → 1',
    'workspace.page.sort.time': 'Masa',
    'workspace.page.sort.timeAsc': 'Lama dahulu',
    'workspace.page.sort.timeDesc': 'Terbaru dahulu',
    'workspace.page.tab.agentAi': 'My Agent',
    'workspace.page.tab.flow': 'Flow',
    'workspace.page.tab.generate': 'Generate',
    'workspace.page.tab.schedule': 'Schedule',
    'workspace.page.title': 'Workspace',
    'workspace.panel.hideTip': 'Sembunyikan Control Panel',
    'workspace.post.lockedNote': 'Threads dan Facebook untuk product Shopee — belum dibuka.',
    'workspace.post.postOnlyNote': 'Langkau langkah masukkan produk ke Showcase. Beg kuning tetap dipasang kalau produk sudah ada dalam Showcase anda.',
    'workspace.post.scheduledNote': 'Setiap video mendapat tarikh dan jamnya sendiri. TikTok yang menyiarkannya kemudian — browser tidak perlu dibuka pada waktu itu.',
    'workspace.post.scheduledNoteOff': 'Setiap video mendapat tarikh dan jamnya sendiri. Hidupkan Direct Schedule di bawah jika anda mahu TikTok menyiarkannya sendiri.',
    'workspace.post.showcaseNote': 'Masukkan produk ke Showcase tanpa memuat naik video.',
    'workspace.post.tiktokNote': 'Untuk product TikTok Shop.',
    'workspace.post.fbNote': 'Untuk produk Shopee.',
    'workspace.post.pilihSatu': 'Pilih satu tempat sahaja. Threads belum dibuka.',
    'workspace.post.fbPageActive': 'Robot post ke page Facebook yang sedang AKTIF dalam browser ini. Satu browser = satu page — tukar page di Facebook dahulu kalau perlu.',
    'workspace.fblaluan.title': 'Laluan post',
    'workspace.fblaluan.hint': 'Pilih laluan yang beg Shopee muncul di phone.',
    'workspace.post.fbRunHint': 'Tick kad produk → Run Facebook (mana-mana tab), atau di tab Schedule tick slot kalendar → Run Facebook. Cara post di bawah menentukan: Post sekarang · Jadual (kalendar sahaja) · Simpan draf.',
    'workspace.page.sect.aiLabel': 'AI Label',
    'workspace.post.aiLabel': 'Add AI label',
    'workspace.post.aiLabelOn': 'Robot tandakan setiap video sebagai kandungan AI (TikTok: AI-generated content · Facebook: Add AI label).',
    'workspace.post.aiLabelOff': 'Robot tidak menandakan video sebagai kandungan AI. Platform boleh mengambil tindakan pada kandungan AI yang tidak dilabel.',
    'workspace.page.sect.ttChecks': 'TikTok Checks',
    'workspace.ttChecks.muzikOn': 'Robot menghidupkan Music copyright check di TikTok untuk setiap video.',
    'workspace.ttChecks.muzikOff': 'Robot mematikan Music copyright check di TikTok. Lagu dalam video tidak disemak.',
    'workspace.ttChecks.kandunganOn': 'Robot menunggu TikTok selesai Checking sebelum Post / Schedule. Jika tidak selesai, video disimpan sebagai draf.',
    'workspace.ttChecks.kandunganOff': 'Robot mematikan Content check lite dan terus Post / Schedule. Amaran kandungan TikTok tidak akan dikesan.',
    'workspace.ttChecks.gagalSimpan': 'Pilihan ini tidak dapat disimpan dalam browser ini.',
    'workspace.page.sect.ttJenisPost': 'Post Type',
    'workspace.ttJenisPost.gambarOn': 'Robot memuat naik gambar card (gambar utama + gambar tambahan) sebagai satu post gambar TikTok bagi setiap card. Video tidak dipost.',
    'workspace.ttJenisPost.gambarOff': 'Robot memuat naik video setiap set yang dipilih.',
    'workspace.post.fbSetLabel': 'Set untuk jadi reel',
    'workspace.post.fbSetHint': 'Setiap set = satu reel. Pilih set mana hendak dipost (contoh S1 sahaja).',
    'workspace.bag.title': 'Beg kuning',
    'workspace.bag.toggle': 'Pasang beg kuning',
    'workspace.bag.noteOn': 'Robot pautkan produk kad pada setiap video (beg kuning TikTok Shop).',
    'workspace.bag.noteOff': 'Video dipost tanpa beg kuning — tiada langkah Showcase, tiada pautan produk.',
    'workspace.fbproduk.title': 'Link produk',
    'workspace.fbproduk.toggle': 'Add product',
    'workspace.fbproduk.noteOn': 'Robot letak link Shopee kad pada setiap reel (Facebook: Add product). Reel dapat label "Commission eligible".',
    'workspace.fbproduk.noteOff': 'Reel dipost tanpa link produk — tiada label "Commission eligible". Link Shopee pada kad kekal, cuma tidak digunakan.',
    'ws.fb.perluKemasKini': 'Simpan draf dan pilihan AI label untuk Facebook memerlukan extension SESAAT versi terbaharu. Sila muat turun dan pasang semula extension dari dashboard, kemudian cuba lagi.',
    'ws.fb.direct.on': 'Kad yang ditanda (tick) terus diterbitkan di Facebook sebaik robot siap memuat naik.',
    'ws.fb.direct.off': 'Robot simpan setiap reel sebagai DRAF di Content Library Facebook — anda boleh semak dan terbitkan sendiri.',
    'ws.fb.noVideo': 'Tiada video sedia untuk produk yang dipilih. Jalankan Run Flow dahulu untuk menghasilkan video.',
    'ws.fb.noShopeeWarn': '{n} produk tiada link Shopee — reel akan diterbit TANPA link affiliate.\n\nMemang tak mahu link produk? Matikan "Add product" di Control Panel.\n\nTeruskan?',
    'ws.fb.started': '🎬 Facebook Reels dimulakan!',
    'ws.fb.startedDetail': 'Robot membuka Content Library Facebook dan memuat naik reel. Jangan tutup tab itu.',
    'ws.fb.startedDetailDraft': 'Robot membuka Content Library Facebook dan menyimpan reel sebagai draf. Jangan tutup tab itu.',
    'ws.fb.hasilPost': '{n} reel diterbit',
    'ws.fb.hasilJadual': '{n} reel dijadualkan',
    'ws.fb.hasilDraf': '{n} draf disimpan',
    'ws.fb.hasilGagal': '{n} gagal',
    'ws.fb.hasilKosong': 'Tiada reel diproses.',
    'ws.fb.hasilPage': 'Page: {nama}',
    'ws.run.extDisconnectedFb': 'Tab ini perlu di-refresh dulu sebelum boleh start Facebook.',
    'ws.fb.doneMsg': '✅ Facebook Reels selesai!',
    'ws.fb.doneAll': '{n} reel diterbit.',
    'ws.fb.doneSome': '{n} reel diterbit, {gagal} gagal.',
    'ws.fb.failMsg': '❌ Facebook Reels gagal',
    'ws.fb.failGeneric': 'Sila cuba lagi.',
    'workspace.preview.count': '{produk} produk · {video} video',
    'workspace.preview.countWithSkip': '{produk} produk · {video} video · {langkau} dilangkau (tiada video)',
    'workspace.preview.noTimes': 'Jadual ini belum mempunyai waktu post. Tetapkan di dalam Urus jadual.',
    'workspace.preview.noVideo': 'Produk yang ditandakan tiada video untuk set yang dipilih jadual ini.',
    'workspace.preview.overLimit': 'Melepasi {hari} hari — TikTok tidak menerima jadual sejauh itu.',
    'workspace.preview.pickProducts': 'Tandakan produk untuk melihat waktu sebenar.',
    'workspace.prototypeNote': 'Prototaip · /workspace-v3.9',
    'workspace.qnFoot': 'Nota bertanda kilat di halaman Notes muncul di sini.',
    'workspace.run.collectionBlocked': 'Kosongkan "In project" dahulu.',
    'workspace.run.collectionEmpty': 'Isi satu sahaja: In project ATAU Collection.',
    'workspace.run.collectionPlaceholder': 'Tampal link collection…',
    'workspace.run.collectionUsed': 'Guna collection ini — langkah "New Project" dilangkau.',
    'workspace.run.continueCollectionNote': 'Isi gambar atau video yang hilang pada collection tersimpan, dan langkau set yang sudah siap. Pilih satu produk sahaja.',
    'workspace.run.multiBrowserOff': 'Simpanan setempat sahaja — untuk ujian.',
    'workspace.run.multiBrowserOn': 'Video disimpan ke Cloud supaya browser lain boleh memuat naiknya ke TikTok.',
    'workspace.run.needChannel': 'Hidupkan sekurang-kurangnya satu channel',
    'workspace.run.needProduct': 'Pilih product dalam list dahulu',
    'workspace.run.projectBlocked': 'Kosongkan "Collection" dahulu.',
    'workspace.run.projectEmpty': 'Biarkan kosong untuk mencipta project baharu setiap kali.',
    'workspace.run.projectPlaceholder': 'Tampal link project…',
    'workspace.run.projectUsed': 'Guna project ini — langkah "New Project" dilangkau.',
    'workspace.run.proOnly': 'Tersedia pada pakej Pro Studio.',
    'workspace.run.setNote': 'Satu set menghasilkan satu video. Tandakan set yang hendak dijalankan sahaja.',
    'workspace.run.sceneNote': 'Satu scene menghasilkan satu bahagian video. Tandakan scene yang hendak dijalankan sahaja.',
    'workspace.run.videoNote': 'Kos credit mengikut pakej Google anda. Flow memaparkan jumlah sebenar sebelum generate.',
    'workspace.run.durationNote': '10 saat hanya tersedia untuk model Omni Flash.',
    'workspace.page.run.resolutionLabel': 'Resolusi video',
    'workspace.page.run.resolutionAria': 'Resolusi video',
    'workspace.run.resolutionNote': 'Hanya model Omni ada pilihan kualiti video. Flow memaparkan kos credit sebenar sebelum generate.',
    'workspace.page.run.dlSizeLabel': 'Saiz fail video',
    'workspace.page.run.dlSizeAria': 'Saiz fail video',
    'workspace.run.dlSizeNote': 'Ikut menu Download dalam Flow. Pilihan berubah ikut resolusi video anda — 360p memberi 360p/720p; 720p (dan semua model Veo) memberi 720p/1080p. Upscaled tambah kira-kira 30 saat setiap video. 270p GIF dan 4K (50 kredit) sengaja tidak ditawarkan. Untuk kad 2 babak, Flow memuat turun video gabungan — pilihan ini tidak terpakai.',
    'workspace.run.dlSizeLocked': 'Modul ini menggabungkan babak menjadi satu video dan memuat turunnya terus dari Flow — Flow tidak menawarkan pilihan saiz untuk video gabungan.',
    'workspace.run.ingredientsNote': 'Hidup: video merujuk gambar produk anda. Mati: mod Frames biasa.',
    'workspace.workflow.title': 'Workflow',
    'workspace.workflow.q1': 'Gambar dari mana?',
    'workspace.workflow.optGenerate': 'Generate di Flow',
    'workspace.workflow.optGenerateDesc': 'Flow generate gambar dahulu, kemudian Animate menjadi video.',
    'workspace.workflow.optCard': 'Guna gambar pada card',
    'workspace.workflow.optCardDesc': 'Tiada generate gambar. Gambar pada card terus menjadi video, contohnya storyboard.',
    // ★ [2026-11-03] Dropdown kaya Workflow — PROTOTAIP /workspace-v3.9 (WorkflowPilihV39.jsx)
    'workspace.wfPilih.aria': 'Pilih workflow',
    'workspace.wfPilih.kosong': 'Pilih workflow',
    'workspace.wfPilih.draft': 'Draft',
    'workspace.wfPilih.draftNote': 'Workflow Draft hanya kelihatan kepada admin. Pelanggan hanya melihat workflow yang telah diterbitkan.',
    'workspace.wfPilih.scenes': 'Scene',
    'workspace.wfPilih.result': 'Hasil',
    'workspace.wfPilih.result.gabung': 'Gabung',
    'workspace.wfPilih.result.asing': 'Setiap scene',
    'workspace.wfPilih.result.keduanya': 'Kedua-duanya',
    'workspace.wfPilih.versions': 'Versi setiap prompt',
    'workspace.wfPilih.versionsNote': 'Lebih banyak versi untuk dipilih. Menggunakan lebih banyak credit.',
    'workspace.wfPilih.images': 'Gambar setiap prompt',
    // ★ [2026-11-03] Dropdown Workflow Workspace v4 mod New (WorkflowDropdownV4.jsx)
    'workspace.wfV4.tickFirst': 'Tanda card dahulu',
    'workspace.wfV4.tickFirstNote': 'Workflow mengikut Formula card yang ditanda.',
    'workspace.wfV4.mixed': '{n} workflow',
    'workspace.wfV4.mixedNote': 'Jalankan satu workflow pada satu masa. Buang tanda card yang menggunakan Formula lain.',
    'workspace.wfV4.fromFormula': 'Workflow lain ditentukan oleh Formula card.',
    'workspace.wfV4.noneLinked': 'Tiada workflow disambung untuk {formula}',
    'workspace.wfV4.noneLinkedNote': 'Larian tetap mengikut Formula card. Sambungkan robot pada workflow di page Workflow untuk memaparkannya di sini.',
    'workspace.wfV4.blankNote': 'Blank card: workflow ini belum disambung kepada Run. Larian akan menggunakan AI image to video, 1 scene.',
    'workspace.wfV4.loadError': 'Senarai workflow gagal dimuat',
    'workspace.wfV4.empty': 'Senarai workflow kosong',
    'workspace.wfV4.emptyNote': 'Buka page Workflow dan muat senarai workflow permulaan.',
    'workspace.wfV4.rosak': '{n} workflow dalam page Workflow tidak sah dan dilangkau.',
    // ★ [2026-10-17] Scene output + card enjin Flow RESIPI (PLAN_FLOW_RESIPI.md)
    'workspace.productRef.title': 'Gambar produk',
    'workspace.productRef.optAll': 'Semua scene',
    'workspace.productRef.optAllDesc': 'Gambar produk menjadi rujukan bagi gambar setiap scene.',
    'workspace.productRef.optFirst': 'Scene pertama sahaja',
    'workspace.productRef.optFirstDesc': 'Produk ditunjukkan pada awal video. Scene lain dijana daripada prompt.',
    'workspace.productRef.optLast': 'Scene terakhir sahaja',
    'workspace.productRef.optLastDesc': 'Produk didedahkan pada akhir video. Scene lain dijana daripada prompt.',
    'workspace.productRef.optNone': 'Tiada',
    'workspace.productRef.optNoneDesc': 'Semua gambar dijana daripada prompt sahaja, tanpa gambar produk dan avatar.',
    'ws.resipi.imageScene': 'Image Prompt · Scene {n}',
    'ws.resipi.imageScenePlaceholder': 'Image Prompt Scene {n}...',
    'workspace.imageSave.title': 'Simpan gambar',
    'workspace.imageSave.optFolder': 'Folder Downloads sahaja',
    'workspace.imageSave.optFolderDesc': 'Gambar disimpan dalam folder Downloads anda. Card tidak memaparkan gambar ini.',
    'workspace.imageSave.optCard': 'Folder Downloads dan card',
    'workspace.imageSave.optCardDesc': 'Gambar disimpan dalam folder Downloads dan dipaparkan pada card.',
    'workspace.imageOutputs.title': 'Gambar setiap prompt',
    'workspace.imageOutputs.opt': '{n} gambar',
    'workspace.imageOutputs.optOneDesc': 'Satu gambar bagi setiap Image Prompt.',
    'workspace.imageOutputs.optManyDesc': 'Flow menjana {n} gambar berbeza daripada prompt yang sama.',
    'ws.resipi.imageEnd': 'Image Prompt · Selepas (End frame)',
    'workspace.sceneOutput.title': 'Hasil scene',
    'workspace.sceneOutput.optCombine': 'Gabung menjadi satu video',
    'workspace.sceneOutput.optCombineDesc': 'Semua {n} scene digabung menjadi satu video dan disimpan pada card.',
    'workspace.sceneOutput.optEach': 'Muat turun setiap scene',
    'workspace.sceneOutput.optEachDesc': 'Setiap {n} scene disimpan sebagai fail berasingan dalam folder Downloads anda. Card tidak memaparkan video ini.',
    'ws.resipi.allScenes': 'semua scene',
    'ws.resipi.allScenesLong': 'satu gambar AI dipakai dalam semua {n} scene',
    'ws.resipi.imagePlaceholder': 'Image Prompt — satu gambar AI untuk semua scene...',
    'ws.resipi.videoPlaceholder': 'Video Prompt Scene {n}...',
    'workspace.workflow.imageUnused': 'Tidak digunakan — workflow ini tiada generate gambar.',
    'workspace.workflow.ingredientsLocked': 'Sentiasa hidup — mod Frames hanya menerima frame mula dan akhir.',
    'workspace.workflow.runLabel': 'Run Flow · Gambar card',
    'workspace.workflow.veoImageLimit': 'Veo guna maksimum 3 gambar card (gambar utama, avatar, kemudian gambar 2). Omni Flash guna semua.',
    'workspace.workflow.durationLocked': 'Veo hanya menjana video 8 saat daripada gambar card.',
    'workspace.workflow.kadTakSokong': 'Card yang ditanda guna {module} — mod ini hanya untuk AI8SAAT dan SMART 1 babak. Larian akan guna “Generate di Flow”. Tanda card AI8SAAT untuk guna gambar card.',
    'workspace.schedule.addBtn': 'Tambah',
    'workspace.schedule.addTime': 'Tambah waktu',
    'workspace.schedule.cancel': 'Cancel',
    'workspace.schedule.cancelDraft': 'Batal',
    'workspace.schedule.clearBtn': 'Kosongkan',
    'workspace.schedule.closeAria': 'Close',
    'workspace.schedule.closeBtn': 'Tutup',
    'workspace.schedule.closeTitle': 'Close (Esc)',
    'workspace.schedule.dateAtRun': 'Tarikh dikira semasa Run',
    'workspace.schedule.delete': 'Delete',
    'workspace.schedule.deleteConfirm': 'Delete “{nama}”?',
    'workspace.schedule.deleteUnusedNote': 'Template ini tidak digunakan oleh mana-mana hari.',
    'workspace.schedule.deleteUsedNote': 'Digunakan oleh {n} hari — semua slot pada hari tersebut akan dikosongkan.',
    'workspace.schedule.deleteUsedNoteOne': 'Digunakan oleh 1 hari — semua slot pada hari itu akan dikosongkan.',
    'workspace.schedule.discardChanges': 'Buang perubahan',
    'workspace.schedule.done': 'Done',
    'workspace.schedule.dragHandle': 'Tarik untuk susun',
    'workspace.schedule.duplicate': 'Duplicate',
    'workspace.schedule.endTimeAria': 'Waktu berhenti',
    'workspace.schedule.fillBtn': 'Isi',
    'workspace.schedule.fillEvery': 'Setiap',
    'workspace.schedule.fillFrom': 'dari',
    'workspace.schedule.fillIntervalAria': 'Jarak antara waktu',
    'workspace.schedule.fillTo': 'hingga',
    'workspace.schedule.interleaveHintOff': 'Tersedia apabila lebih daripada satu set dipilih.',
    'workspace.schedule.interleaveHintOn': 'Hantar set 1 bagi semua produk dahulu, kemudian set 2. Kalau dimatikan, satu produk dihabiskan dahulu sebelum produk berikutnya.',
    'workspace.schedule.listEmpty': 'Belum ada template.',
    'workspace.schedule.listHeading': 'Templates',
    'workspace.schedule.modalAria': 'Schedule template',
    'workspace.schedule.moveDown': 'Turun',
    'workspace.schedule.moveUp': 'Naik',
    'workspace.schedule.nameAria': 'Template name',
    'workspace.schedule.newTemplate': 'New template',
    'workspace.schedule.newTimeAria': 'Waktu baharu',
    'workspace.schedule.noneSelected': 'No template selected',
    'workspace.schedule.noneSelectedBody': 'Buat satu template untuk menetapkan waktu post anda.',
    'workspace.schedule.noTimesHint': 'Hari yang memakai template ini tiada slot langsung.',
    'workspace.schedule.noTimesSet': 'No times set',
    'workspace.schedule.removeTime': 'Buang {t}',
    'workspace.schedule.rowInterleave': 'Interleave sets',
    'workspace.schedule.rowName': 'Name',
    'workspace.schedule.rowSendTimes': 'Send times',
    'workspace.schedule.rowSets': 'Sets',
    'workspace.schedule.save': 'Save',
    'workspace.schedule.saved': 'Saved',
    'workspace.schedule.sendTimesHint': 'Waktu yang ditanda akan diguna SETIAP hari. Video yang melebihi bilangan ini disambung pada hari berikutnya. Setiap {minit} minit sahaja — had TikTok.',
    'workspace.schedule.setsHint': 'Buat satu template bagi setiap set kalau set berlainan pergi ke browser berlainan.',
    /* Versi BM: ayat asal dalam scheduleV39.js memang "{n} slot sehari". */
    'workspace.schedule.slotsPerDay': '{n} slot sehari',
    /* Ringkasan kad jadual (scheduleV39.js → ringkasJadual). */
    'workspace.schedule.allSets': 'Semua set',
    'workspace.schedule.noSets': 'Tiada set',
    'workspace.schedule.interleave': 'Selang seli',
    'workspace.schedule.byCard': 'Ikut kad',
    'workspace.schedule.noTimes': 'Tiada waktu',
    'workspace.schedule.startToday': 'Mula hari ini',
    'workspace.schedule.startTomorrow': 'Mula esok',
    'workspace.schedule.startTimeAria': 'Waktu mula',
    'workspace.schedule.subtitle': 'Peraturan masa sahaja — produk dipilih semasa Run, tarikh dipilih dalam kalendar.',
    'workspace.schedule.timeExists': '{jam} sudah ada dalam jadual ini.',
    'workspace.schedule.title': 'Schedule templates',
    'workspace.schedule.unsavedWarn': 'Perubahan pada template ini belum disimpan.',
    /* Melayu tiada bentuk jamak — dua kunci ini sengaja sama. Ia wujud
       kerana English memerlukannya; pemanggil memilih ikut bilangan. */
    'workspace.schedule.usedByDay': 'Dipakai oleh {n} hari',
    'workspace.schedule.usedByDays': 'Dipakai oleh {n} hari',
    /* Tiga ini dibaca oleh PEMBACA SKRIN sahaja (PilihWaktuV39) — tiada
       pada skrin, tetapi ia tetap antara muka. */
    'workspace.tiktok.timeLabel': 'Waktu',
    'workspace.tiktok.timeHour': '{label} — jam',
    'workspace.tiktok.timeMinute': '{label} — minit',
    'workspace.tiktok.accountNameAria': 'Nama akaun baharu',
    'workspace.tiktok.accountNamePlaceholder': 'Nama akaun…',
    'workspace.tiktok.accountSelectAria': 'Akaun TikTok',
    'workspace.tiktok.addAccount': 'Tambah akaun',
    'workspace.tiktok.searchAccount': 'Cari akaun',
    'workspace.tiktok.noAccountMatch': 'Tiada akaun dengan nama itu.',
    'workspace.tiktok.renameAccount': 'Namakan semula akaun',
    'workspace.tiktok.deleteAccount': 'Padam akaun',
    'workspace.tiktok.deleteAccountConfirm': 'Padam?',
    /* Kalendar mingguan (KalendarMingguV39). Terma yang memang kekal
       English pada skrin ini — Set, Template, Status, Caption, Retry,
       Run, Drop product — dibiarkan seperti asal dalam kedua-dua bahasa. */
    'workspace.tiktok.cal.addTime': 'Tambah waktu',
    'workspace.tiktok.cal.caption': 'Caption',
    'workspace.tiktok.cal.close': 'Tutup',
    'workspace.tiktok.cal.dayToday': 'Today',
    'workspace.tiktok.cal.dayTomorrow': 'Tomorrow',
    'workspace.tiktok.cal.dayYesterday': 'Yesterday',
    'workspace.tiktok.cal.detailAria': 'Butiran video',
    'workspace.tiktok.cal.dragMarked': 'Seret {n} slot bertanda sekali gus',
    'workspace.tiktok.cal.dropProduct': 'Drop product',
    'workspace.tiktok.cal.extraTimeDot': 'Waktu tambahan pada hari ini sahaja',
    'workspace.tiktok.cal.newTimeLabel': 'Waktu baharu untuk hari ini',
    'workspace.tiktok.cal.nextDays': '{n} hari seterusnya',
    'workspace.tiktok.cal.noTemplate': 'No template',
    'workspace.tiktok.cal.tickDay': 'Pilih {hari} {tarikh} untuk Run',
    'workspace.tiktok.cal.tickDayTip': 'Tick untuk jalankan slot pada hari ini',
    'workspace.tiktok.cal.pilihHariTip': 'Pilih semua slot hari ini',
    'workspace.tiktok.cal.pickTemplate': 'Pilih template untuk membuka slot.',
    'workspace.tiktok.cal.pickTemplateOrAdd': 'Pilih template untuk membuka slot — atau tambah waktu sendiri di bawah.',
    'workspace.tiktok.cal.prevDays': '{n} hari sebelum',
    'workspace.tiktok.cal.removeProduct': 'Keluarkan',
    'workspace.tiktok.cal.removeProductAria': 'Keluarkan produk dari slot ini',
    'workspace.tiktok.cal.removeTime': 'Buang waktu ini',
    'workspace.tiktok.cal.retry': 'Retry',
    'workspace.tiktok.cal.retryTitle': 'Cuba jadualkan semula set ini',
    'workspace.tiktok.gagalBar': '{n} slot gagal',
    'workspace.tiktok.retryAll': 'Retry all',
    'workspace.tiktok.gagalTutup': 'Sembunyikan notifikasi ini — status Failed kekal pada card dan slot. Ia muncul semula bila ada slot baru gagal.',
    'workspace.tiktok.sendBar': '{n} sedang dihantar…',
    'workspace.tiktok.stopRun': 'Stop',
    'ws.sched.stop.ok': 'Larian dihentikan. Slot yang tersangkut dibersihkan.',
    'ws.sched.stop.tiada': 'Tiada larian untuk dihentikan.',
    'ws.sched.vid.tiada': 'Tiada video untuk dipadam pada set ini.',
    'workspace.tiktok.cal.rowDate': 'Date',
    'workspace.tiktok.cal.rowStatus': 'Status',
    'workspace.tiktok.cal.rowTemplate': 'Template',
    'workspace.tiktok.cal.rowTime': 'Time',
    'workspace.tiktok.cal.saveTimeAria': 'Simpan waktu',
    'workspace.tiktok.cal.setNoVideoWait': 'Set {n}: video belum ada — slot akan menunggu',
    'workspace.tiktok.cal.setOnOtherAccount': 'Set {n}: sudah dijadualkan pada {akaun} — boleh diulang',
    'workspace.tiktok.cal.slotHint': 'Klik untuk menanda · seret ke waktu lain · jatuh atas slot berisi untuk bertukar tempat',
    'workspace.tiktok.cal.statusWaiting': 'Menunggu Run',
    'workspace.tiktok.cal.stDone': 'Dijadualkan',
    'workspace.tiktok.cal.stPosted': 'Diterbitkan',
    'workspace.tiktok.cal.stDraft': 'Draf',
    'workspace.tiktok.cal.stFail': 'Gagal',
    'workspace.tiktok.cal.stUncertain': 'Tidak pasti',
    'workspace.tiktok.cal.stRunning': 'Menghantar…',
    'workspace.tiktok.cal.stNone': 'Belum dijalankan',
    'workspace.tiktok.cal.editStatus': 'Tukar status slot',
    'workspace.tiktok.cal.delVideo': 'Padam video',
    'workspace.tiktok.cal.delVideoTip': 'Padam video untuk set ini sahaja — kad, prompt dan kapsyen kekal.',
    'workspace.tiktok.cal.templateForAria': 'Template untuk {hari} {tarikh}',
    'workspace.tiktok.cal.timeExists': 'Waktu itu sudah ada pada hari ini.',
    'workspace.tiktok.cal.timezone': 'Waktu ditunjukkan dalam Asia/Kuala_Lumpur',
    'workspace.tiktok.cal.today': 'Today',
    'workspace.tiktok.cal.useSet': 'Guna set {n}',
    'workspace.tiktok.cal.waitVideo': 'Tunggu video',
    'workspace.tiktok.cancel': 'Batal',
    'workspace.tiktok.deselect': 'Nyahpilih',
    'workspace.tiktok.statusSlotTitle': 'Tukar atau kosongkan status pada slot yang ditanda — video KEKAL pada waktunya, dan pil status pada kad di senarai kiri ikut sama',
    'workspace.tiktok.deselectTitle': 'Buang tanda, kekalkan slot',
    'workspace.tiktok.dragExhausted': 'Semua video produk ini sudah ada dalam kalendar',
    'workspace.tiktok.dragHint': 'Seret ke slot kosong dalam kalendar',
    'workspace.tiktok.emptyBody': 'Jalankan Flow dahulu — hanya produk yang sudah ada video boleh dijadualkan.',
    'workspace.tiktok.emptyTitle': 'Tiada produk bervideo',
    'workspace.tiktok.hint': 'Pilih template di bawah setiap tarikh, kemudian seret produk ke slot kosong yang muncul.',
    'workspace.tiktok.products': 'Products',
    'workspace.tiktok.remove': 'Buang',
    'workspace.tiktok.removeSelectedTitle': 'Keluarkan slot bertanda daripada kalendar',
    'workspace.tiktok.save': 'Simpan',
    'workspace.tiktok.saveAccountAria': 'Simpan akaun',
    'workspace.tiktok.scheduleTemplate': 'Schedule template',
    'workspace.tiktok.setNoVideo': 'Set {n}: tiada video',
    'workspace.tiktok.setReady': 'Set {n}: sedia',
    'workspace.tiktok.setScheduled': 'Set {n}: sudah dijadualkan',
    'workspace.tiktok.setScheduledOnAccount': 'Set {n}: sudah dijadualkan pada {akaun}',
    'workspace.tiktok.slotsSelected': '{n} slot dipilih',
    'workspace.tiktok.runSelected': 'Run terpilih',
    'workspace.tiktok.runSelectedTitle': 'Jalankan slot yang ditanda sahaja',
    'workspace.tiktok.undo': 'Undo',
    'workspace.tiktok.undoTitle': 'Batalkan perubahan terakhir pada kalendar ini',
    'workspace.uploadVideo': 'Upload video',
    'workspace.videoReady': 'Video sedia',

    /* ── ws (WorkspaceView) ──────────────────────────────────── */
    'ws.agent.alert.agentTiada': 'Agent "{nama}" sudah tiada — mungkin telah dipadam di PRO Studio. Sila pilih agent lain.',
    'ws.agent.alert.belumConfigure': 'Agent "{nama}" belum dikonfigurasi.\n\nBuka PRO Studio → Agent Saya → Langkah 5 (Configure), jalankan sekali dengan satu produk, kemudian Simpan.',
    'ws.agent.alert.gagalBacaAgent': 'Tetapan terkini agent "{nama}" tidak dapat dibaca. Semak sambungan internet anda, kemudian tekan Run semula.',
    'ws.agent.alert.pilihAgent': 'Sila pilih agent terlebih dahulu.',
    'ws.agent.alert.pilihTemplate': 'Pilih template dulu',
    'ws.agent.alert.tiadaKadFlownity': 'Tiada kad FLOWNITY dipilih. Hidupkan suis Smart untuk menjalankan kad Smart Custom dengan agent anda sendiri.',
    'ws.agent.alert.tiadaKadSmart': 'Tiada kad Smart Custom dipilih. Suis Smart menjalankan kad Smart Custom sahaja — matikan suis itu untuk kad FLOWNITY.',
    'ws.agent.alert.tiadaProduk': 'Tiada produk selected.',
    'ws.agent.ruang.tajuk': '{n} card tiada ruang gambar',
    'ws.agent.ruang.tajuk1': '1 card tiada ruang gambar',
    'ws.agent.ruang.sebab': 'Agent ini menyimpan gambar ke card. Satu card boleh menyimpan {jumlah} gambar sahaja: 1 gambar utama dan {maks} gambar tambahan. Card di bawah sudah tiada ruang untuk gambar baharu.',
    'ws.agent.ruang.baris': 'Gambar tambahan {ada}/{maks} · perlu {perlu} ruang kosong',
    'ws.agent.ruang.caraTajuk': 'Cara betulkan',
    'ws.agent.ruang.cara1': 'Tekan Edit data pada card yang ditanda, buang gambar tambahan yang tidak diperlukan, kemudian Simpan.',
    'ws.agent.ruang.cara2': 'Atau buang tick pada card itu dan pilih card lain.',
    'ws.agent.ruang.cara3': 'Tekan Run semula.',
    'ws.agent.ruang.tiadaJalan': 'Tiada automation dijalankan.',
    'ws.agent.ruang.faham': 'Faham',
    'ws.agent.ruang.label': 'Tiada ruang gambar',
    'ws.agent.ruang.labelTip': 'Agent yang dipilih perlu {perlu} ruang gambar kosong pada card ini. Buang gambar tambahan melalui Edit data.',
    'ws.flowPrompt.tajuk': '{n} card tiada prompt',
    'ws.flowPrompt.tajuk1': '1 card tiada prompt',
    'ws.flowPrompt.sebab': 'Flow perlukan prompt untuk setiap set yang dijalankan. Tanpa prompt, robot terpaksa guna nama produk sahaja — hasilnya tidak menjadi dan kredit Flow terbakar.',
    'ws.flowPrompt.sebabBabak': 'Flow perlukan prompt untuk setiap babak. Babak tanpa prompt akan dilangkau, jadi video akhir tidak lengkap.',
    'ws.flowPrompt.caraTajuk': 'Cara betulkan',
    'ws.flowPrompt.cara1': 'Isi prompt yang kosong — Generate semula card itu, atau tampal prompt sendiri.',
    'ws.flowPrompt.cara2': 'Atau buang tick pada card itu, atau buang tick set itu di Control Panel.',
    'ws.flowPrompt.cara3': 'Tekan Run semula.',
    'ws.flowPrompt.tiadaJalan': 'Tiada automation dijalankan.',
    'ws.flowPrompt.faham': 'Faham',
    'ws.flowModel.tajuk': 'Run dihentikan — model video tiada',
    'ws.flowModel.sebabUltra': 'Model video "{model}" tiada dalam akaun Google Flow anda. Model ini hanya tersedia untuk pakej Google AI Ultra.',
    'ws.flowModel.sebab': 'Model video "{model}" tiada dalam akaun Google Flow anda.',
    'ws.flowModel.tiadaKredit': 'SESAAT berhenti sebelum mencipta collection, jadi tiada kredit Flow digunakan.',
    'ws.flowModel.baris': 'Dihentikan sebelum collection dicipta',
    'ws.flowModel.caraTajuk': 'Cara betulkan',
    'ws.flowModel.langkah1': 'Buka Control Panel → Flow',
    'ws.flowModel.langkah2Ada': 'Pilih model Video yang tersedia dalam akaun anda',
    'ws.flowModel.langkah2': 'Pilih model Video lain',
    'ws.flowModel.langkah3': 'Tekan Run semula',
    'ws.flowModel.nota': 'Card lain dalam Run ini juga tidak dijalankan.',
    'ws.flowModel.faham': 'Faham',
    'ws.flowPrompt.kurangGambar': 'Image Prompt',
    'ws.flowPrompt.kurangVideo': 'Video Prompt',
    'ws.flowPrompt.kurangDua': 'Image Prompt dan Video Prompt',
    'ws.flowPrompt.barisSet': 'Set {n}: tiada {apa}',
    'ws.flowPrompt.barisBabak': 'Babak {n}: tiada prompt',
    'ws.flowPrompt.chipSet': 'Set {senarai} tiada prompt',
    'ws.flowPrompt.chipBabak': 'Babak {senarai} tiada prompt',
    'ws.agent.progress.dihentikan': 'Dihentikan ({siap}/{jumlah})',
    'ws.agent.progress.memproses': 'Processing {nama}...',
    'ws.agent.progress.cubaSemula': 'Mencuba semula {nama}...',
    'ws.agent.progress.mula': 'Mula...',
    'ws.agent.progress.selesai': 'Selesai {siap}/{jumlah}',
    'ws.agent.saya.belumConfigure': ' — belum Configure',
    'ws.agent.saya.butangRun': 'Run Agent ({bil})',
    'ws.agent.saya.pilih': '— Pilih agent —',
    'ws.agent.saya.tajuk': 'Agent Saya',
    'ws.agent.saya.tiadaAgent': 'Tiada agent — buka PRO Studio',
    'ws.agent.saya.titleBelumConfigure': 'Agent ini belum dikonfigurasi di PRO Studio',
    'ws.agent.saya.titlePilihDulu': 'Pilih agent dulu',
    'ws.agent.saya.titleRun': 'Run Agent',
    'ws.agent.titlePilihProduk': 'Select produk dulu',
    'ws.agent.titleSedangJalan': 'Sedang jalan...',
    'ws.agent.unnamed': 'Agent tanpa nama',
    'ws.ap.title': 'Agent Flownity',
    'ws.ap.comingSoon': 'Akan datang',
    'ws.ap.readyMade': 'Agent siap sedia oleh SESAAT. Buat masa ini kad FLOWNITY sahaja.',
    'ws.ap.myAgent': 'Agent saya',
    'ws.ap.noAgentYet': 'Belum ada agent',
    'ws.ap.buildOwn': 'Bina agent anda sendiri di PRO Studio, kemudian pilih di sini.',
    'ws.ap.openProStudio': 'Buka PRO Studio',
    'ws.ap.selectAgent': 'Pilih agent',
    'ws.ap.notConfigured': 'Belum dikonfigurasi',
    'ws.ap.pickToSetup': 'Pilih agent untuk melihat tetapannya.',
    'ws.ap.platform': 'Platform',
    'ws.ap.notConfiguredLong': 'Belum dikonfigurasi. Run sekali di PRO Studio, langkah 5, kemudian simpan.',
    'ws.ap.configured': 'Dikonfigurasi',
    'ws.ap.setsPerProduct': 'Set setiap produk',
    'ws.ap.scenes': 'Scene',
    'ws.ap.output': 'Output',
    'ws.ap.productPhoto': 'Gambar produk',
    'ws.ap.avatar': 'Avatar',
    'ws.ap.fieldsMatched': 'Field dipadankan',
    'ws.ap.savesImagesOne': 'Simpan {n} gambar',
    'ws.ap.savesImagesMany': 'Simpan {n} gambar',
    'ws.ap.saveImages': 'Simpan gambar',
    'ws.ap.perCardOne': '{n} gambar setiap card',
    'ws.ap.perCardMany': '{n} gambar setiap card',
    'ws.ap.editInProStudio': 'Edit di PRO Studio',
    'ws.ap.outImgNoVidOne': '{n} imej, tiada video',
    'ws.ap.outImgNoVidMany': '{n} imej, tiada video',
    'ws.ap.outImgVidOne': '{n} imej, {n} video',
    'ws.ap.outImgVidMany': '{n} imej, {n} video',
    'ws.ap.sceneEvery': 'setiap scene',
    'ws.ap.sceneNone': 'tidak digunakan',
    'ws.ap.sceneN': 'scene {n}',
    'ws.ap.running': 'Running {c} daripada {t}',
    'ws.ap.noProduct': 'Tiada produk dipilih',
    'ws.ap.nSelected': '{n} dipilih',
    'ws.ap.skipped': '{n} dilangkau, {jenis}',
    'ws.ap.notSmart': 'bukan Smart Custom',
    'ws.ap.notFlownity': 'bukan FLOWNITY',
    'ws.ap.tipRunning': 'Running...',
    'ws.ap.tipPickConfigured': 'Pilih agent yang telah dikonfigurasi dahulu',
    'ws.ap.tipSelectCard': 'Pilih sekurang-kurangnya satu kad',
    'ws.ap.runMyAgent': 'Run Agent Saya',
    'ws.ap.runAgentAI': 'Run Agent AI',
    'ws.alert.skippedNoData': '{n} produk ditarik masuk tetapi TIDAK dijana kerana tiada data produk.\n\nSila import produk tersebut menggunakan butang Import Products di halaman Products, kemudian tarik masuk semula ke Workspace.',
    'ws.arkib.alert.berjaya': '"{nama}" telah diarkibkan!',
    'ws.arkib.alert.gagal': 'Gagal mengarkibkan produk.',
    'ws.arkib.alert.import': '"{nama}" telah diimport ke space ini!',
    'ws.auto.cancel': 'Batal',
    'ws.auto.close': 'Tutup',
    'ws.auto.disconnectedBody': 'Extension tidak merespons. Selalu berlaku selepas extension update — bukan masalah produk anda.',
    'ws.auto.disconnectedHint': 'Klik butang di bawah untuk refresh tab ini. Selepas refresh, klik butang Run semula.',
    'ws.auto.disconnectedSub': 'Tab ini perlu di-refresh dulu',
    'ws.auto.disconnectedTitle': '🔴 Extension Terputus Sambungan',
    'ws.auto.extensionConnected': 'Extension Bersambung',
    'ws.auto.processing': 'Sedang memproses...',
    'ws.auto.refreshNow': 'Refresh Tab Sekarang',
    'ws.avatar.campur': 'Card dipilih campur lelaki & perempuan. Pilih card jantina sama sahaja dulu — satu avatar tak boleh untuk dua jantina.',
    'ws.avatar.hanyaGender': ' · {gender} sahaja',
    'ws.avatar.hijab': 'Hijab',
    'ws.avatar.namaLalai': 'Avatar',
    'ws.avatar.tiadaAvatar': 'Tiada avatar {gender} dalam library kau. Buat avatar {gender} dulu di panel Avatar (sidebar).',
    'ws.avatar.tiadaHijab': 'Tiada Hijab',
    'ws.avatar.tiadaJantina': 'Card dipilih tiada jantina — tak boleh tukar avatar (avatar mesti padan jantina dengan prompt asal).',
    'ws.avatar.tukarTajuk': 'Tukar avatar',
    'ws.avatarChange.cancel': 'Batal',
    'ws.avatarChange.confirm': 'Ya, tukar',
    'ws.avatarChange.count': '{n} card akan ditukar avatar. Prompt & video kekal — tiada jana semula, tiada coin.',
    'ws.avatarChange.fallbackName': 'Avatar',
    'ws.avatarChange.female': '♀ Perempuan',
    'ws.avatarChange.hijab': 'Hijab',
    'ws.avatarChange.male': '♂ Lelaki',
    'ws.avatarChange.noHijab': 'Tiada Hijab',
    'ws.avatarChange.warning': 'Prompt & video yang dah siap ditulis ikut avatar asal (jantina, umur, hijab). Pastikan avatar baru ni padan — contoh kalau asal ada hijab, jangan pilih yang tiada hijab, nanti hasil tak sama.',
    'ws.avatarChange.warningLabel': '⚠️ Perhatian:',
    'ws.card.avatarAttached': 'Avatar dilampirkan',
    'ws.card.collapse': 'Kuncupkan kad',
    'ws.card.copyCollectionLink': 'Salin link collection',
    'ws.card.copyLink': 'Salin link',
    'ws.card.customBackground': 'latar belakang tersuai',
    'ws.card.duplicateFrom': 'Kad ini salinan daripada "{nama}" — klik untuk buat salinan lagi',
    'ws.card.duplicateFromDeleted': 'Kad ini salinan (kad asal sudah dipadam) — klik untuk buat salinan lagi',
    'ws.card.editData': 'Edit data',
    'ws.card.editDataFail': 'Data produk tidak dapat dimuatkan. Cuba sekali lagi.',
    'ws.card.editLink': 'Edit link',
    'ws.card.expand': 'Kembangkan kad',
    'ws.card.extraInstruction': 'Extra Arahan',
    'ws.card.extraInstructionAdd': 'Tambah arahan tambahan (ditampal pada mesej Agent AI)',
    'ws.card.extraInstructionTip': 'Extra Arahan: {teks}',
    'ws.card.handMen': 'Tangan: Lelaki',
    'ws.card.handWomen': 'Tangan: Perempuan',
    'ws.card.hookSyncWarn': '⚠ Image Prompt tak auto-update — pattern hook tak detect. Edit Image Prompt manually.',
    'ws.card.linkTiktokProduct': 'Produk TikTok',
    'ws.card.linkShopee': 'Link Shopee',
    'ws.card.linkShopeeProduct': 'Produk Shopee',
    'ws.gateBeg.tajuk': '{n} kad tiada produk TikTok',
    'ws.gateBeg.sebab': 'Beg kuning tidak boleh dipasang pada kad ini. Tiada apa-apa dijalankan lagi.',
    'ws.gateBeg.tandaTiada': 'Tiada link',
    'ws.gateBeg.petua': 'Untuk post kad ini tanpa beg kuning: matikan "Pasang beg kuning" di Control Panel, kemudian Run kad ini sahaja.',
    'ws.gateBeg.petuaSemua': 'Video akan dihantar seperti biasa, cuma tanpa beg kuning. Tetapan "Pasang beg kuning" anda tidak berubah.',
    'ws.gateBeg.langkau': 'Langkau {n} kad ini, Run {m} yang lain',
    'ws.gateBeg.tanpaBeg': 'Post {n} kad ini tanpa beg kuning',
    'ws.card.loadFullTextFailed': 'Gagal memuatkan teks dari cloud. Sila tutup modal ini dan cuba semula.',
    'ws.card.loadingFullText': 'Memuatkan teks penuh dari cloud…',
    'ws.card.men': 'Lelaki',
    'ws.card.moduleBadge': 'Module: {nama}',
    'ws.card.noLink': 'Tiada pautan',
    'ws.card.openInExtension': 'Buka dalam Extension',
    'ws.card.retryPipeline': 'Jana semula pipeline',
    'ws.card.retryShort': 'CUBA SEMULA',
    'ws.card.templateBg': 'Template BG: {fail}',
    'ws.card.video.checking': 'Menyemak…',
    'ws.card.video.local': 'Video Tempatan',
    'ws.card.video.none': 'Tiada Video',
    'ws.card.video.ready': 'Video Sedia',
    'ws.card.video.savedCloud': 'Disimpan ke Cloud',
    'ws.card.video.savedLocal': 'Tersimpan di browser ini',
    'ws.card.video.thumbAlt': 'Thumbnail video',
    'ws.card.viewEditFullPrompt': 'Lihat / Edit prompt penuh',
    'ws.card.women': 'Perempuan',
    'ws.common.cancel': 'Batal',
    'ws.common.close': 'Tutup',
    'ws.common.copy': 'Salin',
    'ws.common.noName': '(tanpa nama)',
    'ws.common.save': 'Simpan',
    'ws.common.tryAgain': 'Cuba lagi',
    'ws.confirm.calculating': ' (mengira ruang…)',
    'ws.confirm.cancel': 'Batal',
    'ws.confirm.delete': 'Padam',
    'ws.confirm.deleteProductsBtn': 'Padam {n} produk',
    'ws.confirm.deleteProductsMsg': 'Video berkaitan akan dipadam terus daripada storan awan{ruang}. Tindakan ini tidak boleh dibatalkan.',
    'ws.confirm.deleteProductsTitle': 'Padam {n} produk?',
    'ws.confirm.deleteVideoMsg': 'Video untuk {setLabel} akan dipadam terus dari cloud. Tindakan ini tak boleh undo.',
    'ws.confirm.deleteVideoTitle': 'Padam video ini?',
    'ws.confirm.deleteVideosBtn': 'Padam {n} video',
    'ws.confirm.deleteVideosMsg': 'Video sahaja akan dipadam terus daripada storan awan — produk, prompt dan kapsyen kekal{ruang}. Tindakan ini tidak boleh dibatalkan.',
    'ws.confirm.deleteVideosTitle': 'Padam {n} video?',
    'ws.confirm.deleting': 'Memadam…',
    'ws.confirm.deletingProgress': 'Memadam {selesai}/{jumlah}…',
    'ws.confirm.kosongPromptBtn': 'Kosongkan {n} kad',
    'ws.confirm.kosongPromptBtnSatu': 'Kosongkan 1 kad',
    'ws.confirm.kosongPromptDijana': ' Sedang dijana, dilangkau: {n} kad.',
    'ws.confirm.kosongPromptHadMasa': 'sambungan terlalu lambat',
    'ws.confirm.kosongPromptMsg': 'Semua teks prompt dan Caption TikTok dalam {set} akan dikosongkan. Video, gambar dan data produk kekal. Tindakan ini tidak boleh dibatalkan.',
    'ws.confirm.kosongPromptSemak': 'Menyemak…',
    'ws.confirm.kosongPromptSemakMsg': 'Menyemak teks pada kad yang ditanda…',
    'ws.confirm.kosongPromptSudahKosong': ' Sudah kosong, dilangkau: {n} kad.',
    'ws.confirm.kosongPromptTitle': 'Kosongkan prompt {set}?',
    'ws.confirm.kosongPromptTulis': 'Mengosongkan…',
    'ws.confirm.spaceFreed': ' (~{saiz} akan dikosongkan)',
    'ws.detail.loadFailed': 'Gagal memuatkan teks produk',
    'ws.detail.loadFailedRetry': 'Teks tidak dapat dimuat — klik untuk cuba semula',
    'ws.detail.loadingPrompt': 'Memuatkan teks prompt…',
    'ws.dup.cancel': 'Batal',
    'ws.dup.confirm': 'Salin {jumlah} kad',
    'ws.dup.confirmLama': 'Ya, salin {jumlah} kad',
    'ws.dup.copiesAria': 'Bilangan salinan',
    'ws.dup.copiesPerCard': 'Salinan bagi setiap kad',
    'ws.dup.copiesPerCardLama': 'Berapa salinan bagi setiap kad?',
    'ws.dup.copiesTitle': 'Bilangan salinan (tiada had)',
    'ws.dup.dataKadFailed': '{n} salinan dibuat, tetapi data produk yang disunting pada kad asal tidak dapat disalin. Sila padam salinan itu dan Duplicate sekali lagi.',
    'ws.dup.failed': 'Gagal buat salinan: {msg}',
    'ws.dup.noQuota': 'Kuota generation tidak digunakan',
    'ws.dup.notCopied': 'Video, thumbnail dan status upload TikTok tidak disalin — setiap kad baharu menjana videonya sendiri apabila anda Run Flow. Nama salinan diberi nombor, contoh (2), supaya folder video mudah dibezakan.',
    'ws.dup.selectedCount': '{n} kad dipilih',
    'ws.dup.success': '{n} salinan dibuat — sedia untuk Run Flow. Kuota generation tidak digunakan.',
    'ws.dup.title': 'Duplicate kad',
    'ws.dup.titleLama': 'Duplicate Kad',
    'ws.dup.tryAgain': 'Cuba lagi',
    'ws.dup.willCreate': '{jumlah} kad baharu akan dihasilkan dengan prompt, gambar produk, template dan avatar yang sama.',
    'ws.dup.willCreateLama': '{jumlah} kad baharu akan dihasilkan dengan prompt, gambar produk, template dan avatar yang sama. Kuota generation tidak digunakan kerana tiada penjanaan AI baharu.',
    'ws.ext.putus.detailAgent': 'Tab ini perlu di-refresh dulu sebelum boleh run Agent AI.',
    'ws.ext.putus.detailAgentSambung': 'Tab ini perlu di-refresh dulu sebelum sambung run Agent AI.',
    'ws.ext.putus.tajuk': 'Extension Terputus Sambungan',
    'ws.ext.yatim.butang': 'Refresh',
    'ws.ext.yatim.tajuk': 'Extension dah di-reload',
    'ws.ext.yatim.teks': 'Refresh tab ini untuk sambung sync semula dengan extension.',
    'ws.extra.cancel': 'Batal',
    'ws.extra.delete': 'Padam',
    'ws.extra.panelTitle': 'Extra Arahan — ditampal pada mesej Agent AI produk ini',
    'ws.extra.placeholder': 'Contoh: Guna gaya lawak. Fokus audiens mak-mak.',
    'ws.extra.save': 'Simpan',
    'ws.flownity.akanDatang': ' — Akan Datang',
    'ws.flownity.alert.gagalMula': 'Gagal mula scrape: {ralat}',
    'ws.flownity.alert.pilihProduk': 'Pilih sekurang-kurangnya satu produk dulu.',
    'ws.flownity.alert.urlBelumSet': 'Admin belum set URL {jenisAgen} untuk FLOWNITY.\nBuka gear ⚙ FLOWNITY → section "Scrape Agent AI" → pilih {platform} → isi URL + Simpan.',
    'ws.flownity.scrapeTajuk': 'Scrape Agent AI',
    'ws.gen.goyangNeedTemplate': 'GOYANG memerlukan template. Sila pilih template di sidebar sebelum cuba lagi.',
    'ws.gen.initializing': 'Sedang bermula…',
    'ws.gen.modulesNotReady': 'Senarai module belum siap dimuat. Tunggu 1-2 saat, kemudian cuba Generate semula.',
    'ws.gen.needSubModule': 'Module ini memerlukan pilihan {label}. Sila pilih di sidebar sebelum Generate.',
    'ws.gen.noData': 'Produk ini tiada data produk. Sila import semula produk ini menggunakan butang Import Products di halaman Products, kemudian tarik masuk semula ke Workspace.',
    'ws.gen.status.cached': 'Intelligence sudah di-cache — analisa dilangkau...',
    'ws.gen.status.init': 'Memulakan...',
    'ws.gen.step.generate.detail': 'Menjana kandungan berkualiti tinggi...',
    'ws.gen.step.generate.label': 'Penjanaan Kreatif',
    'ws.gen.step.research.detail': 'Mencari maklumat produk di web...',
    'ws.gen.step.research.label': 'Carian Web',
    'ws.gen.step.vision.detail': 'Menganalisa gambar produk...',
    'ws.gen.step.vision.label': 'Analisa Gambar',
    'ws.gen.subModuleFallback': 'teknik',
    'ws.gen.unknownError': 'Ralat tidak diketahui.',
    // Hasil Generate tertinggal (page ditutup semasa Generate) — useHasilGenerateTertinggal
    'ws.gen.tertinggal.terhenti': 'Generate terhenti sebelum siap. Sila tekan Retry.',
    'ws.gen.tertinggal.terlaluBesar': 'Hasil Generate terlalu besar untuk disimpan. Sila tekan Retry.',
    'ws.gen.tertinggal.kosong': 'Generate tidak memulangkan hasil. Sila tekan Retry.',
    'ws.gen.tertinggal.tiadaLogic': 'Hasil Generate tidak dapat dimasukkan kerana tetapan module belum dimuat. Sila tekan Retry.',
    'ws.gender.lelaki': 'Lelaki',
    'ws.gender.lelakiRingkas': 'Lelaki',
    'ws.gender.perempuan': 'Perempuan',
    'ws.gender.perempuanRingkas': 'Wanita',
    'ws.image.metaSaveFailed': 'Gambar dah upload, tapi gagal save metadata: {msg}',
    'ws.image.readFailed': 'Gagal baca fail gambar: {msg}',
    'ws.image.reloginNeeded': 'Sila log masuk semula untuk ganti gambar.',
    'ws.image.unknownError': 'tidak diketahui',
    'ws.image.uploadFailed': 'Gagal upload gambar: {msg}',
    'ws.import.done': '{n} produk diimport',
    'ws.import.failed': 'Gagal save bulk import. Sila cuba lagi.',
    'ws.input.empty': 'Sila masukkan data produk.',
    'ws.input.skippedNoData': '{n} produk ditambah tetapi TIDAK dijana kerana tiada data produk.\n\nSila import produk menggunakan butang Import Products di halaman Products, kemudian tarik masuk semula ke Workspace.',
    'ws.jadual.kepalaProduk': 'Produk',
    'ws.jadual.seret.habis': 'Ketiga-tiga set sudah ada dalam kalendar ini',
    'ws.jadual.seret.pukal': 'Seret {bil} kad bertanda sekali gus · bilangan slot mengikut template hari yang dijatuhkan',
    'ws.jadual.seret.tunggal': 'Seret ke slot kalendar · {guna}/3 set sudah dijadualkan',
    'ws.jadual.titik.diLuar': 'Set {n}: sudah dijadualkan pada {tarikh}',
    'ws.jadual.titik.dijadual': 'Set {n}: sudah dalam kalendar ini',
    'ws.jadual.titik.sedia': 'Set {n}: sedia',
    'ws.jadual.titik.tiadaVideo': 'Set {n}: tiada video lagi',
    'ws.jana.batalTitle': 'Batalkan',
    'ws.jana.dismiss': 'Dismiss',
    'ws.jana.gagal.gangguan': 'Gangguan Sementara',
    'ws.jana.gagal.tajuk': 'Pipeline Gagal',
    'ws.jana.kapsul.teks': 'menulis 3 set prompt…',
    'ws.jana.lama.kemajuan': 'Progress',
    'ws.jana.lama.langkahSiap': 'Completed',
    'ws.jana.lama.memproses': 'Processing your content...',
    'ws.jana.lama.mula': 'Initializing...',
    'ws.jana.lama.mulaPipeline': 'Initializing pipeline...',
    'ws.jana.lama.semuaSelesai': 'All steps finished',
    'ws.jana.lama.siap': 'Pipeline Complete!',
    'ws.jana.lama.tajuk': 'AI Pipeline',
    'ws.jana.lencana.peringkat': '3 Peringkat',
    'ws.jana.lencana.title': 'Pipeline AI — 3 peringkat analisis untuk hasil video berkualiti',
    'ws.jana.lencanaAi': 'PIPELINE AI',
    'ws.kad.bgLalai': 'custom background',
    'ws.kad.buangTanda': 'Buang tanda',
    'ws.kad.bukaSemua': 'Expand all cards',
    'ws.kad.editNama': 'Edit name',
    'ws.kad.idTitle': 'ID produk TikTok',
    'ws.kad.pilTandaFlow': 'Click to mark as Flow',
    'ws.kad.pilTandaTiktok': 'Click to mark as TikTok',
    'ws.kad.pratonton': 'Preview',
    'ws.kad.salinNama': 'Copy name',
    'ws.kad.tambahGambar': 'Add image',
    'ws.kad.tambahIsi': 'Add product or image',
    'ws.kad.tambahProduk': 'Add product',
    'ws.kad.tandakan': 'Tandakan kad',
    'ws.kad.tangan': 'Hand: {gender}',
    'ws.kad.templateBg': 'Template BG: {fail}',
    'ws.kad.tukarGambar': 'Change Image',
    'ws.kad.tutupSemua': 'Collapse all cards',
    'ws.mixed.body': 'Awak pilih produk dari {n} module berlainan. Setiap module guna automation script berbeza, jadi tak boleh run serentak dalam satu batch. Sila pilih dari satu module sahaja, atau run secara berasingan.',
    'ws.mixed.productCount': '{n} produk',
    'ws.mixed.subtitle': 'Pilih satu module sahaja untuk Run Flow',
    'ws.mixed.title': 'Tak Boleh Run Mixed Module',
    'ws.mixed.understood': 'Faham',
    'ws.panel.paparButang': 'Show Control Panel',
    'ws.panel.paparTitle': 'Papar Control Panel',
    'ws.preview.alt': 'Pratonton',
    'ws.prompt.editAllFullscreen': 'Edit semua prompt (fullscreen)',
    'ws.prompt.empty': 'Kosong',
    'ws.prompt.hookPlaceholder': 'Hook ayat — edit di sini auto-sync ke Image Prompt',
    'ws.prompt.nsceneDialoguePlaceholder': 'Dialogue Scene {n}...',
    'ws.prompt.nsceneImagePlaceholder': 'Image Prompt Scene {n}...',
    'ws.prompt.nsceneVideoPlaceholder': 'Video Prompt Veo 3 Scene {n}...',
    'ws.prompt.tiktokCaptionPlaceholder': 'TikTok caption...',
    'ws.prompt.voiceoverPlaceholder': 'Voiceover script — auto-sync ke Video Prompt',
    'ws.prompt.voiceoverScene1Placeholder': 'Voiceover Scene 1 — auto-sync ke Video Prompt (Scene 1)',
    'ws.prompt.voiceoverScene2Placeholder': 'Voiceover Scene 2 — auto-sync ke Video Prompt (Scene 2)',
    'ws.promptModal.bgFragment': '🔎 BG fragment: {nilai}',
    'ws.promptModal.closeQuickNotes': 'Tutup Quick Notes',
    'ws.promptModal.fragmentUsed': '🔎 Fragment used: {nilai}',
    'ws.promptModal.nsceneImagePlaceholder': 'Image Prompt Scene {n} — visual sahaja',
    'ws.promptModal.nsceneVideoPlaceholder': 'Video Prompt Veo 3 Scene {n} — visual + dialog',
    'ws.promptModal.openQuickNotes': 'Buka Quick Notes',
    'ws.promptModal.saveBtn': 'Simpan',
    'ws.promptModal.saveHint': 'Edit dan klik Simpan untuk kekalkan perubahan',
    'ws.promptModal.saved': 'Berjaya disimpan',
    'ws.promptModal.savedBtn': 'Tersimpan',
    'ws.promptModal.title': 'Edit Prompts',
    'ws.promptModal.unsavedChanges': 'Ada perubahan yang belum disimpan',
    'ws.promptModal.untitledProduct': 'Produk tanpa nama',
    'ws.pukal.batalTitle': 'Batal pilihan',
    'ws.pukal.cancel': 'Cancel',
    'ws.pukal.del': 'Padam',
    'ws.pukal.delete': 'Delete',
    'ws.pukal.dipilih': '{bil} dipilih',
    'ws.pukal.dipilihLama': '{bil} selected',
    'ws.pukal.duplicate': 'Duplicate',
    'ws.pukal.duplicateTitle': 'Salin kad terpilih — prompt sama, sedia untuk Run Flow (tiada kuota generation)',
    'ws.pukal.groupBaharu': 'New Group',
    'ws.pukal.groupUtama': 'Main Group',
    'ws.pukal.kosong': 'Kosongkan',
    'ws.pukal.kosongPromptTitle': 'Kosongkan teks prompt dan caption pada kad yang ditanda — video, gambar dan data produk tidak disentuh',
    'ws.pukal.mark': 'Mark',
    'ws.pukal.markAgentDilangkau': '{bil} kad tidak dipindahkan. Hanya kad Smart Custom dan FLOWNITY boleh diletakkan dalam {tab}.',
    'ws.pukal.move': 'Move',
    'ws.pukal.namaGroup': 'Group name',
    'ws.pukal.pilihSemua': 'Pilih semua',
    'ws.pukal.pilihSemuaTitle': 'Select All (Ctrl+A)',
    'ws.pukal.retry': 'Retry',
    'ws.pukal.retryTitle': 'Jana semula pipeline untuk kad yang ditanda',
    'ws.pukal.save': 'Save',
    'ws.pukal.semuaSet': 'Semua Set',
    'ws.pukal.status': 'Status',
    'ws.pukal.statusTitle': 'Tukar atau kosongkan status pada kad yang ditanda — untuk akaun yang sedang dibuka di kalendar. Slot kalendar akaun itu ikut sama; video dan caption tidak disentuh.',
    'ws.pukal.tukar': 'Tukar',
    'ws.quota.dailyEmpty': 'Kuota harian anda telah habis ({used}/{cap}). Kuota akan reset pada 12:00 AM (Malaysia).',
    'ws.quota.dailyShort': 'Anda memilih {count} produk, tetapi baki kuota hari ini tinggal {remaining} daripada {cap}.\n\nSila kurangkan pilihan kepada {remaining} produk atau kurang. Kuota akan reset pada 12:00 AM (Malaysia).',
    'ws.quota.trialEmpty': 'Coin percubaan anda telah habis (0/{cap}). Sila naik taraf ke pelan berbayar untuk teruskan.',
    'ws.quota.trialShort': 'Anda memilih {count} produk, tetapi baki coin percubaan anda tinggal {remaining}.\n\nSila kurangkan pilihan kepada {remaining} produk atau kurang, kemudian cuba semula.',
    'ws.raw.close': 'Tutup',
    'ws.raw.copied': '✓ Disalin!',
    'ws.raw.copyAll': 'Salin Semua',
    'ws.raw.copyChatLink': 'Salin link chat',
    'ws.raw.plain': 'Teks Biasa',
    'ws.raw.title': 'Raw AI Output',
    'ws.retry.bulkConfirm': 'Jalankan semula pipeline untuk {n} produk?\n\n• Prompt & caption sedia ada akan dipadam dan dijana semula\n• Video sedia ada KEKAL — ia tidak disentuh\n• Menggunakan {n} daripada kuota generation harian anda',
    'ws.retry.confirm': 'Reset "{name}" ke fresh pipeline?\n\nIni akan:\n• Clear semua prompts & captions\n• Reset status ke pending\n• Video sedia ada akan disimpan\n• Pipeline AI akan run semula secara automatik',
    'ws.retry.failed': '❌ Gagal reset: {msg}',
    'ws.run.continueOneOnly': 'Untuk Continue Collection, pilih SATU produk sahaja.',
    'ws.run.extDisconnected': 'Extension Terputus Sambungan',
    'ws.run.extDisconnectedFlow': 'Tab ini perlu di-refresh dulu sebelum boleh start Flow.',
    'ws.run.extDisconnectedTiktok': 'Tab ini perlu di-refresh dulu sebelum boleh start TikTok.',
    'ws.run.failed': '❌ Automasi Gagal!',
    'ws.run.flowTitle': 'Flow Automation — {n} produk',
    'ws.run.hydrateFailed': 'Gagal memuatkan teks prompt dari cloud. Sila semak sambungan internet anda dan cuba semula.',
    'ws.run.loginFirst': 'Sila log masuk terlebih dahulu.',
    'ws.run.moduleMaintenance': 'Modul ini sedang penyelenggaraan — kami sedang adapt extension untuk interface terbaru Google Labs Flow. Nanti kami buka balik sebaik sahaja stabil.',
    'ws.run.noCollection': 'Produk ini belum ada collection tersimpan.\nRun Flow biasa sekali dulu — collection akan disimpan automatik, baru boleh Continue.',
    'ws.run.selectProduct': 'Sila pilih produk untuk dijalankan.',
    'ws.run.selectSet': 'Sila pilih sekurang-kurangnya satu Set (S1-S3).',
    'ws.run.workflowKadModul': 'Workflow "Guna gambar pada card" buat masa ini hanya untuk AI8SAAT dan SMART 1 babak.\n\nCard yang dipilih guna {module}. Tukar Workflow ke "Generate di Flow" untuk run card ini.',
    'ws.run.workflowKadVeo': 'Model Veo hanya guna 3 gambar card.\n\n{n} card yang dipilih ada lebih daripada 3 gambar — gambar selebihnya tidak akan masuk video (keutamaan: gambar utama, avatar, kemudian gambar 2, 3…).\n\nPilih Omni Flash untuk guna semua gambar.\n\nTeruskan dengan 3 gambar?',
    'ws.run.setsLabel': 'Sets: {sets}',
    'ws.run.started': '🚀 Automasi Bermula!',
    'ws.run.startedDetail': '{n} produk telah dihantar ke Extension. Extension sedang membuka Google Flow...',
    'ws.run.step.done': 'Selesai!',
    'ws.run.step.prepare': 'Menyediakan produk...',
    'ws.run.step.send': 'Menghantar arahan ke Extension...',
    'ws.run.tasksSent': '{n} tugasan dihantar ✓',
    'ws.run.tiktokAfterFlow': '\n★ TikTok akan auto-run selepas Flow selesai.',
    'ws.save.ralat.arahan': 'Klik {reload} untuk muat semula. Selepas reload anda boleh paste kandungan clipboard untuk recovery.',
    'ws.save.ralat.butangReload': 'Reload',
    'ws.save.ralat.clipboard': '✓ {bil} edit telah disalin ke clipboard sebagai backup.',
    'ws.save.ralat.tajuk': 'Save gagal selepas 3 cubaan',
    'ws.save.status.mencubaSemula': 'Mencuba semula ({cubaan})...',
    'ws.save.status.menyimpan': 'Menyimpan...',
    'ws.save.status.tersimpan': '✓ Tersimpan',
    'ws.sched.min15': 'TikTok memerlukan jadual sekurang-kurangnya 15 minit dari sekarang.\n\nSila pilih masa mula yang lebih lewat.',
    'ws.sched.noCaption': 'Tiada caption pada set ini.',
    'ws.sched.noSlot': 'Tiada slot kosong — {n} video tidak dapat diletakkan. Pilih template pada tarikh lain, atau kosongkan slot sedia ada.',
    'ws.sched.noTemplate': 'Hari ini belum ada template — pilih template pada kepala hari dahulu, kemudian seret video masuk.',
    'ws.sched.akaunTerakhir': 'Tidak boleh padam akaun terakhir. Cipta satu lagi dahulu.',
    'ws.sched.akaunDipadam': 'Akaun kalendar dipadam.',
    'ws.sched.run.noDate': 'Sila tick sekurang-kurangnya satu tarikh pada kepala kalendar sebelum Run.',
    'ws.sched.run.noPilih': 'Sila pilih sekurang-kurangnya satu slot sebelum Run — tick kepala hari untuk pilih semua slot hari itu, atau klik slot satu-satu.',
    'ws.phone.noVideo': "Tiada video pada card atau slot yang dipilih. Pilih card atau slot yang ada video.",
    'ws.sched.run.noRunnable': 'Tiada slot yang boleh dijalankan pada tarikh yang ditick.',
    'ws.sched.run.rVideo': '{n} slot belum ada video (jalankan Flow dahulu)',
    'ws.sched.run.rGambar': '{n} slot card-nya tiada gambar (Photo post)',
    'ws.tiktok.gambar.tiada': 'Photo post: {n} card tiada gambar (gambar utama / tambahan). Untick card ini atau tambah gambar, kemudian Run semula.',
    'ws.tiktok.gambar.tiadaSet': 'Photo post: pilih sekurang-kurangnya satu set (status post disimpan pada set itu).',
    'ws.sched.run.rLain': '{n} slot dilangkau — sudah dijalankan oleh browser lain',
    'ws.sched.run.rMasa': '{n} slot waktunya sudah terlalu hampir (kurang 15 minit)',
    'ws.sched.run.rHad': '{n} slot melepasi had {had} hari',
    'ws.sched.run.rProduk': '{n} slot produknya sudah tiada',
    'ws.sched.run.rKunci': '{n} slot tarikhnya tidak difahami — buka semula tab Schedule, kemudian seret video itu sekali lagi',
    'ws.sched.run.skipped': '{n} slot dilangkau (video belum siap / waktu terlepas). {jalan} akan dijalankan.',
    'ws.sched.run.otherGroup': '{n} daripada slot ini milik produk group lain — ia tetap akan dijalankan.',
    'ws.sched.run.title': 'Jadual TikTok — {n} video',
    'ws.sched.run.detail': '{n} video pada waktu tepat setiap slot.',
    'ws.sched.run.startedDetail': '{n} video dihantar ke Extension — akan dijadualkan pada waktu tepat setiap slot.',
    'ws.sched.run.bar': '{n} video · {julat}',
    'ws.sched.run.barKosong': 'Tiada slot dipilih',
    'workspace.cara.title': 'Cara post',
    'workspace.cara.now': 'Post sekarang',
    'workspace.cara.schedule': 'Jadual',
    'workspace.cara.draft': 'Simpan draf',
    'workspace.cara.nowNote': 'Terbit serta-merta. Satu video sahaja setiap Run.',
    'workspace.cara.scheduleNote': 'Robot jadualkan ikut waktu setiap slot kalendar yang ditick.',
    'workspace.cara.scheduleKunci': 'Hanya dari tab Schedule — kalendar yang menetapkan waktunya.',
    'workspace.cara.draftNoteFb': 'Simpan sebagai draf di Content Library Facebook — semak dan terbitkan sendiri.',
    'workspace.cara.draftNoteTt': 'Simpan sebagai draf di TikTok — edit (letak music, dll) dan terbitkan sendiri.',
    'workspace.cara.pilihDulu': 'Pilih satu cara dahulu — butang Run terkunci sehingga dipilih.',
    'workspace.cara.showcase': 'Showcase Only tidak memuat naik video, jadi cara post tidak terpakai.',
    'workspace.cara.runKunci': 'Pilih cara post',
    'workspace.page.post.directSchedule': 'Direct Schedule',
    'workspace.page.post.directScheduleOff': 'Schedule (Save in Draft)',
    'ws.sched.direct.on': 'Robot terus menjadualkan & menerbitkan video ikut waktu setiap slot. Anda tak perlu buka browser pada waktu itu.',
    'ws.sched.direct.off': 'Robot simpan video sebagai DRAF dahulu — anda boleh edit (letak music, dll) dan terbitkan sendiri di TikTok.',
    'ws.sched.overLimit': 'Jadual ini melebihi had TikTok.\n\n{bil} video pada selang {selang} minit menjadikan video terakhir jatuh melebihi {had} hari dari sekarang, dan TikTok tidak menerima tarikh sejauh itu.\n\nSila kurangkan selang masa, atau kurangkan bilangan video dalam larian ini.',
    'ws.sched.partial': '{diletak} video diletakkan{hujung}. {tinggal} lagi tidak muat — slot pada hari-hari berikutnya sudah penuh atau belum ada template.',
    'ws.sched.pickStart': 'Sila pilih masa mula jadual terlebih dahulu.',
    'ws.sched.placed': '{diletak} video diletakkan{hujung}.',
    'ws.sched.step5': 'TikTok hanya menerima jadual pada setiap 5 minit (contoh 14:30, 14:35).\n\nSila laraskan minit pada masa mula.',
    'ws.sched.untilSuffix': ' (hingga {tarikh})',
    'ws.senarai.kosong.agent': 'Mark products as {agent} dari tab {flow} / {tiktok} untuk muncul di sini',
    'ws.senarai.kosong.tajuk': 'Tiada Produk',
    'ws.senarai.kosong.tajukTab': 'Tiada Produk {tab}',
    'ws.senarai.kosong.tambah': 'Add products using the form above',
    'ws.senarai.kosong.tiktok': 'Mark products as {tiktok} to see them here',
    'ws.sort.hint': 'Tekan pilihan yang sama sekali lagi untuk menterbalikkan arah.',
    'ws.sort.module': 'Module',
    'ws.sort.number': 'Nombor',
    'ws.sort.time': 'Masa',
    'ws.sort.manual': 'Susunan saya',
    'ws.gbr.buka': 'Papar kesemua {bil} gambar produk',
    'ws.gbr.tutup': 'Kuncupkan gambar produk',
    'ws.gbr.utama': 'Utama',
    'ws.gbr.tiadaAvatar': 'Tiada avatar',
    'ws.gbr.seret': 'Gambar {n} — tekan untuk lihat besar, seret untuk susun. Gambar 1 ialah gambar utama',
    'ws.gbr.tajuk': 'Gambar produk {n} daripada {bil} — dihantar ke Flow',
    // Paparan gambar besar (PratontonGambar.jsx, 2026-09-13) — borang Data Produk + jalur gambar kad
    'gbrBesar.aria': 'Paparan gambar besar',
    'gbrBesar.tutup': 'Tutup (Esc)',
    'gbrBesar.sebelum': 'Gambar sebelum (←)',
    'gbrBesar.seterusnya': 'Gambar seterusnya (→)',
    'gbrBesar.ralat': 'Gambar ini tidak dapat dipaparkan.',
    'gbrBesar.lihat': 'Lihat saiz besar',
    'gbrBesar.lihatNo': 'Lihat gambar {n} saiz besar',
    'gbrBesar.utama': 'Utama',
    'gbrBesar.dipilih': 'Dipilih',
    'gbrBesar.pilih': 'Pilih gambar ini',
    'gbrBesar.buang': 'Buang pilihan',
    'gbrBesar.penuh': 'Had {max} gambar tambahan sudah penuh — buang satu dahulu.',
    'gbrBesar.kiraTambahan': 'Gambar tambahan {n}/{max}',
    'gbrBesar.galeri': 'Galeri TikTok',
    'ws.sort.tip.manual': 'Seret kad untuk menyusun',
    'ws.susun.seret.tunggal': 'Seret untuk menyusun kad',
    'ws.susun.seret.pukal': 'Seret {bil} kad bertanda sekali gus untuk menyusun',
    'ws.sort.tip.newest': 'Terbaru dahulu',
    'ws.sort.tip.oldest': 'Lama dahulu',
    'ws.space.kelihatan': 'Visible',
    'ws.space.kustomAntaraMuka': 'Interface Customization',
    'ws.space.labelCaptionTiktok': 'TikTok Caption Label',
    'ws.space.labelPromptImej': 'Image Prompt Label',
    'ws.space.labelPromptVideo': 'Video Prompt Label',
    'ws.space.logicLalai': 'Default AI Logic',
    'ws.space.modLarian.label': 'Execution Mode',
    'ws.space.modLarian.tip': 'Pilih cara browser memproses video anda.',
    'ws.space.modScene.tajuk': 'Scene Mode',
    'ws.space.modScene.teks': 'Satu browser buat semua scene serentak.',
    'ws.space.modSet.tajuk': 'Set Mode',
    'ws.space.modSet.teks': 'Kerja diasingkan mengikut Set pada browser berbeza.',
    'ws.space.pilihPersona': 'Select a default persona...',
    'ws.space.sentiasaHidup': 'ALWAYS ON',
    'ws.space.set1Tajuk': 'SET 1 TITLE',
    'ws.space.set2Tajuk': 'SET 2 TITLE',
    'ws.space.set3Tajuk': 'SET 3 TITLE',
    'ws.space.showField': 'SHOW FIELD',
    'ws.space.subtajuk': 'Kawal cara AI bekerja untuk space {nama}',
    'ws.space.tajuk': 'Space Settings',
    'ws.space.urusSet': 'Set Management',
    'ws.split.alert.gagalMuat': 'Gagal memuatkan teks penuh produk dari cloud. Sila semak sambungan internet anda dan cuba semula.',
    'ws.susun.ikutMasa': 'By Time',
    'ws.susun.ikutModule': 'By Module',
    'ws.susun.ikutNombor': 'By Number',
    'ws.susun.menaik': 'Ascending (1-10)',
    'ws.susun.menurun': 'Descending (10-1)',
    'ws.susun.modulAZ': 'Module A-Z',
    'ws.susun.modulZA': 'Module Z-A',
    'ws.susun.terbaru': 'Newest',
    'ws.susun.terbaruDulu': 'Newest First',
    'ws.susun.terlama': 'Oldest',
    'ws.susun.terlamaDulu': 'Oldest First',
    'ws.tab.agentAi': 'My Agent',
    'ws.tab.all': 'Semua',
    'ws.tab.flow': 'Flow',
    'ws.tab.generate': 'Generate',
    'ws.tab.schedule': 'Schedule',
    'ws.tab.tiktok': 'Tiktok',
    'ws.tiktok.doneMode.postOnly': ' Post Video Only.',
    'ws.tiktok.doneMode.tanpaBeg': ' Post video tanpa beg kuning.',
    'ws.tiktok.doneMode.showcaseOnly': ' Showcase Only.',
    'ws.tiktok.doneMode.showcasePost': ' Showcase + Post Video.',
    'ws.tiktok.failed': '❌ TikTok Automation Gagal!',
    'ws.tiktok.mode.postOnly': ' | Post Only',
    'ws.tiktok.mode.tanpaBeg': ' | Tanpa beg kuning',
    'ws.tiktok.mode.showcaseOnly': ' | Showcase Only',
    'ws.tiktok.mode.showcasePost': ' | Showcase + Post',
    'ws.cara.pilihDulu': 'Pilih cara post dahulu (Post sekarang · Jadual · Simpan draf) di Control Panel.',
    'ws.sched.run.nowSatu': 'Post sekarang hanya untuk SATU video. Anda tick {n} slot — kekalkan satu sahaja, atau pilih Jadual / Simpan draf.',
    'ws.fb.jadualKalendar': 'Jadual hanya dari tab Schedule — di sini tiada waktu untuk dijadualkan. Pergi ke tab Schedule dan tick slot, atau pilih Post sekarang / Simpan draf.',
    'ws.fb.perluKemasKiniKalendar': 'Run Facebook dari kalendar memerlukan extension SESAAT versi terbaharu. Sila muat turun dan pasang semula extension dari dashboard, kemudian cuba lagi.',
    'ws.fb.run.startedDetail': '{n} reel dihantar ke Extension — robot membuka Content Library Facebook dan mengikut waktu setiap slot. Jangan tutup tab itu.',
    'ws.fb.run.rMasa': '{n} slot waktunya sudah terlalu hampir (kurang 30 minit)',
    'ws.fb.run.rHad': '{n} slot melepasi had {had} hari',
    'ws.fb.stopNota': 'Robot Facebook tidak boleh dihentikan di tengah jalan — reel yang sedang dimuat naik akan diselesaikan dahulu.',
    'ws.caption.fb': 'Facebook Caption',
    'ws.caption.fbHint': 'Kosong = guna caption TikTok.',
    'ws.caption.fbPlaceholder': 'Caption Facebook (pilihan)',
    'ws.caption.fbKosong': 'Kosong — robot Facebook guna caption TikTok',
    'ws.caption.suis': 'Tukar paparan caption TikTok / Facebook',
    'ws.caption.label': 'Caption',
    'ws.caption.fbKosongSengaja': 'Kosong — Facebook akan post tanpa caption',
    'ws.tiktok.noneSelected': 'Tiada produk dipilih untuk dijalankan.',
    'ws.tiktok.sentLabel': '{n} produk × {sets} set dihantar ✓',
    'ws.tiktok.started': '🎉 TikTok Automation Dimulakan!',
    'ws.tiktok.startedDetail': '{n} produk telah dihantar terus ke Extension.{mod} Extension sedang membuka TikTok Studio...',
    'ws.tiktok.step.prepare': 'Menyediakan produk untuk TikTok...',
    'ws.tiktok.title': 'TikTok Automation — {n} produk',
    'ws.toast.kosongPromptGagal': 'Gagal mengosongkan prompt: {msg}. Tiada apa-apa berubah.',
    'ws.toast.kosongPromptSemakGagal': 'Gagal menyemak kad: {msg}. Tiada apa-apa dikosongkan.',
    'ws.toast.kosongPromptSemuaJana': 'Semua kad yang ditanda sedang dijana — tunggu siap dahulu.',
    'ws.toast.kosongPromptSeparuh': '{ok} daripada {n} kad dikosongkan — selebihnya gagal: {msg}',
    'ws.toast.kosongPromptSiap': 'Prompt dikosongkan pada {n} kad.',
    'ws.toast.kosongPromptSiapSatu': 'Prompt dikosongkan pada 1 kad.',
    'ws.toast.kosongPromptTiada': 'Tiada prompt untuk dikosongkan dalam {set}.',
    'ws.toast.productsDeleted': '{n} produk dipadam · {size} dikosongkan',
    'ws.toast.saveFailedVideoRestored': 'Save gagal — video dipulihkan. {msg}',
    'ws.agent.toast.simpanGagal': 'Hasil agent untuk "{nama}" tidak dapat disimpan. Sila Run semula produk ini. ({msg})',
    'ws.sched.kosong.ok': '{n} status slot dikosongkan.',
    'ws.sched.kosong.okSatu': '1 status slot dikosongkan.',
    'ws.sched.kosong.running': 'Slot yang sedang dihantar tidak dikosongkan — guna Stop untuk menghentikannya.',
    'ws.sched.kosong.tiada': 'Tiada status untuk dikosongkan pada slot yang ditanda.',
    'ws.toast.statusDikosongkan': '{n} status dikosongkan.',
    'ws.toast.statusDikosongkanSatu': '1 status dikosongkan.',
    'ws.toast.statusDitukar': '{n} status ditukar ke {status}.',
    'ws.toast.statusDitukarSatu': '1 status ditukar ke {status}.',
    'ws.toast.statusSudah': 'Status itu memang sudah {status} — tiada apa diubah.',
    'ws.toast.statusBerjalan': 'Set yang sedang dihantar tidak diubah — guna Stop untuk menghentikannya.',
    'ws.toast.statusTiada': 'Tiada status untuk akaun {akaun} pada kad yang ditanda.',
    'ws.toast.statusTiadaVideo': 'Kad yang tiada video untuk set itu dilangkau — status hanya untuk set yang ada video.',
    'ws.toast.statusSlotTiadaVideo': 'Slot yang setnya tiada video dilangkau — status hanya untuk set yang ada video.',
    'ws.toast.statusKadTiada': 'Slot yang kadnya tiada dalam senarai dilangkau.',
    'ws.status.setKosong': 'Tiada video dan tiada status untuk set ini pada kad yang ditanda',
    'ws.status.akaun': 'Akaun: {akaun}',
    'ws.status.tukarKe': 'Tukar {set} ke',
    'ws.status.tukarSlot': 'Tukar {n} slot ke',
    'ws.status.semuaSetFrasa': 'semua set',
    'ws.toast.videoDeleteFailed': 'Gagal padam video: {msg}',
    'ws.toast.videoDeleted': 'Video berjaya dipadam',
    'ws.toast.videoDeletedOrphan': 'Video dipadam dari database, tapi fail di Storage tak dapat dialih keluar — akan dibersihkan automatik kemudian',
    'ws.toast.videoKeptLocal': '💾 {n} video kekal dalam browser ini — simpanan video Cloud tidak tersedia buat masa ini. Video tidak hilang: ia masih boleh di-post ke TikTok dari browser ini.',
    'ws.toast.videoPushFailed': '{n} video tak dapat dimuat naik — buka di browser yang ada Extension SESAAT aktif.',
    'ws.toast.videoQuotaKept': '💾 {n} video kekal dalam browser ini — had cloud harian sudah cukup, simpanan penuh, atau video melebihi 50MB. Ia masih boleh di-post ke TikTok dari browser ini.',
    'ws.toast.videoPushed': '{n} video dimuat naik ke Cloud',
    'ws.toast.videosDeleted': '{n} video dipadam · {size} dikosongkan',
    'ws.toast.videosDeletedOrphan': '{n} video dipadam · sebahagian fail Storage tak dapat dialih keluar — akan dibersihkan automatik kemudian',
    'ws.umum.batal': 'Cancel',
    'ws.umum.ok': 'OK',
    'ws.umum.selesai': 'Done',
    'ws.umum.simpan': 'Save',
    'ws.umum.tutup': 'Tutup',
    'ws.upload.blockedModule': '📥 Untuk produk {label}, upload video perlu dilakukan melalui extension SESAAT.\n\nLangkah:\n1. Buka extension SESAAT\n2. Cari product card yang sama\n3. Klik butang "Mass Video"\n4. Pilih video file (set1/set2/set3) daripada folder Downloads\n\nVideo untuk modul ini tidak boleh disimpan ke Cloud kerana saiznya besar — ia hanya tersimpan dalam storage pada browser ini sahaja.',
    'ws.upload.blockedModuleFallback': 'modul ini',
    'ws.upload.fileTooLarge': 'Fail terlalu besar (maksimum 100MB)',
    'ws.upload.notAuthenticated': 'Pengguna belum log masuk. Sila log masuk semula.',
    'ws.upload.storageFull': '⚠️ Had storage telah dicapai!\n\nDigunakan: {used} MB / {limit} MB\nSaiz fail: {file} MB\n\nSila padam beberapa video lama untuk mengosongkan ruang.',
    'ws.upload.videoFailed': 'Gagal memuat naik video:\n{msg}',
    'ws.upload.videoTooBigCloud': 'Video ini {size}MB — melebihi had 50MB untuk simpanan cloud. Sila muat naik video ini melalui Extension SESAAT: video besar disimpan dalam browser anda dan masih boleh di-post ke TikTok.',
    'ws.upload.cloudUnavailable': 'Storan cloud tidak tersedia sekarang, atau video melebihi had 50MB. Sila muat naik video ini melalui Extension SESAAT.',
    'ws.vergate.body': 'Anda masih menggunakan versi lama extension SESAAT. Sila kemas kini untuk meneruskan penggunaan.',
    'ws.vergate.checking': 'Menyemak…',
    'ws.vergate.close': 'Tutup',
    'ws.vergate.download': 'Muat Turun Versi Terkini',
    'ws.vergate.dupBody': 'Browser ini mempunyai {n} extension SESAAT yang aktif serentak. Versi terkini anda berfungsi seperti biasa, tetapi versi lama masih terpasang dan perlu dibuang.',
    'ws.vergate.dupOk': 'Faham',
    'ws.vergate.dupStep1': 'Taip chrome://extensions pada address bar',
    'ws.vergate.dupStep2': 'Cari semua kad SESAAT. Tekan Remove pada yang bukan versi terkini',
    'ws.vergate.dupStep3': 'Pastikan tinggal satu sahaja, kemudian refresh tab ini',
    'ws.vergate.dupSub': 'Sila buang versi lama daripada browser',
    'ws.vergate.dupTitle': 'Extension Lama Masih Terpasang',
    'ws.vergate.dupWhy1': 'Arahan Run boleh dihantar dua kali — video berganda dan kuota Flow terbakar.',
    'ws.vergate.dupWhy2': 'Extension lama masih cuba menyimpan data anda, tetapi simpanannya ditolak sistem tanpa notis.',
    'ws.vergate.dupWhy3': 'Ia dikira sebagai dua browser daripada had lesen anda.',
    'ws.vergate.dupWhyTitle': 'Kenapa ia perlu dibuang?',
    'ws.vergate.duplicateNotice': 'Kami mengesan lebih daripada satu extension SESAAT dalam browser ini. Versi baharu tidak menggantikan versi lama secara automatik — ia dipasang sebagai extension berasingan. Sila buang yang lama pada langkah 2 di bawah.',
    'ws.vergate.iHaveUpdated': 'Saya Sudah Kemas Kini',
    'ws.vergate.requiredVersion': 'Diperlukan: v{versi}',
    'ws.vergate.step1': 'Muat turun fail ZIP di bawah',
    'ws.vergate.step2': 'Buka chrome://extensions dan tekan Remove pada extension SESAAT yang lama',
    'ws.vergate.step3': 'Pasang extension baharu (panduan penuh di Dashboard, Step 1)',
    'ws.vergate.step4': 'Kembali ke tab ini dan tekan “Saya Sudah Kemas Kini”',
    'ws.vergate.stillOld': 'Sistem masih mengesan versi lama. Punca paling kerap: extension lama belum dibuang daripada chrome://extensions. Sila pastikan tinggal satu extension SESAAT sahaja, kemudian cuba sekali lagi.',
    'ws.vergate.sub': 'Versi terkini diperlukan untuk meneruskan',
    'ws.usgate.title': 'Satu Langkah Lagi',
    'ws.usgate.sub': 'Hidupkan satu suis dalam browser anda',
    'ws.usgate.why': 'Suis ini membenarkan SESAAT menerima kemas kini automation terus daripada kami — jadi anda tidak perlu pasang semula extension setiap kali ada pembaikan. Cukup hidupkan sekali sahaja.',
    'ws.usgate.chrome': 'Google Chrome',
    'ws.usgate.c1': 'Buka chrome://extensions dalam tab baharu',
    'ws.usgate.c2': 'Klik Details pada extension SESAAT',
    'ws.usgate.c3': 'Hidupkan Allow user scripts',
    'ws.usgate.edge': 'Microsoft Edge',
    'ws.usgate.e1': 'Buka edge://extensions dalam tab baharu',
    'ws.usgate.e2': 'Kalau ada Allow user scripts — hidupkan',
    'ws.usgate.e3': 'Kalau tiada — hidupkan Developer mode di bawah sekali',
    'ws.usgate.gagal': 'Masih belum dikesan. Pastikan suis itu betul-betul hidup, kemudian muat semula halaman ini sebelum cuba lagi.',
    'ws.usgate.semak': 'Saya dah hidupkan — semak',
    'ws.usgate.imgcap': `Cari baris ini, hidupkan suis di kanan. Chrome akan papar amaran \"may be unsafe\" — ia normal; suis ini cuma membenarkan SESAAT terima kemas kini daripada kami.`,
    'ws.vergate.title': 'Kemas Kini Extension Diperlukan',
    'ws.vergate.yourVersionOld': 'Versi anda: lama',
    'ws.video.delete': 'Padam',
    'ws.video.deleting': 'Memadam…',
    'ws.video.download': 'Muat Turun',
    'ws.video.extNotResponding': 'Extension tidak menjawab. Pastikan Extension SESAAT aktif.',
    'ws.video.notInLocalCache': 'Video tiada dalam simpanan browser ini',
    'ws.video.uploadVideo': 'Muat Naik Video',
    'ws.videoModal.close': 'Tutup (Esc)',
    'ws.videoModal.escToClose': 'Esc untuk tutup',
    'ws.videoModal.loading': 'Memuat video dari extension...',

    /* ── Halaman produk Marketplace · Boost · Hook Library (2026-09-23) ── */
    'market.detail.loadFailed': 'Gagal muat produk: {ralat}',
    'market.detail.failed': 'Gagal: {ralat}',
    'market.detail.freeClaimed': 'Berjaya! Ebook dibuka. Boleh muat turun semula di Pembelian Saya.',
    'market.detail.notFoundTitle': 'Produk tidak dijumpai',
    'market.detail.notFoundDesc': 'Produk ini mungkin sudah dibuang atau belum diterbitkan.',
    'market.detail.stock': 'Stok: {n}',
    'market.detail.save': 'Jimat {n}%',
    'market.detail.fulfil.manual': 'Penghantaran oleh admin',
    'market.detail.fulfil.autoStock': 'Akses akaun automatik',
    'market.detail.fulfil.autoDownload': 'Muat turun automatik',
    'market.detail.fulfil.manualDesc': 'Selepas pembayaran disahkan, admin akan menyerahkan akses anda secara manual. Semak status di Pembelian Saya.',
    'market.detail.fulfil.autoStockDesc': 'Sebaik pembayaran selesai, butiran log masuk dilepaskan serta-merta di Pembelian Saya. Tiada penantian, tiada perlu menghubungi admin.',
    'market.detail.fulfil.autoStockDaysDesc': 'Sebaik pembayaran selesai, butiran log masuk dilepaskan serta-merta di Pembelian Saya — akses sah selama {n} hari. Tiada penantian, tiada perlu menghubungi admin.',
    'market.detail.fulfil.freeDesc': 'Klik dan terus muat turun — tiada bayaran diperlukan.',
    'market.detail.fulfil.autoDownloadDesc': 'Selepas pembayaran disahkan, anda boleh terus memuat turun fail di Pembelian Saya.',
    'market.detail.soldOutBtn': 'Sudah habis (Sold Out)',
    'market.detail.processing': 'Memproses…',
    'market.detail.getFree': 'Dapatkan Percuma',
    'market.detail.buy': 'Beli — {harga}',
    'market.detail.checkoutTitle': 'Teruskan Pembayaran',
    'market.detail.payNote': 'Anda akan dibawa ke halaman pembayaran Billplz (FPX atau kad). Sebaik bayaran selesai, pesanan anda muncul di Pembelian Saya.',
    'market.detail.payNoteAutoStock': 'Anda akan dibawa ke halaman pembayaran Billplz (FPX atau kad). Sebaik bayaran selesai, akses anda dilepaskan serta-merta di Pembelian Saya.',
    'boost.subtitle': 'Program TikTok dan Shopee daripada rakan MCN dan TAP.',
    'boost.adminBadge': 'Admin sahaja · rupa sahaja',
    'boost.previewBanner': 'Rupa sahaja. Data di bawah adalah contoh yang ditaip dalam kod — belum bersambung ke Google Sheet, dan borang belum menyimpan apa-apa. Pelanggan tidak nampak halaman ini.',
    'boost.previewState': 'Pratonton keadaan',
    'boost.state.locked': 'Tiada pakej',
    'boost.state.form': 'Belum daftar',
    'boost.state.list': 'Sudah daftar',
    'boost.openMenu': 'Buka menu',
    'boost.locked.title': 'Boost untuk pelanggan berbayar',
    'boost.locked.desc': 'Halaman ini terbuka kepada pelanggan Premium, Fighter dan SMART yang langganannya masih aktif.',
    'boost.locked.cta': 'Lihat pakej',
    'boost.form.title': 'Daftar untuk masuk Boost',
    'boost.form.desc': 'Isi sekali sahaja. Nombor WhatsApp anda digunakan untuk memasukkan anda ke dalam group sokongan MCN / TAP.',
    'boost.form.name': 'Nama penuh',
    'boost.form.namePh': 'Nama seperti dalam IC',
    'boost.form.email': 'Email',
    'boost.form.emailPh': '(email akaun anda)',
    'boost.form.emailHint': 'Diambil daripada akaun SESAAT anda.',
    'boost.form.wa': 'Nombor WhatsApp',
    'boost.form.tiktok': 'Username TikTok',
    'boost.form.submit': 'Hantar',
    'boost.form.previewNote': 'Rupa sahaja — borang ini belum menyimpan apa-apa. Butang Hantar cuma membawa anda ke paparan senarai untuk pratonton.',
    'boost.howTitle': 'Cara guna Boost',
    'boost.step1': 'Buka link kempen seller di TELEFON anda.',
    'boost.step2': 'Add produk seller itu ke showcase, dari dalam app TikTok.',
    'boost.step3': 'Scrape showcase guna extension SESAAT — Import Products, pilih Option 2.',
    'boost.sellerCount': '{n} seller',
    'boost.viewSellers': 'Lihat seller',
    'boost.joinGroup': 'Join group',
    'boost.allMcn': 'Semua MCN / TAP',
    'boost.searchPh': 'Cari nama seller',
    'boost.allCategories': 'Semua kategori',
    'boost.bonusOnly': 'Bonus sahaja',
    'boost.emptyTitle': 'Tiada seller sepadan',
    'boost.emptyDesc': 'Cuba kosongkan carian atau penapis kategori.',
    'boost.col.seller': 'Seller',
    'boost.col.category': 'Kategori',
    'boost.col.bonus': 'Bonus',
    'boost.col.gmv': 'Syarat GMV',
    'boost.col.postRate': 'Post rate',
    'boost.col.note': 'Nota',
    'boost.col.link': 'Link kempen',
    'boost.yes': 'Ya',
    'boost.open': 'Buka',
    'boost.copy': 'Salin',
    'boost.copied': 'Disalin',
    'boost.footHint': 'Buka link di telefon, add produk ke showcase dari app TikTok, kemudian scrape showcase di extension (Import Products → Option 2).',
    'boost.adminNotOpen': 'Admin sahaja — pelanggan belum nampak Boost',
    'boost.loading': 'Memuatkan Boost…',
    'boost.retry': 'Cuba lagi',
    'boost.profile.title': 'Profil Boost anda',
    'boost.profile.desc': 'Diisi sekali sahaja. Butiran ini hanya dikongsi dengan MCN yang anda mohon.',
    'boost.profile.empty': 'Profil belum diisi. Anda akan diminta mengisinya semasa memohon.',
    'boost.profile.edit': 'Kemas kini profil',
    'boost.profile.save': 'Simpan profil',
    'boost.profile.saved': 'Profil disimpan',
    'boost.profile.note': 'Perubahan hanya terpakai pada permohonan baharu.',
    'boost.form.tiktok2': 'Username TikTok kedua',
    'boost.form.shopee': 'Username Shopee',
    'boost.form.optional': 'pilihan',
    'boost.form.required': 'wajib untuk program ini',
    'boost.form.waHint': 'Digunakan oleh MCN untuk memasukkan anda ke dalam group WhatsApp mereka.',
    'boost.cancel': 'Batal',
    'boost.apply': 'Mohon',
    'boost.apply.title': 'Mohon · {mcn} {program}',
    'boost.apply.desc': 'Semak butiran anda. Butiran ini dihantar kepada {mcn} untuk program ini.',
    'boost.apply.consent': 'Saya bersetuju nama, email, nombor WhatsApp dan username saya dikongsi dengan {mcn} untuk program ini.',
    'boost.apply.submit': 'Hantar permohonan',
    'boost.apply.sending': 'Menghantar…',
    'boost.apply.bindNote': 'Satu akaun {platform} hanya boleh bind dengan satu MCN.',
    'boost.tag.many': 'Boleh sertai banyak',
    'boost.tag.one': '1 MCN sahaja',
    'boost.status.approved': 'Diluluskan',
    'boost.status.pending': 'Menunggu',
    'boost.status.declined': 'Ditolak',
    'boost.soon': 'Akan datang',
    'boost.boundTo': 'Sudah bind dengan {mcn}',
    'boost.openProgram': 'Buka',
    'boost.back': 'Semua program',
    'boost.catalog.title': 'Senarai seller sedang disediakan',
    'boost.catalog.desc': '{mcn} sedang menyediakan senarai seller dan produk. Ia akan dipaparkan di sini secara automatik.',
    'boost.noPrograms': 'Belum ada program dibuka',
    'boost.noProgramsDesc': 'Program MCN baharu akan dipaparkan di sini.',
    'boost.err.load': 'Boost tidak dapat dimuatkan',
    'boost.err.server': 'Ralat pada server. Sila cuba lagi.',
    'boost.err.tak-layak': 'Boost hanya untuk pakej Premium, Fighter dan SMART yang masih aktif.',
    'boost.err.program-tutup': 'Program ini tidak lagi menerima permohonan.',
    'boost.err.perlu-setuju': 'Sila tandakan kotak persetujuan untuk berkongsi butiran anda dengan MCN ini.',
    'boost.err.profil-tak-lengkap': 'Sila lengkapkan nama dan nombor WhatsApp anda.',
    'boost.err.nama-salah': 'Sila masukkan nama penuh anda (2–80 aksara).',
    'boost.err.wa-salah': 'Sila masukkan nombor WhatsApp yang sah (9–15 digit).',
    'boost.err.tiktok-salah': 'Sila masukkan username TikTok yang sah (huruf, nombor, _ dan . sahaja).',
    'boost.err.tiktok2-salah': 'Username TikTok kedua tidak sah (huruf, nombor, _ dan . sahaja).',
    'boost.err.shopee-salah': 'Sila masukkan username Shopee yang sah (huruf, nombor, _ . dan - sahaja).',
    'boost.err.bind-lain': 'Akaun anda sudah bind dengan MCN lain untuk platform ini. Satu akaun hanya boleh bind dengan satu MCN.',
    'boost.err.ditolak': '{mcn} telah menolak permohonan ini. Sila hubungi mereka jika anda rasa ini satu kesilapan.',
    'boost.err.tiada-emel': 'Akaun anda tiada email. Sila log masuk dengan akaun yang mempunyai email.',
    'boost.err.boost-tutup': 'Boost belum dibuka.',
    'hooks.subtitle': '800+ ayat pembuka TikTok Shop dalam Bahasa Melayu — untuk affiliate Malaysia.',
    'hooks.mode.app': 'Selepas log masuk',
    'hooks.mode.public': 'Pelawat belum daftar',
    'hooks.proto.title': 'Prototaip · admin sahaja.',
    'hooks.proto.desc': 'Setiap butang di halaman ini tiada fungsi. Suis di atas menukar antara rupa pelanggan yang sudah log masuk dan rupa pelawat yang baru datang dari TikTok.',
    'hooks.searchPh': 'Cari hook — contoh: “kurus”, “promo”, “review”…',
    'hooks.freeAccount': 'Akaun percuma',
    'hooks.meter.free': 'Salinan percuma hari ini',
    'hooks.meter.size': '{hook} hook · {niche} niche · {kategori} kategori',
    'hooks.filter.niche': 'Niche',
    'hooks.filter.category': 'Kategori',
    'hooks.niche.all': 'Semua',
    'hooks.niche.general': 'Umum',
    'hooks.niche.beauty': 'Kecantikan',
    'hooks.niche.fashion': 'Fashion',
    'hooks.niche.parenting': 'Parenting',
    'hooks.niche.food': 'F&B & Dapur',
    'hooks.niche.gadget': 'Gadget',
    'hooks.niche.health': 'Kesihatan',
    'hooks.niche.home': 'Home & Living',
    'hooks.cat.all': 'Semua kategori',
    'hooks.cat.urgency': 'Urgency',
    'hooks.cat.sales': 'Jualan & Promosi',
    'hooks.cat.review': 'Review & Bukti',
    'hooks.cat.curiosity': 'Rasa Ingin Tahu',
    'hooks.cat.warning': 'Amaran',
    'hooks.cat.pov': 'POV',
    'hooks.cat.story': 'Storytelling',
    'hooks.cat.trending': 'Trending',
    'hooks.cat.solution': 'Penyelesaian',
    'hooks.personal.title': 'Taip nama produk anda — setiap hook terus disesuaikan',
    'hooks.personal.desc': 'Contoh: “benda ni” bertukar menjadi “serum XYZ” pada semua hook, secara automatik.',
    'hooks.personal.locked': 'Dibuka dengan akaun percuma',
    'hooks.personal.cta': 'Sesuaikan',
    'hooks.card.save': 'Simpan hook',
    'hooks.card.copy': 'Salin',
    'hooks.card.copied': 'Disalin',
    'hooks.card.toVideo': 'Jadikan video',
    'hooks.wall.title': '700+ hook lagi menunggu anda',
    'hooks.wall.desc': 'Daftar akaun percuma untuk membuka semua hook, menyimpan koleksi anda sendiri dan menapis mengikut niche anda.',
    'hooks.wall.cta': 'Daftar percuma sekarang',
    'hooks.loadMore': 'Muat {n} lagi',
    'hooks.remaining': '· {n} tinggal',
    'hooks.more.title': 'Hook ini tidak berhenti di sini',
    'hooks.more.desc': 'Di tempat lain, selepas salin anda masih perlu shooting dan edit sendiri. Di SESAAT, hook yang sama boleh terus menjadi video TikTok yang siap dimuat naik.',
    'hooks.more.ctaPublic': 'Cuba dengan akaun percuma',
    'hooks.more.ctaApp': 'Buka Workspace',
    'hooks.step1.title': 'Pilih hook & produk',
    'hooks.step1.desc': 'Salin mana-mana hook, pilih produk TikTok Shop yang anda nak promosikan.',
    'hooks.step2.title': 'SESAAT jana video',
    'hooks.step2.desc': 'AI siapkan video promosi — tanpa shooting, tanpa menunjukkan wajah.',
    'hooks.step3.title': 'Naik ke TikTok automatik',
    'hooks.step3.desc': 'Video dimuat naik ke akaun TikTok anda mengikut jadual anda.',
    'hooks.agent.pill': 'Untuk ejen SESAAT',
    'hooks.agent.title': 'Kongsi halaman percuma ini. Komisen tetap milik anda.',
    'hooks.agent.perk1': 'Anda kongsi benda percuma yang memang dicari orang — bukan menjual software secara terus.',
    'hooks.agent.perk2': 'Link anda kekal menjejak: pelawat yang daftar hari ini dan melanggan bulan depan tetap dikira milik anda.',
    'hooks.agent.perk3': 'Pack slideshow siap disediakan setiap bulan — tinggal muat naik ke TikTok anda.',
    'hooks.agent.linkLabel': 'Link rujukan anda',
    'hooks.agent.copyLink': 'Salin link saya',
    'hooks.agent.packNote': 'Pack slideshow bulanan untuk dimuat naik ke TikTok anda akan muncul di sini — tinggal muat turun dan post.',
    'maintenance.defaultTitle': 'Sistem sedang diselenggara',
    'maintenance.defaultBody': 'SESAAT tidak dapat digunakan buat sementara waktu kerana kami sedang membaiki satu masalah. Sila cuba semula sebentar lagi.',
    'maintenance.autoNote': 'Halaman ini akan dibuka semula secara automatik sebaik sahaja sistem kembali normal.',
    // ★ HOSTED FLOW BETA — pemilih mode + status job customer + dashboard admin (central worker PC ofis)
    'hosted.status.dalam_barisan': 'Dalam barisan',
    'hosted.status.sedang_dijana': 'Sedang dijana',
    'hosted.status.menyimpan': 'Menyimpan',
    'hosted.status.siap': 'Siap',
    'hosted.status.perlu_semakan': 'Perlu semakan',
    'hosted.status.dibatalkan': 'Dibatalkan',
    'hosted.mode.title': 'Cara jalankan',
    'hosted.mode.hosted': 'Hosted Flow Beta',
    'hosted.mode.hostedSub': 'PC ofis SESAAT jana di belakang. Boleh tutup browser.',
    'hosted.mode.biasa': 'Run Flow Biasa',
    'hosted.mode.biasaSub': 'Guna extension Chrome anda sendiri.',
    'hosted.submit': 'Submit',
    'hosted.batal': 'Batal',
    'hosted.batalTanya': 'Batal job ini? Ia belum dihantar ke Google.',
    'hosted.quota': '{remaining}/{cap} video · {cardsRemaining}/{cardCap} card lagi hari ni',
    'hosted.closeNote': 'Boleh tutup browser — PC ofis siapkan di belakang.',
    'hosted.jobsAktif': 'Status Hosted',
    'hosted.tiadaJob': 'Belum ada job dihantar.',
    'hosted.perluSemakanNota': 'Admin sedang semak — anda tak perlu buat apa-apa.',
    'hosted.run.sending': 'Menghantar ke PC ofis SESAAT...',
    'hosted.run.title': 'Hosted Flow Beta — {n} job',
    'hosted.run.detail': '{n} card × {sets} set → PC ofis. Anda boleh tutup browser; video masuk card bila siap.',
    'hosted.run.progress': '{siap}/{jumlah} dihantar...',
    'hosted.run.offlineTitle': 'PC ofis SESAAT tidak dapat dihubungi',
    'hosted.run.offlineDetail': 'Job TIDAK dihantar. Cuba sebentar lagi atau hubungi admin SESAAT.',
    'hosted.run.sent': '{n} job diterima queue ✓',
    'hosted.run.partial': '⚠ Sebahagian job gagal',
    'hosted.run.okTitle': '🚀 Job masuk queue PC ofis!',
    'hosted.run.okDetail': '{n} job baharu dihantar.',
    'hosted.run.dupDetail': ' {n} sudah dalam barisan (tiada duplicate).',
    'hosted.run.failDetail': ' {n} gagal: {sebab}',
    'hosted.run.seeStatus': ' Lihat status di Control Panel.',
    'hosted.run.failed': '❌ Submit Hosted gagal',
    'hosted.run.kadOnly': "Hosted Flow Beta guna 'Guna gambar card' sahaja. Tukar Workflow ke 'Guna gambar card' di Control Panel dulu, kemudian Submit semula.",
    // Loceng notifikasi batch (HostedNotifBell.jsx)
    'hosted.notif.title': 'Notifikasi',
    'hosted.notif.kosong': 'Tiada notifikasi lagi.',
    'hosted.notif.batchTajuk': 'Hosted Flow — batch video',
    'hosted.notif.videoSiap': 'video siap',
    'hosted.notif.perluSemak': 'perlu semakan',
    'hosted.notif.gagal': 'gagal',
};
